// Translations for 5 P0 competitor-beating features
// (Live Activity Feed, FAQ, Sleep AI, SEO Course, AI Strategy Generator)
// EN is the source for auto-translation; SK is hardcoded as primary market.
export const p0FeaturesTranslations = {
  en: {
    // LiveActivityFeed
    laf_live: "LIVE",
    laf_online: "online",
    laf_from: "from",
    laf_verified: "Verified",
    laf_just_now: "just now",
    laf_seconds_ago: "{n}s ago",
    laf_minutes_ago: "{n}m ago",
    laf_hours_ago: "{n}h ago",

    // FAQSection
    faqs_tag: "FAQ",
    faqs_title: "Frequently asked questions",
    faqs_subtitle: "Everything you need to know before your first scan",
    faqs_contact: "Need more? Email us at",
    faqs_q1: "How are you different from SEMrush and Ahrefs?",
    faqs_a1: "SEMrush costs from €119/month and only tracks Google. For €49/month we cover Google + ChatGPT + Perplexity + Claude + Gemini — where people actually search in 2026. Plus PulseAI Engine™ writes concrete step-by-step recommendations for you.",
    faqs_q2: "Is the first scan really free?",
    faqs_a2: "Yes, no credit card required. You get a complete SEO + GEO report for 1 domain + 3 AI recommendations. Just paste your URL and run a scan.",
    faqs_q3: "Do I need to know SEO technically?",
    faqs_a3: "No. PulseAI Engine™ writes an exact step-by-step action plan ('change title to X', 'add keyword Y'). Just copy-paste. Zero programming.",
    faqs_q4: "How long until I see results?",
    faqs_a4: "First ranking improvements within 7–14 days. AI visibility (ChatGPT / Perplexity mentions) within 3–5 days. Most customers see +40% traffic within 30 days.",
    faqs_q5: "Does it work for local / EU markets?",
    faqs_a5: "Yes, full support for 26 languages including SK, CZ, PL, HU, DE. Our LLM generates recommendations directly in your language and accounts for local SEO specifics.",
    faqs_q6: "Can I cancel anytime?",
    faqs_a6: "Yes, one click in your dashboard. No cancellation fees. 30-day money-back guarantee if you're not satisfied.",
    faqs_q7: "Do you have WordPress / Shopify integration?",
    faqs_a7: "WordPress plugin (free download) automatically applies schema markup and meta tags. Shopify app is coming Q2 2026.",
    faqs_q8: "What if a competitor scans my domain?",
    faqs_a8: "Scanning is public (anyone can scan any URL). Your data, keywords, and strategies are private and encrypted — only you have access via your account.",
    faqs_q9: "What's your guarantee?",
    faqs_a9: "30-day money-back guarantee, no questions asked. Not happy — full refund.",
    faqs_q10: "Do you have an API?",
    faqs_a10: "Yes, the Enterprise plan includes REST API + webhooks for integration with your internal tools, CRM, or BI dashboards.",

    // SleepAISection
    sleep_tag: "Automation 24/7",
    sleep_title_a: "While you sleep,",
    sleep_title_b: "PulseAI works",
    sleep_subtitle: "Every night at 3:00 AM your AI assistant automatically runs 6 critical tasks. You open your email in the morning — 17 new improvements waiting for 1-click approval.",
    sleep_highlight: "17 new improvements waiting for 1-click approval.",
    sleep_check_1: "Scans 100% of your pages",
    sleep_check_2: "Checks 47 AI platforms (ChatGPT, Perplexity, Claude…)",
    sleep_check_3: "Generates 5 new optimization recommendations",
    sleep_check_4: "Sends an alert if a competitor overtakes your position",
    sleep_check_5: "Drafts a blog article for tomorrow",
    sleep_check_6: "Adjusts meta tags where CTR dropped",
    sleep_cta: "Let AI work for you →",
    sleep_overnight: "Overnight improvements:",
    sleep_pending: "waiting for approval",

    // SEOCourseSection
    course_tag: "Free · No credit card",
    course_title_a: "7 days to",
    course_title_b: "#1 position",
    course_subtitle: "Free email course: 7 practical lessons, 7 concrete tasks, 1 BONUS discount code at the end.",
    course_feature_1: "7 emails × 5 min reading",
    course_feature_2: "Copy-paste actionable tasks",
    course_feature_bonus: "BONUS:",
    course_feature_3: "20% discount code on completion",
    course_email_placeholder: "your@email.com",
    course_submit: "Send →",
    course_privacy: "🔒 No spam · Unsubscribe 1 click · GDPR-friendly",
    course_success: "✅ Done! Check your email.",
    course_code_label: "Your BONUS code:",
    course_program: "7-day program",
    course_d1_t: "Audit in 5 minutes",
    course_d1_s: "Where you really stand",
    course_d2_t: "Keywords that change everything",
    course_d2_s: "Long-tail vs. short-tail",
    course_d3_t: "On-page SEO without a developer",
    course_d3_s: "Title, meta, H1, schema",
    course_d4_t: "How to get into ChatGPT answers",
    course_d4_s: "GEO strategy step-by-step",
    course_d5_t: "Backlink strategy without spam",
    course_d5_s: "14 white-hat techniques",
    course_d6_t: "Technical SEO checklist",
    course_d6_s: "Speed, schema, mobile",
    course_d7_t: "Your 90-day plan",
    course_d7_s: "+ BONUS: 20% discount code",
    course_err_invalid: "Please enter a valid email",

    // AIStrategyPage
    strat_nav_title: "AI Strategy Generator",
    strat_badge: "PRO / Free first strategy",
    strat_title_a: "How to",
    strat_title_b: "outrank your competitor",
    strat_title_c: "in 30 days",
    strat_subtitle: "PulseAI Engine™ generates a concrete 4-week action plan tailored to your domain vs. a specific competitor.",
    strat_label_my: "Your domain",
    strat_label_competitor: "Competitor",
    strat_label_keywords: "Target keywords (optional)",
    strat_placeholder_my: "yourdomain.com",
    strat_placeholder_competitor: "competitor.com",
    strat_placeholder_keywords: "running shoes, nike shoes, adidas...",
    strat_kw_hint: "Comma-separated. Max 6 keywords.",
    strat_submit: "Generate 30-day strategy",
    strat_loading: "AI analyzing... (~15–30s)",
    strat_err_both: "Enter both domains",
    strat_err_generic: "Generation failed",
    strat_gap_title: "📊 Current Gap Analysis",
    strat_share: "Share",
    strat_copied: "Copied!",
    strat_gap_score: "SEO Score",
    strat_gap_keywords: "Keywords in TOP 100",
    strat_gap_ai_vis: "AI Visibility %",
    strat_you: "You",
    strat_competitor: "Competitor",
    strat_advantages_title: "🔥 Your unfair advantages",
    strat_week_label: "Week",
    strat_forecast_title: "🎯 Forecasted result (30 days)",
    strat_forecast_traffic: "Organic traffic",
    strat_forecast_position: "Target position",
    strat_forecast_ai_vis: "AI Visibility",
    strat_upgrade: "Upgrade to PRO",
  },
  sk: {
    laf_live: "LIVE",
    laf_online: "online",
    laf_from: "z",
    laf_verified: "Overené",
    laf_just_now: "teraz",
    laf_seconds_ago: "pred {n} s",
    laf_minutes_ago: "pred {n} min",
    laf_hours_ago: "pred {n} h",

    faqs_tag: "FAQ",
    faqs_title: "Časté otázky",
    faqs_subtitle: "Všetko, čo potrebuješ vedieť pred prvým scanom",
    faqs_contact: "Ešte niečo? Napíš nám na",
    faqs_q1: "Čím sa líšite od SEMrush a Ahrefs?",
    faqs_a1: "SEMrush stojí od €119/mesiac a sleduje iba Google. My za €49/mesiac pokrývame Google + ChatGPT + Perplexity + Claude + Gemini (kde ľudia skutočne hľadajú v roku 2026). Navyše — PulseAI Engine™ ti píše konkrétne odporúčania krok-po-kroku.",
    faqs_q2: "Naozaj je prvý scan zadarmo?",
    faqs_a2: "Áno, bez kreditky. Dostaneš kompletný SEO + GEO report na 1 doménu + 3 AI odporúčania. Stačí vložiť URL a spustiť scan.",
    faqs_q3: "Musím vedieť technicky SEO?",
    faqs_a3: "Nie. PulseAI Engine™ ti napíše presný action plan krok-po-kroku ('zmeň title na X', 'pridaj keyword Y'). Stačí copy-paste. 0 programovania.",
    faqs_q4: "Koľko trvá, kým uvidím výsledky?",
    faqs_a4: "Prvé pozičné zlepšenia do 7–14 dní. AI visibility (ChatGPT / Perplexity mentions) do 3–5 dní. Väčšina zákazníkov vidí +40% traffic do 30 dní.",
    faqs_q5: "Funguje to pre slovenský / český trh?",
    faqs_a5: "Áno, plná podpora 26 jazykov vrátane SK, CZ, PL, HU, DE. LLM generuje odporúčania priamo v tvojom jazyku a berie do úvahy lokálne SEO špecifiká.",
    faqs_q6: "Môžem zrušiť kedykoľvek?",
    faqs_a6: "Áno, jedným klikom v dashboarde. Žiadne poplatky za zrušenie. 30-dňová money-back garancia pri nespokojnosti.",
    faqs_q7: "Máte WordPress / Shopify integráciu?",
    faqs_a7: "WordPress plugin (stiahnuteľný zdarma) automaticky aplikuje schema markup a meta tagy. Shopify app je v príprave (Q2 2026).",
    faqs_q8: "Čo ak konkurent skenuje moju doménu?",
    faqs_a8: "Scan je verejný (každý môže skenovať ľubovoľnú URL). Tvoje dáta, keywords a stratégie sú privátne a zašifrované — iba ty máš prístup cez svoj účet.",
    faqs_q9: "Aká je vaša garancia?",
    faqs_a9: "30-dňová money-back garancia bez otázok. Ak nie si spokojný — plná refundácia.",
    faqs_q10: "Máte API?",
    faqs_a10: "Áno, Enterprise plán zahŕňa REST API + webhooks pre integráciu s tvojimi internými toolmi, CRM alebo BI dashboardmi.",

    sleep_tag: "Automation 24/7",
    sleep_title_a: "Kým ty spíš,",
    sleep_title_b: "PulseAI pracuje",
    sleep_subtitle: "Každú noc o 3:00 ráno tvoj AI asistent automaticky spustí 6 kritických úloh. Ráno otvoríš email — 17 nových zlepšení čaká na 1-klik schválenie.",
    sleep_highlight: "17 nových zlepšení čaká na 1-klik schválenie.",
    sleep_check_1: "Naskenuje 100% tvojich stránok",
    sleep_check_2: "Skontroluje 47 AI platforiem (ChatGPT, Perplexity, Claude…)",
    sleep_check_3: "Vygeneruje 5 nových optimalizačných odporúčaní",
    sleep_check_4: "Pošle alert, ak konkurent preskočil tvoju pozíciu",
    sleep_check_5: "Napíše draft blog článku na zajtrajšok",
    sleep_check_6: "Upraví meta tagy, kde klesla CTR",
    sleep_cta: "Nechaj AI pracovať za teba →",
    sleep_overnight: "Overnight improvements:",
    sleep_pending: "čaká na schválenie",

    course_tag: "Zadarmo · Bez kreditky",
    course_title_a: "7 dní k",
    course_title_b: "#1 pozícii",
    course_subtitle: "Bezplatný email kurz: 7 praktických lekcií, 7 konkrétnych úloh, 1 BONUS zľavový kód na záver.",
    course_feature_1: "7 emailov × 5 min čítania",
    course_feature_2: "Copy-paste akčné úlohy",
    course_feature_bonus: "BONUS:",
    course_feature_3: "20% zľavový kód pri dokončení",
    course_email_placeholder: "tvoj@email.sk",
    course_submit: "Poslať →",
    course_privacy: "🔒 Žiadny spam · Unsubscribe 1 klik · GDPR-friendly",
    course_success: "✅ Hotovo! Skontroluj email.",
    course_code_label: "Tvoj BONUS kód:",
    course_program: "7-dňový program",
    course_d1_t: "Audit za 5 minút",
    course_d1_s: "Kde reálne stojíš",
    course_d2_t: "Keywords, ktoré menia všetko",
    course_d2_s: "Long-tail vs. short-tail",
    course_d3_t: "On-page SEO bez programátora",
    course_d3_s: "Title, meta, H1, schema",
    course_d4_t: "Ako sa dostať do ChatGPT odpovedí",
    course_d4_s: "GEO stratégia krok-po-kroku",
    course_d5_t: "Backlink stratégia bez spamu",
    course_d5_s: "14 white-hat techník",
    course_d6_t: "Technical SEO checklist",
    course_d6_s: "Speed, schema, mobile",
    course_d7_t: "Tvoj 90-dňový plán",
    course_d7_s: "+ BONUS: 20% zľavový kód",
    course_err_invalid: "Zadaj platný email",

    strat_nav_title: "AI Strategy Generator",
    strat_badge: "PRO / Zadarmo prvá stratégia",
    strat_title_a: "Ako",
    strat_title_b: "prekonať konkurenta",
    strat_title_c: "za 30 dní",
    strat_subtitle: "PulseAI Engine™ vygeneruje konkrétny 4-týždňový akčný plán ušitý pre tvoju doménu vs. konkrétneho konkurenta.",
    strat_label_my: "Tvoja doména",
    strat_label_competitor: "Konkurent",
    strat_label_keywords: "Cieľové kľúčové slová (voliteľné)",
    strat_placeholder_my: "tvojadomena.sk",
    strat_placeholder_competitor: "konkurent.sk",
    strat_placeholder_keywords: "bežecká obuv, running shoes, adidas...",
    strat_kw_hint: "Oddelené čiarkou. Max 6 kľúčových slov.",
    strat_submit: "Vygenerovať 30-dňovú stratégiu",
    strat_loading: "AI analyzuje... (~15–30s)",
    strat_err_both: "Zadaj obe domény",
    strat_err_generic: "Generovanie zlyhalo",
    strat_gap_title: "📊 Current Gap Analysis",
    strat_share: "Zdieľať",
    strat_copied: "Skopírované!",
    strat_gap_score: "SEO Score",
    strat_gap_keywords: "Keywords v TOP 100",
    strat_gap_ai_vis: "AI Visibility %",
    strat_you: "Ty",
    strat_competitor: "Konkurent",
    strat_advantages_title: "🔥 Tvoje neférové výhody",
    strat_week_label: "Týždeň",
    strat_forecast_title: "🎯 Predpovedaný výsledok (30 dní)",
    strat_forecast_traffic: "Organic traffic",
    strat_forecast_position: "Target pozícia",
    strat_forecast_ai_vis: "AI Visibility",
    strat_upgrade: "Upgrade na PRO",
  },
  cs: {
    laf_live: "ŽIVĚ",
    laf_online: "online",
    laf_from: "od",
    laf_verified: "Ověřeno",
    laf_just_now: "právě teď",
    laf_seconds_ago: "před {n}s",
    laf_minutes_ago: "před {n}m",
    laf_hours_ago: "před {n}h",
    faqs_tag: "ČASTO KLADENÉ OTÁZKY",
    faqs_title: "Často kladené otázky",
    faqs_subtitle: "Vše, co potřebujete vědět před svým prvním skenováním",
    faqs_contact: "Potřebujete více informací? Napište nám na",
    faqs_q1: "Jak se lišíte od SEMrush a Ahrefs?",
    faqs_a1: "SEMrush stojí od 119 €/měsíc a sleduje pouze Google. Za 49 €/měsíc pokryjeme Google + ChatGPT + Perplexity + Claude + Gemini — kde lidé skutečně hledají v roce 2026. Plus PulseAI Engine™ píše konkrétní krok za krokem doporučení pro vás.",
    faqs_q2: "Je první skenování opravdu zdarma?",
    faqs_a2: "Ano, není potřeba kreditní karta. Získáte úplnou SEO + GEO zprávu pro 1 doménu + 3 AI doporučení. Stačí vložit svou URL a spustit skenování.",
    faqs_q3: "Musím znát SEO technicky?",
    faqs_a3: "Ne. PulseAI Engine™ napsal přesný plán akce krok za krokem ('změňte název na X', 'přidejte klíčové slovo Y'). Stačí kopírovat a vložit. Zero programování.",
    faqs_q4: "Jak dlouho trvá, než uvidím výsledky?",
    faqs_a4: "První zlepšení umístění během 7–14 dní. Viditelnost AI (zmínky ChatGPT / Perplexity) během 3–5 dní. Většina zákazníků vidí +40% provoz během 30 dní.",
    faqs_q5: "Funguje to pro místní / EU trhy?",
    faqs_a5: "Ano, plná podpora pro 26 jazyků včetně SK, CZ, PL, HU, DE. Naše LLM generuje doporučení přímo ve vašem jazyce a zohledňuje místní SEO specifika.",
    faqs_q6: "Mohu kdykoli zrušit?",
    faqs_a6: "Ano, jedním kliknutím na vašem panelu. Žádné poplatky za zrušení. 30denní záruka vrácení peněz, pokud nejste spokojeni.",
    faqs_q7: "Máte integraci s WordPress / Shopify?",
    faqs_a7: "WordPress plugin (zdarma ke stažení) automaticky aplikuje schema markup a meta tagy. Aplikace pro Shopify přichází ve 2. čtvrtletí 2026.",
    faqs_q8: "Co když konkurent proskenuje mou doménu?",
    faqs_a8: "Skener je veřejný (kdokoliv může skenovat jakoukoli URL). Vaše data, klíčová slova a strategie jsou soukromé a šifrované — pouze vy máte přístup přes svůj účet.",
    faqs_q9: "Jaká je vaše záruka?",
    faqs_a9: "30denní záruka vrácení peněz, bez otázek. Nejste spokojeni — plná náhrada.",
    faqs_q10: "Máte API?",
    faqs_a10: "Ano, podnikový plán zahrnuje REST API + webhooks pro integraci s vašimi interními nástroji, CRM nebo BI panely.",
    sleep_tag: "Automatizace 24/7",
    sleep_title_a: "Zatímco spíte,",
    sleep_title_b: "PulseAI pracuje",
    sleep_subtitle: "Každou noc ve 3:00 ráno váš AI asistent automaticky spouští 6 kritických úkolů. Ráno otevřete e-mail — 17 nových vylepšení čeká na schválení jedním kliknutím.",
    sleep_highlight: "17 nových vylepšení čeká na schválení jedním kliknutím.",
    sleep_check_1: "Skenuje 100 % vašich stránek",
    sleep_check_2: "Kontroluje 47 AI platforem (ChatGPT, Perplexity, Claude…)",
    sleep_check_3: "Generuje 5 nových doporučení pro optimalizaci",
    sleep_check_4: "Odesílá upozornění, pokud vás konkurent předežene",
    sleep_check_5: "Návrh blogového článku na zítřek",
    sleep_check_6: "Upravuje meta tagy, kde klesl CTR",
    sleep_cta: "Nechte AI pracovat za vás →",
    sleep_overnight: "Noční zlepšení:",
    sleep_pending: "čeká na schválení",
    course_tag: "Zdarma · Bez kreditní karty",
    course_title_a: "7 dní k",
    course_title_b: "#1 pozici",
    course_subtitle: "Zdarma e-mailový kurz: 7 praktických lekcí, 7 konkrétních úkolů, 1 BONUSový slevový kód na konci.",
    course_feature_1: "7 e-mailů × 5 min čtení",
    course_feature_2: "Úkoly připravené k použití",
    course_feature_bonus: "BONUS:",
    course_feature_3: "20% slevový kód po dokončení",
    course_email_placeholder: "váš@email.com",
    course_submit: "Odeslat →",
    course_privacy: "🔒 Žádný spam · Odhlásit se 1 kliknutím · GDPR-friendly",
    course_success: "✅ Hotovo! Zkontrolujte svůj e-mail.",
    course_code_label: "Váš BONUSový kód:",
    course_program: "7denní program",
    course_d1_t: "Audit za 5 minut",
    course_d1_s: "Kde opravdu stojíte",
    course_d2_t: "Klíčová slova, která změní všechno",
    course_d2_s: "Long-tail vs. short-tail",
    course_d3_t: "On-page SEO bez vývojáře",
    course_d3_s: "Titul, meta, H1, schéma",
    course_d4_t: "Jak se dostat do odpovědí ChatGPT",
    course_d4_s: "GEO strategie krok za krokem",
    course_d5_t: "Strategie zpětných odkazů bez spamu",
    course_d5_s: "14 technik white-hat",
    course_d6_t: "Kontrolní seznam technického SEO",
    course_d6_s: "Rychlost, schéma, mobil",
    course_d7_t: "Váš plán na 90 dní",
    course_d7_s: "+ BONUS: 20% slevový kód",
    course_err_invalid: "Zadejte platný e-mail",
    strat_nav_title: "Generátor AI strategie",
    strat_badge: "PRO / Zdarma první strategie",
    strat_title_a: "Jak",
    strat_title_b: "předejít konkurenta",
    strat_title_c: "za 30 dní",
    strat_subtitle: "PulseAI Engine™ generuje konkrétní akční plán na 4 týdny přizpůsobený vašemu doméně a konkrétnímu konkurentovi.",
    strat_label_my: "Vaše doména",
    strat_label_competitor: "Konkurent",
    strat_label_keywords: "Cílová klíčová slova (volitelné)",
    strat_placeholder_my: "vasedomena.com",
    strat_placeholder_competitor: "konkurent.com",
    strat_placeholder_keywords: "běžecké boty, nike boty, adidas...",
    strat_kw_hint: "Oddělená čárkami. Max 6 klíčových slov.",
    strat_submit: "Vygenerovat 30denní strategii",
    strat_loading: "AI analyzuje... (~15–30s)",
    strat_err_both: "Zadejte obě domény",
    strat_err_generic: "Generování selhalo",
    strat_gap_title: "📊 Aktuální analýza mezer",
    strat_share: "Sdílet",
    strat_copied: "Zkopírováno!",
    strat_gap_score: "SEO skóre",
    strat_gap_keywords: "Klíčová slova v TOP 100",
    strat_gap_ai_vis: "AI viditelnost %",
    strat_you: "Vy",
    strat_competitor: "Konkurent",
    strat_advantages_title: "🔥 Vaše nespravedlivé výhody",
    strat_week_label: "Týden",
    strat_forecast_title: "🎯 Očekávaný výsledek (30 dní)",
    strat_forecast_traffic: "Organická návštěvnost",
    strat_forecast_position: "Cílová pozice",
    strat_forecast_ai_vis: "AI viditelnost",
    strat_upgrade: "Upgrade na PRO",
  },
  de: {
    laf_live: "LIVE",
    laf_online: "online",
    laf_from: "von",
    laf_verified: "Verifiziert",
    laf_just_now: "gerade eben",
    laf_seconds_ago: "vor {n}s",
    laf_minutes_ago: "vor {n}m",
    laf_hours_ago: "vor {n}h",
    faqs_tag: "FAQ",
    faqs_title: "Häufig gestellte Fragen",
    faqs_subtitle: "Alles, was Sie vor Ihrem ersten Scan wissen müssen",
    faqs_contact: "Brauchen Sie mehr? Schreiben Sie uns an",
    faqs_q1: "Wie unterscheiden Sie sich von SEMrush und Ahrefs?",
    faqs_a1: "SEMrush kostet ab €119/Monat und verfolgt nur Google. Für €49/Monat decken wir Google + ChatGPT + Perplexity + Claude + Gemini ab — dort, wo Menschen 2026 tatsächlich suchen. Außerdem erstellt PulseAI Engine™ konkrete Schritt-für-Schritt-Empfehlungen für Sie.",
    faqs_q2: "Ist der erste Scan wirklich kostenlos?",
    faqs_a2: "Ja, keine Kreditkarte erforderlich. Sie erhalten einen vollständigen SEO + GEO Bericht für 1 Domain + 3 KI-Empfehlungen. Fügen Sie einfach Ihre URL ein und führen Sie einen Scan durch.",
    faqs_q3: "Muss ich SEO technisch verstehen?",
    faqs_a3: "Nein. PulseAI Engine™ erstellt einen genauen Schritt-für-Schritt-Aktionsplan ('Titel zu X ändern', 'Keyword Y hinzufügen'). Einfach kopieren und einfügen. Null Programmierung.",
    faqs_q4: "Wie lange dauert es, bis ich Ergebnisse sehe?",
    faqs_a4: "Erste Ranking-Verbesserungen innerhalb von 7–14 Tagen. KI-Sichtbarkeit (Erwähnungen in ChatGPT / Perplexity) innerhalb von 3–5 Tagen. Die meisten Kunden sehen innerhalb von 30 Tagen +40% mehr Traffic.",
    faqs_q5: "Funktioniert es für lokale / EU-Märkte?",
    faqs_a5: "Ja, vollständige Unterstützung für 26 Sprachen einschließlich SK, CZ, PL, HU, DE. Unser LLM generiert Empfehlungen direkt in Ihrer Sprache und berücksichtigt lokale SEO-Spezifika.",
    faqs_q6: "Kann ich jederzeit kündigen?",
    faqs_a6: "Ja, ein Klick in Ihrem Dashboard. Keine Stornierungsgebühren. 30-Tage-Geld-zurück-Garantie, wenn Sie nicht zufrieden sind.",
    faqs_q7: "Haben Sie eine Integration für WordPress / Shopify?",
    faqs_a7: "Das WordPress-Plugin (kostenloser Download) wendet automatisch Schema-Markup und Meta-Tags an. Die Shopify-App kommt im Q2 2026.",
    faqs_q8: "Was passiert, wenn ein Wettbewerber meine Domain scannt?",
    faqs_a8: "Scans sind öffentlich (jeder kann jede URL scannen). Ihre Daten, Keywords und Strategien sind privat und verschlüsselt — nur Sie haben über Ihr Konto Zugriff.",
    faqs_q9: "Was ist Ihre Garantie?",
    faqs_a9: "30-Tage-Geld-zurück-Garantie, keine Fragen gestellt. Nicht zufrieden — volle Rückerstattung.",
    faqs_q10: "Haben Sie eine API?",
    faqs_a10: "Ja, der Enterprise-Plan beinhaltet REST API + Webhooks für die Integration mit Ihren internen Tools, CRM oder BI-Dashboards.",
    sleep_tag: "Automatisierung 24/7",
    sleep_title_a: "Während Sie schlafen,",
    sleep_title_b: "arbeitet PulseAI",
    sleep_subtitle: "Jede Nacht um 3:00 Uhr führt Ihr KI-Assistent automatisch 6 kritische Aufgaben aus. Sie öffnen morgens Ihre E-Mails — 17 neue Verbesserungen warten auf Ihre Genehmigung mit einem Klick.",
    sleep_highlight: "17 neue Verbesserungen warten auf Ihre Genehmigung mit einem Klick.",
    sleep_check_1: "Scannt 100% Ihrer Seiten",
    sleep_check_2: "Überprüft 47 KI-Plattformen (ChatGPT, Perplexity, Claude…)",
    sleep_check_3: "Generiert 5 neue Optimierungsempfehlungen",
    sleep_check_4: "Sendet eine Benachrichtigung, wenn ein Konkurrent Ihre Position überholt",
    sleep_check_5: "Entwirft einen Blogartikel für morgen",
    sleep_check_6: "Passt die Meta-Tags an, wo CTR gesunken ist",
    sleep_cta: "Lassen Sie KI für Sie arbeiten →",
    sleep_overnight: "Übernachtige Verbesserungen:",
    sleep_pending: "wartet auf Genehmigung",
    course_tag: "Kostenlos · Keine Kreditkarte",
    course_title_a: "7 Tage zu",
    course_title_b: "Position #1",
    course_subtitle: "K kostenfreier E-Mail-Kurs: 7 praktische Lektionen, 7 konkrete Aufgaben, 1 BONUS-Rabattcode am Ende.",
    course_feature_1: "7 E-Mails × 5 min Lesen",
    course_feature_2: "Copy-Paste umsetzbare Aufgaben",
    course_feature_bonus: "BONUS:",
    course_feature_3: "20% Rabattcode bei Abschluss",
    course_email_placeholder: "ihre@email.com",
    course_submit: "Senden →",
    course_privacy: "🔒 Kein Spam · Abmeldung mit 1 Klick · DSGVO-konform",
    course_success: "✅ Fertig! Überprüfen Sie Ihre E-Mail.",
    course_code_label: "Ihr BONUS-Code:",
    course_program: "7-Tage-Programm",
    course_d1_t: "Audit in 5 Minuten",
    course_d1_s: "Wo Sie wirklich stehen",
    course_d2_t: "Keywords, die alles verändern",
    course_d2_s: "Long-Tail vs. Short-Tail",
    course_d3_t: "On-Page SEO ohne Entwickler",
    course_d3_s: "Titel, Meta, H1, Schema",
    course_d4_t: "Wie man in ChatGPT-Antworten kommt",
    course_d4_s: "GEO-Strategie Schritt für Schritt",
    course_d5_t: "Backlink-Strategie ohne Spam",
    course_d5_s: "14 White-Hat-Techniken",
    course_d6_t: "Technisches SEO-Checkliste",
    course_d6_s: "Geschwindigkeit, Schema, mobil",
    course_d7_t: "Ihr 90-Tage-Plan",
    course_d7_s: "+ BONUS: 20% Rabattcode",
    course_err_invalid: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    strat_nav_title: "KI-Strategiegenerator",
    strat_badge: "PRO / Kostenlose erste Strategie",
    strat_title_a: "Wie man",
    strat_title_b: "seinen Konkurrenten übertrifft",
    strat_title_c: "in 30 Tagen",
    strat_subtitle: "Der PulseAI Engine™ erstellt einen konkreten 4-Wochen-Aktionsplan, der auf Ihre Domain im Vergleich zu einem bestimmten Wettbewerber zugeschnitten ist.",
    strat_label_my: "Ihre Domain",
    strat_label_competitor: "Wettbewerber",
    strat_label_keywords: "Ziel-Keywords (optional)",
    strat_placeholder_my: "ihredomain.com",
    strat_placeholder_competitor: "wettbewerber.com",
    strat_placeholder_keywords: "Laufschuhe, Nike-Schuhe, Adidas...",
    strat_kw_hint: "Durch Kommas getrennt. Maximal 6 Keywords.",
    strat_submit: "30-Tage-Strategie erstellen",
    strat_loading: "KI analysiert... (~15–30s)",
    strat_err_both: "Beide Domains eingeben",
    strat_err_generic: "Erstellung fehlgeschlagen",
    strat_gap_title: "📊 Aktuelle Lückenanalyse",
    strat_share: "Teilen",
    strat_copied: "Kopiert!",
    strat_gap_score: "SEO-Score",
    strat_gap_keywords: "Keywords in den TOP 100",
    strat_gap_ai_vis: "KI-Sichtbarkeit %",
    strat_you: "Sie",
    strat_competitor: "Wettbewerber",
    strat_advantages_title: "🔥 Ihre unfairen Vorteile",
    strat_week_label: "Woche",
    strat_forecast_title: "🎯 Prognostiziertes Ergebnis (30 Tage)",
    strat_forecast_traffic: "Organischer Traffic",
    strat_forecast_position: "Zielposition",
    strat_forecast_ai_vis: "KI-Sichtbarkeit",
    strat_upgrade: "Auf PRO upgraden",
  },
  pl: {
    laf_live: "NA ŻYWO",
    laf_online: "online",
    laf_from: "od",
    laf_verified: "Zweryfikowane",
    laf_just_now: "przed chwilą",
    laf_seconds_ago: "przed {n}s",
    laf_minutes_ago: "przed {n}m",
    laf_hours_ago: "przed {n}h",
    faqs_tag: "FAQ",
    faqs_title: "Najczęściej zadawane pytania",
    faqs_subtitle: "Wszystko co musisz wiedzieć przed pierwszym skanem",
    faqs_contact: "Potrzebujesz więcej? Napisz do nas na",
    faqs_q1: "Czym różnicie się od SEMrush i Ahrefs?",
    faqs_a1: "SEMrush kosztuje od €119/miesiąc i śledzi tylko Google. Za €49/miesiąc obejmujemy Google + ChatGPT + Perplexity + Claude + Gemini — tam, gdzie ludzie naprawdę szukają w 2026 roku. Dodatkowo PulseAI Engine™ pisze konkretne zalecenia krok po kroku.",
    faqs_q2: "Czy pierwszy skan jest naprawdę bezpłatny?",
    faqs_a2: "Tak, nie wymagamy karty kredytowej. Otrzymujesz pełny raport SEO + GEO dla 1 domeny + 3 zalecenia AI. Po prostu wklej swój URL i uruchom skan.",
    faqs_q3: "Czy muszę znać SEO technicznie?",
    faqs_a3: "Nie. PulseAI Engine™ pisze dokładny plan działań krok po kroku ('zmień tytuł na X', 'dodaj słowo kluczowe Y'). Po prostu kopiuj-wklej. Zero programowania.",
    faqs_q4: "Jak długo muszę czekać na wyniki?",
    faqs_a4: "Pierwsze poprawy w rankingach w ciągu 7-14 dni. Widoczność AI (wzmianki o ChatGPT / Perplexity) w ciągu 3-5 dni. Większość klientów widzi +40% ruchu w ciągu 30 dni.",
    faqs_q5: "Czy to działa na rynkach lokalnych / EU?",
    faqs_a5: "Tak, pełne wsparcie dla 26 języków, w tym SK, CZ, PL, HU, DE. Nasze LLM generuje rekomendacje bezpośrednio w Twoim języku i uwzględnia lokalne specyfiki SEO.",
    faqs_q6: "Czy mogę anulować w dowolnym momencie?",
    faqs_a6: "Tak, jednym kliknięciem w panelu. Brak opłat za anulowanie. 30-dniowa gwarancja zwrotu pieniędzy, jeśli nie jesteś zadowolony.",
    faqs_q7: "Czy macie integrację z WordPress / Shopify?",
    faqs_a7: "Wtyczka WordPress (darmowe pobranie) automatycznie stosuje znaczniki schemy i meta tagi. Aplikacja Shopify pojawi się w II kwartale 2026.",
    faqs_q8: "Co jeśli konkurencja zeskanuje moją domenę?",
    faqs_a8: "Skanowanie jest publiczne (każdy może zeskanować dowolny URL). Twoje dane, słowa kluczowe i strategie są prywatne i szyfrowane — tylko Ty masz do nich dostęp przez swoje konto.",
    faqs_q9: "Jaka jest Wasza gwarancja?",
    faqs_a9: "30-dniowa gwarancja zwrotu pieniędzy, bez pytań. Nie jesteś zadowolony — pełny zwrot.",
    faqs_q10: "Czy macie API?",
    faqs_a10: "Tak, plan Enterprise obejmuje REST API + webhooki do integracji z Twoimi wewnętrznymi narzędziami, CRM lub pulpitami BI.",
    sleep_tag: "Automatyzacja 24/7",
    sleep_title_a: "Podczas gdy śpisz,",
    sleep_title_b: "PulseAI działa",
    sleep_subtitle: "Każdej nocy o 3:00 Twoja asystentka AI automatycznie wykonuje 6 krytycznych zadań. Rano otwierasz e-mail – 17 nowych ulepszeń czeka na akceptację jednym kliknięciem.",
    sleep_highlight: "17 nowych ulepszeń czeka na akceptację jednym kliknięciem.",
    sleep_check_1: "Skanuje 100% Twoich stron",
    sleep_check_2: "Sprawdza 47 platform AI (ChatGPT, Perplexity, Claude…)",
    sleep_check_3: "Generuje 5 nowych rekomendacji optymalizacyjnych",
    sleep_check_4: "Wysyła powiadomienie, gdy konkurent wyprzedza twoją pozycję",
    sleep_check_5: "Szkicuje wpis na bloga na jutro",
    sleep_check_6: "Dostosowuje tagi meta, gdzie spadł CTR",
    sleep_cta: "Niech AI pracuje dla Ciebie →",
    sleep_overnight: "Nocne ulepszenia:",
    sleep_pending: "czekanie na zatwierdzenie",
    course_tag: "Darmowe · Bez karty kredytowej",
    course_title_a: "7 dni do",
    course_title_b: "pozycji #1",
    course_subtitle: "Darmowy kurs mailowy: 7 praktycznych lekcji, 7 konkretnych zadań, 1 KOD zniżkowy BONUS na końcu.",
    course_feature_1: "7 e-maili × 5 min czytania",
    course_feature_2: "Zadania do kopiowania i wklejania",
    course_feature_bonus: "BONUS:",
    course_feature_3: "Kod zniżkowy 20% po ukończeniu",
    course_email_placeholder: "twoj@email.com",
    course_submit: "Wyślij →",
    course_privacy: "🔒 Bez spamu · Wypisz się 1 kliknięciem · Przyjazne dla RODO",
    course_success: "✅ Gotowe! Sprawdź swoją skrzynkę.",
    course_code_label: "Twój kod BONUS:",
    course_program: "7-dniowy program",
    course_d1_t: "Audyt w 5 minut",
    course_d1_s: "Gdzie tak naprawdę stoisz",
    course_d2_t: "Słowa kluczowe, które zmieniają wszystko",
    course_d2_s: "Długie ogony vs. krótkie ogony",
    course_d3_t: "SEO on-page bez programisty",
    course_d3_s: "Tytuł, meta, H1, schema",
    course_d4_t: "Jak trafić do odpowiedzi ChatGPT",
    course_d4_s: "Strategia GEO krok po kroku",
    course_d5_t: "Strategia backlinków bez spamu",
    course_d5_s: "14 technik white-hat",
    course_d6_t: "Lista kontrolna technicznego SEO",
    course_d6_s: "Szybkość, schema, mobilność",
    course_d7_t: "Twój plan na 90 dni",
    course_d7_s: "+ BONUS: kod zniżkowy 20%",
    course_err_invalid: "Proszę wprowadzić poprawny adres e-mail",
    strat_nav_title: "Generator Strategii AI",
    strat_badge: "PRO / Darmowa pierwsza strategia",
    strat_title_a: "Jak",
    strat_title_b: "przechwycić konkurencję",
    strat_title_c: "w 30 dni",
    strat_subtitle: "Silnik PulseAI™ tworzy konkretny 4-tygodniowy plan działania dostosowany do Twojej domeny w porównaniu do konkretnego konkurenta.",
    strat_label_my: "Twoja domena",
    strat_label_competitor: "Konkurent",
    strat_label_keywords: "Docelowe słowa kluczowe (opcjonalnie)",
    strat_placeholder_my: "twojadomena.pl",
    strat_placeholder_competitor: "konkurent.pl",
    strat_placeholder_keywords: "buty do biegania, buty nike, adidas...",
    strat_kw_hint: "Oddzielone przecinkami. Maks. 6 słów kluczowych.",
    strat_submit: "Generuj strategię na 30 dni",
    strat_loading: "AI analizuje... (~15–30s)",
    strat_err_both: "Wprowadź obie domeny",
    strat_err_generic: "Generowanie nie powiodło się",
    strat_gap_title: "📊 Analiza luk",
    strat_share: "Udostępnij",
    strat_copied: "Skopiowane!",
    strat_gap_score: "Wynik SEO",
    strat_gap_keywords: "Słowa kluczowe w TOP 100",
    strat_gap_ai_vis: "Widoczność AI %",
    strat_you: "Ty",
    strat_competitor: "Konkurent",
    strat_advantages_title: "🔥 Twoje nieuczciwe przewagi",
    strat_week_label: "Tydzień",
    strat_forecast_title: "🎯 Prognozowany wynik (30 dni)",
    strat_forecast_traffic: "Ruch organiczny",
    strat_forecast_position: "Docelowa pozycja",
    strat_forecast_ai_vis: "Widoczność AI",
    strat_upgrade: "Przejdź do PRO",
  },
  hu: {
    laf_live: "ÉLŐ",
    laf_online: "online",
    laf_from: "tól",
    laf_verified: "Hitelesítve",
    laf_just_now: "éppen most",
    laf_seconds_ago: "{n} másodperccel ezelőtt",
    laf_minutes_ago: "{n} perccel ezelőtt",
    laf_hours_ago: "{n} órával ezelőtt",
    faqs_tag: "GYIK",
    faqs_title: "Gyakran ismételt kérdések",
    faqs_subtitle: "Minden, amit tudni érdemes az első vizsgálat előtt",
    faqs_contact: "Többre van szükséged? Írj nekünk itt:",
    faqs_q1: "Miben különböztök a SEMrush-tól és az Ahrefs-től?",
    faqs_a1: "A SEMrush ára 119 €/hó-tól kezdődik, és csak a Google-t követi. 49 €/hó-ért a Google-t + a ChatGPT-t + a Perplexity-t + a Claude-ot + a Gemini-t követjük – ahol az emberek ténylegesen keresnek 2026-ban. Ráadásul a PulseAI Engine™ konkrét lépésről lépésre ajánlásokat ír számodra.",
    faqs_q2: "Az első vizsgálat valóban ingyenes?",
    faqs_a2: "Igen, nem kell hitelkártya. Teljes SEO + GEO jelentést kapsz 1 domainre + 3 AI ajánlást. Csak másold be az URL-ed és indíts egy vizsgálatot.",
    faqs_q3: "Meg kell értenem a SEO-t technikailag?",
    faqs_a3: "Nem. A PulseAI Engine™ pontos lépésről lépésre akciótervet ír ('cseréld a címet X-re', 'add hozzá a Y kulcsszót'). Csak másold be. Nulla programozás.",
    faqs_q4: "Mikor láthatom az eredményeket?",
    faqs_a4: "Az első rangsorjavulások 7–14 napon belül. AI láthatóság (ChatGPT / Perplexity említések) 3–5 napon belül. A legtöbb ügyfél +40% forgalmat lát 30 napon belül.",
    faqs_q5: "Működik helyi / EU piacokon?",
    faqs_a5: "Igen, teljes támogatás 26 nyelven, beleértve a SK, CZ, PL, HU, DE. A nyelvi modellünk közvetlenül a te nyelveden generál ajánlásokat, figyelembe véve a helyi SEO specifikumokat.",
    faqs_q6: "Bármikor lemondhatom?",
    faqs_a6: "Igen, egy kattintás a műszerfaladon. Nincsenek lemondási díjak. 30 napos pénz-visszafizetési garancia, ha nem vagy elégedett.",
    faqs_q7: "Van WordPress / Shopify integrációtok?",
    faqs_a7: "A WordPress plugin (ingyenes letöltés) automatikusan alkalmazza a séma jelölést és a meta címkéket. A Shopify alkalmazás 2026 második negyedévében érkezik.",
    faqs_q8: "Mi van, ha egy versenytárs beolvassa a doménemet?",
    faqs_a8: "A beolvasás nyilvános (bárki beolvashat bármilyen URL-t). Az adataid, kulcsszavaid és stratégiáid privátak és titkosítva vannak – csak te férsz hozzá a fiókodon keresztül.",
    faqs_q9: "Mi a garanciátok?",
    faqs_a9: "30 napos pénz-visszafizetési garancia, kérdés nélkül. Ha nem vagy elégedett – teljes visszatérítés.",
    faqs_q10: "Van API-tok?",
    faqs_a10: "Igen, az Enterprise terv tartalmaz REST API-t + webhookokat a belső eszközeiddel, CRM-mel vagy BI irányítópultokkal való integrációhoz.",
    sleep_tag: "Automatizálás 24/7",
    sleep_title_a: "Amíg alszol,",
    sleep_title_b: "a PulseAI dolgozik",
    sleep_subtitle: "Minden este 3:00-kor az AI asszisztensed automatikusan 6 kritikus feladatot végez el. Reggel megnyitod az emailed – 17 új fejlesztés vár 1 kattintásos jóváhagyásra.",
    sleep_highlight: "17 új fejlesztés vár 1 kattintásos jóváhagyásra.",
    sleep_check_1: "Beolvassa az oldalad 100%-át",
    sleep_check_2: "Ellenőrzi a 47 AI platformot (ChatGPT, Perplexity, Claude…)",
    sleep_check_3: "5 új optimalizálási ajánlást generál",
    sleep_check_4: "Értesítést küld, ha egy versenytárs megelőzi a pozíciódat",
    sleep_check_5: "Megír egy blogcikket holnapra",
    sleep_check_6: "Beállítja a meta tageket, ahol a CTR csökkent",
    sleep_cta: "Engedd, hogy az AI dolgozzon helyetted →",
    sleep_overnight: "Éjszakai fejlesztések:",
    sleep_pending: "jóváhagyásra vár",
    course_tag: "Ingyenes · Nincs bankkártya",
    course_title_a: "7 nap alatt",
    course_title_b: "#1 pozíció",
    course_subtitle: "Ingyenes e-mail tanfolyam: 7 gyakorlati lecke, 7 konkrét feladat, 1 BÓNUSZ kedvezmény kód a végén.",
    course_feature_1: "7 e-mail × 5 perc olvasás",
    course_feature_2: "Másold és illeszd be a megvalósítható feladatokat",
    course_feature_bonus: "BÓNUSZ:",
    course_feature_3: "20% kedvezmény kód a befejezéskor",
    course_email_placeholder: "your@email.com",
    course_submit: "Küldés →",
    course_privacy: "🔒 Nincs spam · Lemondás 1 kattintással · GDPR-kompatibilis",
    course_success: "✅ Kész! Ellenőrizd az emailed.",
    course_code_label: "A BÓNUSZ kódod:",
    course_program: "7 napos program",
    course_d1_t: "Audit 5 perc alatt",
    course_d1_s: "Hol állsz valójában",
    course_d2_t: "Kulcsszavak, amik mindent megváltoztatnak",
    course_d2_s: "Hosszú farok vs. rövid farok",
    course_d3_t: "On-page SEO fejlesztő nélkül",
    course_d3_s: "Cím, meta, H1, séma",
    course_d4_t: "Hogyan juss be a ChatGPT válaszaiba",
    course_d4_s: "GEO stratégia lépésről lépésre",
    course_d5_t: "Visszautalási stratégia spam nélkül",
    course_d5_s: "14 white-hat technika",
    course_d6_t: "Technikai SEO ellenőrző lista",
    course_d6_s: "Sebesség, séma, mobil",
    course_d7_t: "A 90 napos terved",
    course_d7_s: "+ BÓNUSZ: 20% kedvezmény kód",
    course_err_invalid: "Kérjük, adj meg egy érvényes e-mail címet",
    strat_nav_title: "AI Stratégia Generátor",
    strat_badge: "PRO / Ingyenes első stratégia",
    strat_title_a: "Hogyan",
    strat_title_b: "előzd meg a versenytársadat",
    strat_title_c: "30 nap alatt",
    strat_subtitle: "A PulseAI Engine™ egy konkrét, 4 hetes cselekvési tervet generál az Ön doménjának és egy konkrét versenytársnak megfelelően.",
    strat_label_my: "Az Ön doménje",
    strat_label_competitor: "Versenytárs",
    strat_label_keywords: "Célzott kulcsszavak (opcionális)",
    strat_placeholder_my: "yourdomain.com",
    strat_placeholder_competitor: "competitor.com",
    strat_placeholder_keywords: "futócipők, nike cipők, adidas...",
    strat_kw_hint: "Vesszővel elválasztva. Max 6 kulcsszó.",
    strat_submit: "30 napos stratégia generálása",
    strat_loading: "AI elemzés alatt... (~15–30s)",
    strat_err_both: "Adja meg mindkét domaint",
    strat_err_generic: "Generálás sikertelen",
    strat_gap_title: "📊 Jelenlegi rés elemzés",
    strat_share: "Megosztás",
    strat_copied: "Másolva!",
    strat_gap_score: "SEO Pontszám",
    strat_gap_keywords: "Kulcsszavak a TOP 100-ban",
    strat_gap_ai_vis: "AI Láthatóság %",
    strat_you: "Ön",
    strat_competitor: "Versenytárs",
    strat_advantages_title: "🔥 Az Ön tisztátlan előnyei",
    strat_week_label: "Hét",
    strat_forecast_title: "🎯 Előrejelzett eredmény (30 nap)",
    strat_forecast_traffic: "Organikus forgalom",
    strat_forecast_position: "Célzott pozíció",
    strat_forecast_ai_vis: "AI Láthatóság",
    strat_upgrade: "Frissítés PRO-ra",
  },
  fr: {
    laf_live: "EN DIRECT",
    laf_online: "en ligne",
    laf_from: "de",
    laf_verified: "Vérifié",
    laf_just_now: "à l'instant",
    laf_seconds_ago: "il y a {n}s",
    laf_minutes_ago: "il y a {n}m",
    laf_hours_ago: "il y a {n}h",
    faqs_tag: "FAQ",
    faqs_title: "Questions fréquemment posées",
    faqs_subtitle: "Tout ce que vous devez savoir avant votre premier scan",
    faqs_contact: "Besoin de plus d'infos ? Écrivez-nous à",
    faqs_q1: "En quoi êtes-vous différent de SEMrush et Ahrefs ?",
    faqs_a1: "SEMrush coûte à partir de 119 €/mois et ne suit que Google. Pour 49 €/mois, nous couvrons Google + ChatGPT + Perplexity + Claude + Gemini — où les gens cherchent réellement en 2026. De plus, PulseAI Engine™ rédige des recommandations concrètes étape par étape pour vous.",
    faqs_q2: "Le premier scan est-il vraiment gratuit ?",
    faqs_a2: "Oui, aucune carte de crédit requise. Vous obtenez un rapport SEO + GEO complet pour 1 domaine + 3 recommandations AI. Il suffit de coller votre URL et de lancer un scan.",
    faqs_q3: "Dois-je connaître le SEO techniquement ?",
    faqs_a3: "Non. PulseAI Engine™ rédige un plan d'action précis étape par étape ('changer le titre en X', 'ajouter le mot-clé Y'). Il suffit de copier-coller. Aucune programmation.",
    faqs_q4: "Combien de temps avant de voir des résultats ?",
    faqs_a4: "Premières améliorations de classement dans les 7 à 14 jours. Visibilité AI (mentions ChatGPT / Perplexity) dans les 3 à 5 jours. La plupart des clients voient +40 % de trafic dans les 30 jours.",
    faqs_q5: "Est-ce que ça fonctionne pour les marchés locaux / de l'UE ?",
    faqs_a5: "Oui, un support complet pour 26 langues dont SK, CZ, PL, HU, DE. Notre LLM génère des recommandations directement dans votre langue et prend en compte les spécificités locales du SEO.",
    faqs_q6: "Puis-je annuler à tout moment ?",
    faqs_a6: "Oui, un clic dans votre tableau de bord. Aucun frais d'annulation. Garantie de remboursement de 30 jours si vous n'êtes pas satisfait.",
    faqs_q7: "Avez-vous une intégration WordPress / Shopify ?",
    faqs_a7: "Le plugin WordPress (téléchargement gratuit) applique automatiquement le balisage de schéma et les balises meta. L'application Shopify arrive au T2 2026.",
    faqs_q8: "Que se passe-t-il si un concurrent analyse mon domaine ?",
    faqs_a8: "L'analyse est publique (tout le monde peut analyser n'importe quelle URL). Vos données, mots-clés et stratégies sont privées et cryptées — vous seul avez accès via votre compte.",
    faqs_q9: "Quelle est votre garantie ?",
    faqs_a9: "Garantie de remboursement de 30 jours, sans questions posées. Pas satisfait — remboursement complet.",
    faqs_q10: "Avez-vous une API ?",
    faqs_a10: "Oui, le plan Enterprise inclut REST API + webhooks pour l'intégration avec vos outils internes, CRM ou tableaux de bord BI.",
    sleep_tag: "Automatisation 24/7",
    sleep_title_a: "Pendant que vous dormez,",
    sleep_title_b: "PulseAI travaille",
    sleep_subtitle: "Chaque nuit à 3h00, votre assistant AI exécute automatiquement 6 tâches critiques. Vous ouvrez votre e-mail le matin — 17 nouvelles améliorations en attente d'approbation en un clic.",
    sleep_highlight: "17 nouvelles améliorations en attente d'approbation en un clic.",
    sleep_check_1: "Analyse 100 % de vos pages",
    sleep_check_2: "Vérifie 47 plateformes AI (ChatGPT, Perplexity, Claude…)",
    sleep_check_3: "Génère 5 nouvelles recommandations d'optimisation",
    sleep_check_4: "Envoie une alerte si un concurrent dépasse votre position",
    sleep_check_5: "Rédige un article de blog pour demain",
    sleep_check_6: "Ajuste les balises meta où le CTR a baissé",
    sleep_cta: "Laissez l'IA travailler pour vous →",
    sleep_overnight: "Améliorations nocturnes :",
    sleep_pending: "en attente d'approbation",
    course_tag: "Gratuit · Pas de carte de crédit",
    course_title_a: "7 jours pour",
    course_title_b: "la position #1",
    course_subtitle: "Cours par email gratuit : 7 leçons pratiques, 7 tâches concrètes, 1 CODE de réduction BONUS à la fin.",
    course_feature_1: "7 emails × 5 min de lecture",
    course_feature_2: "Tâches exploitables à copier-coller",
    course_feature_bonus: "BONUS :",
    course_feature_3: "Code de réduction de 20 % à l'achèvement",
    course_email_placeholder: "votre@email.com",
    course_submit: "Envoyer →",
    course_privacy: "🔒 Pas de spam · Désabonnez-vous en 1 clic · Conforme au RGPD",
    course_success: "✅ Fait ! Vérifiez votre email.",
    course_code_label: "Votre code BONUS :",
    course_program: "Programme de 7 jours",
    course_d1_t: "Audit en 5 minutes",
    course_d1_s: "Où vous en êtes réellement",
    course_d2_t: "Mots-clés qui changent tout",
    course_d2_s: "Longue traîne vs. courte traîne",
    course_d3_t: "SEO on-page sans développeur",
    course_d3_s: "Titre, meta, H1, schéma",
    course_d4_t: "Comment intégrer dans les réponses de ChatGPT",
    course_d4_s: "Stratégie GEO étape par étape",
    course_d5_t: "Stratégie de backlink sans spam",
    course_d5_s: "14 techniques white-hat",
    course_d6_t: "Liste de contrôle SEO technique",
    course_d6_s: "Vitesse, schéma, mobile",
    course_d7_t: "Votre plan de 90 jours",
    course_d7_s: "+ BONUS : code de réduction de 20 %",
    course_err_invalid: "Veuillez saisir un email valide",
    strat_nav_title: "Générateur de Stratégie IA",
    strat_badge: "PRO / Première stratégie gratuite",
    strat_title_a: "Comment",
    strat_title_b: "dépasser votre concurrent",
    strat_title_c: "en 30 jours",
    strat_subtitle: "Le moteur PulseAI™ génère un plan d'action concret de 4 semaines adapté à votre domaine par rapport à un concurrent spécifique.",
    strat_label_my: "Votre domaine",
    strat_label_competitor: "Concurrent",
    strat_label_keywords: "Mots-clés cibles (optionnel)",
    strat_placeholder_my: "votredomaine.com",
    strat_placeholder_competitor: "concurrent.com",
    strat_placeholder_keywords: "chaussures de course, chaussures nike, adidas...",
    strat_kw_hint: "Séparés par des virgules. Max 6 mots-clés.",
    strat_submit: "Générer la stratégie sur 30 jours",
    strat_loading: "Analyse de l'IA en cours... (~15–30s)",
    strat_err_both: "Entrez les deux domaines",
    strat_err_generic: "Échec de la génération",
    strat_gap_title: "📊 Analyse des écarts actuelle",
    strat_share: "Partager",
    strat_copied: "Copié !",
    strat_gap_score: "Score SEO",
    strat_gap_keywords: "Mots-clés dans le TOP 100",
    strat_gap_ai_vis: "Visibilité IA %",
    strat_you: "Vous",
    strat_competitor: "Concurrent",
    strat_advantages_title: "🔥 Vos avantages déloyaux",
    strat_week_label: "Semaine",
    strat_forecast_title: "🎯 Résultat prévisionnel (30 jours)",
    strat_forecast_traffic: "Trafic organique",
    strat_forecast_position: "Position cible",
    strat_forecast_ai_vis: "Visibilité IA",
    strat_upgrade: "Mettre à niveau vers PRO",
  },
  es: {
    laf_live: "EN VIVO",
    laf_online: "en línea",
    laf_from: "de",
    laf_verified: "Verificado",
    laf_just_now: "ahora mismo",
    laf_seconds_ago: "hace {n}s",
    laf_minutes_ago: "hace {n}m",
    laf_hours_ago: "hace {n}h",
    faqs_tag: "FAQ",
    faqs_title: "Preguntas frecuentes",
    faqs_subtitle: "Todo lo que necesitas saber antes de tu primer escaneo",
    faqs_contact: "¿Necesitas más? Escríbenos a",
    faqs_q1: "¿En qué te diferencias de SEMrush y Ahrefs?",
    faqs_a1: "SEMrush cuesta a partir de €119/mes y solo rastrea Google. Por €49/mes cubrimos Google + ChatGPT + Perplexity + Claude + Gemini — donde la gente realmente busca en 2026. Además, PulseAI Engine™ escribe recomendaciones concretas paso a paso para ti.",
    faqs_q2: "¿El primer escaneo es realmente gratis?",
    faqs_a2: "Sí, no se requiere tarjeta de crédito. Obtienes un informe completo de SEO + GEO para 1 dominio + 3 recomendaciones de IA. Solo pega tu URL y ejecuta un escaneo.",
    faqs_q3: "¿Necesito saber SEO técnicamente?",
    faqs_a3: "No. PulseAI Engine™ escribe un plan de acción exacto paso a paso ('cambiar título a X', 'agregar palabra clave Y'). Solo copia y pega. Cero programación.",
    faqs_q4: "¿Cuánto tiempo tardaré en ver resultados?",
    faqs_a4: "Mejoras en los rankings dentro de 7–14 días. Visibilidad en IA (menciones en ChatGPT / Perplexity) dentro de 3–5 días. La mayoría de los clientes ven un aumento del +40% en tráfico dentro de 30 días.",
    faqs_q5: "¿Funciona para mercados locales / de la UE?",
    faqs_a5: "Sí, soporte completo para 26 idiomas incluyendo SK, CZ, PL, HU, DE. Nuestro LLM genera recomendaciones directamente en tu idioma y tiene en cuenta las especificaciones locales de SEO.",
    faqs_q6: "¿Puedo cancelar en cualquier momento?",
    faqs_a6: "Sí, un clic en tu tablero. Sin cargos por cancelación. Garantía de devolución de dinero de 30 días si no estás satisfecho.",
    faqs_q7: "¿Tienen integración con WordPress / Shopify?",
    faqs_a7: "El plugin de WordPress (descarga gratuita) aplica automáticamente el marcado de esquema y las meta tags. La aplicación de Shopify llegará en el Q2 de 2026.",
    faqs_q8: "¿Qué pasa si un competidor escanea mi dominio?",
    faqs_a8: "El escaneo es público (cualquiera puede escanear cualquier URL). Tus datos, palabras clave y estrategias son privados y están encriptados: solo tú tienes acceso a través de tu cuenta.",
    faqs_q9: "¿Cuál es su garantía?",
    faqs_a9: "Garantía de devolución de dinero de 30 días, sin preguntas. Si no estás contento, reembolso total.",
    faqs_q10: "¿Tienen una API?",
    faqs_a10: "Sí, el plan Enterprise incluye REST API + webhooks para la integración con tus herramientas internas, CRM o tableros de BI.",
    sleep_tag: "Automatización 24/7",
    sleep_title_a: "Mientras duermes,",
    sleep_title_b: "PulseAI trabaja",
    sleep_subtitle: "Cada noche a las 3:00 AM, tu asistente de IA ejecuta automáticamente 6 tareas críticas. Abres tu correo por la mañana — 17 nuevas mejoras esperando tu aprobación con un clic.",
    sleep_highlight: "17 nuevas mejoras esperando tu aprobación con un clic.",
    sleep_check_1: "Escanea el 100% de tus páginas",
    sleep_check_2: "Revisa 47 plataformas de IA (ChatGPT, Perplexity, Claude…)",
    sleep_check_3: "Genera 5 nuevas recomendaciones de optimización",
    sleep_check_4: "Envía una alerta si un competidor supera tu posición",
    sleep_check_5: "Redacta un artículo de blog para mañana",
    sleep_check_6: "Ajusta las meta etiquetas donde cayó el CTR",
    sleep_cta: "Deja que la IA trabaje para ti →",
    sleep_overnight: "Mejoras nocturnas:",
    sleep_pending: "esperando aprobación",
    course_tag: "Gratis · Sin tarjeta de crédito",
    course_title_a: "7 días para",
    course_title_b: "posición #1",
    course_subtitle: "Curso gratuito por email: 7 lecciones prácticas, 7 tareas concretas, 1 código de descuento BONO al final.",
    course_feature_1: "7 correos × 5 min de lectura",
    course_feature_2: "Tareas prácticas para copiar y pegar",
    course_feature_bonus: "BONO:",
    course_feature_3: "Código de descuento del 20% al finalizar",
    course_email_placeholder: "tu@email.com",
    course_submit: "Enviar →",
    course_privacy: "🔒 Sin spam · Cancelar 1 clic · Amigable con GDPR",
    course_success: "✅ ¡Listo! Revisa tu correo.",
    course_code_label: "Tu código BONO:",
    course_program: "Programa de 7 días",
    course_d1_t: "Auditoría en 5 minutos",
    course_d1_s: "Dónde te encuentras realmente",
    course_d2_t: "Palabras clave que lo cambian todo",
    course_d2_s: "De cola larga vs. cola corta",
    course_d3_t: "SEO en la página sin un desarrollador",
    course_d3_s: "Título, meta, H1, esquema",
    course_d4_t: "Cómo aparecer en las respuestas de ChatGPT",
    course_d4_s: "Estrategia GEO paso a paso",
    course_d5_t: "Estrategia de backlinks sin spam",
    course_d5_s: "14 técnicas de sombrero blanco",
    course_d6_t: "Lista de verificación de SEO técnico",
    course_d6_s: "Velocidad, esquema, móvil",
    course_d7_t: "Tu plan de 90 días",
    course_d7_s: "+ BONO: código de descuento del 20%",
    course_err_invalid: "Por favor, ingresa un correo válido",
    strat_nav_title: "Generador de Estrategias de IA",
    strat_badge: "PRO / Primera estrategia gratuita",
    strat_title_a: "Cómo",
    strat_title_b: "superar a tu competidor",
    strat_title_c: "en 30 días",
    strat_subtitle: "PulseAI Engine™ genera un plan de acción concreto de 4 semanas adaptado a tu dominio frente a un competidor específico.",
    strat_label_my: "Tu dominio",
    strat_label_competitor: "Competidor",
    strat_label_keywords: "Palabras clave objetivo (opcional)",
    strat_placeholder_my: "tudominio.com",
    strat_placeholder_competitor: "competidor.com",
    strat_placeholder_keywords: "zapatillas de running, zapatillas nike, adidas...",
    strat_kw_hint: "Separadas por comas. Máx 6 palabras clave.",
    strat_submit: "Generar estrategia de 30 días",
    strat_loading: "AI analizando... (~15–30s)",
    strat_err_both: "Ingresa ambos dominios",
    strat_err_generic: "Generación fallida",
    strat_gap_title: "📊 Análisis de Brecha Actual",
    strat_share: "Compartir",
    strat_copied: "¡Copiado!",
    strat_gap_score: "Puntuación SEO",
    strat_gap_keywords: "Palabras clave en el TOP 100",
    strat_gap_ai_vis: "% Visibilidad AI",
    strat_you: "Tú",
    strat_competitor: "Competidor",
    strat_advantages_title: "🔥 Tus ventajas injustas",
    strat_week_label: "Semana",
    strat_forecast_title: "🎯 Resultado pronosticado (30 días)",
    strat_forecast_traffic: "Tráfico orgánico",
    strat_forecast_position: "Posición objetivo",
    strat_forecast_ai_vis: "Visibilidad AI",
    strat_upgrade: "Actualizar a PRO",
  },
  pt: {
    laf_live: "AO VIVO",
    laf_online: "online",
    laf_from: "de",
    laf_verified: "Verificado",
    laf_just_now: "agora mesmo",
    laf_seconds_ago: "há {n}s",
    laf_minutes_ago: "há {n}m",
    laf_hours_ago: "há {n}h",
    faqs_tag: "FAQ",
    faqs_title: "Perguntas frequentes",
    faqs_subtitle: "Tudo o que você precisa saber antes da sua primeira varredura",
    faqs_contact: "Precisa de mais? Envie um e-mail para",
    faqs_q1: "Como vocês são diferentes do SEMrush e Ahrefs?",
    faqs_a1: "O SEMrush custa a partir de €119/mês e rastreia apenas o Google. Por €49/mês cobrimos Google + ChatGPT + Perplexity + Claude + Gemini — onde as pessoas realmente pesquisam em 2026. Além disso, o PulseAI Engine™ escreve recomendações concretas passo a passo para você.",
    faqs_q2: "A primeira varredura é realmente gratuita?",
    faqs_a2: "Sim, não é necessário cartão de crédito. Você recebe um relatório completo de SEO + GEO para 1 domínio + 3 recomendações de IA. Basta colar sua URL e executar uma varredura.",
    faqs_q3: "Preciso saber SEO tecnicamente?",
    faqs_a3: "Não. O PulseAI Engine™ escreve um plano de ação exato passo a passo ('mudar título para X', 'adicionar palavra-chave Y'). Basta copiar e colar. Zero programação.",
    faqs_q4: "Quanto tempo até eu ver resultados?",
    faqs_a4: "Primeiras melhorias de ranking em 7–14 dias. Visibilidade de IA (menções no ChatGPT / Perplexity) em 3–5 dias. A maioria dos clientes vê +40% de tráfego em 30 dias.",
    faqs_q5: "Funciona para mercados locais / da UE?",
    faqs_a5: "Sim, suporte total para 26 idiomas, incluindo SK, CZ, PL, HU, DE. Nosso LLM gera recomendações diretamente no seu idioma e considera as especificidades de SEO local.",
    faqs_q6: "Posso cancelar a qualquer momento?",
    faqs_a6: "Sim, com um clique no seu painel. Sem taxas de cancelamento. Garantia de devolução do dinheiro em 30 dias se você não estiver satisfeito.",
    faqs_q7: "Vocês têm integração com WordPress / Shopify?",
    faqs_a7: "O plugin WordPress (download gratuito) aplica automaticamente marcação schema e meta tags. O app Shopify estará disponível no segundo trimestre de 2026.",
    faqs_q8: "E se um concorrente escanear meu domínio?",
    faqs_a8: "A varredura é pública (qualquer um pode escanear qualquer URL). Seus dados, palavras-chave e estratégias são privados e criptografados — apenas você tem acesso através da sua conta.",
    faqs_q9: "Qual é a sua garantia?",
    faqs_a9: "Garantia de devolução do dinheiro em 30 dias, sem perguntas. Não satisfeito — reembolso total.",
    faqs_q10: "Vocês têm uma API?",
    faqs_a10: "Sim, o plano Enterprise inclui REST API + webhooks para integração com suas ferramentas internas, CRM ou painéis de BI.",
    sleep_tag: "Automação 24/7",
    sleep_title_a: "Enquanto você dorme,",
    sleep_title_b: "o PulseAI trabalha",
    sleep_subtitle: "Toda noite às 3:00 da manhã, seu assistente de IA executa automaticamente 6 tarefas críticas. Você abre seu e-mail pela manhã — 17 novas melhorias aguardando aprovação com um clique.",
    sleep_highlight: "17 novas melhorias aguardando aprovação com um clique.",
    sleep_check_1: "Escaneia 100% das suas páginas",
    sleep_check_2: "Verifica 47 plataformas de IA (ChatGPT, Perplexity, Claude…)",
    sleep_check_3: "Gera 5 novas recomendações de otimização",
    sleep_check_4: "Envia um alerta se um concorrente ultrapassar sua posição",
    sleep_check_5: "Escreve um artigo de blog para amanhã",
    sleep_check_6: "Ajusta as meta tags onde a CTR caiu",
    sleep_cta: "Deixe a IA trabalhar para você →",
    sleep_overnight: "Melhorias durante a noite:",
    sleep_pending: "aguardando aprovação",
    course_tag: "Gratuito · Sem cartão de crédito",
    course_title_a: "7 dias para",
    course_title_b: "a posição #1",
    course_subtitle: "Curso de e-mail gratuito: 7 lições práticas, 7 tarefas concretas, 1 código de desconto BÔNUS no final.",
    course_feature_1: "7 e-mails × 5 min de leitura",
    course_feature_2: "Tarefas acionáveis para copiar e colar",
    course_feature_bonus: "BÔNUS:",
    course_feature_3: "Código de desconto de 20% na conclusão",
    course_email_placeholder: "seu@email.com",
    course_submit: "Enviar →",
    course_privacy: "🔒 Sem spam · Cancelar inscrição em 1 clique · Compatível com GDPR",
    course_success: "✅ Feito! Verifique seu e-mail.",
    course_code_label: "Seu código BÔNUS:",
    course_program: "Programa de 7 dias",
    course_d1_t: "Auditoria em 5 minutos",
    course_d1_s: "Onde você realmente está",
    course_d2_t: "Palavras-chave que mudam tudo",
    course_d2_s: "Long-tail vs. short-tail",
    course_d3_t: "SEO on-page sem um desenvolvedor",
    course_d3_s: "Título, meta, H1, schema",
    course_d4_t: "Como aparecer nas respostas do ChatGPT",
    course_d4_s: "Estratégia GEO passo a passo",
    course_d5_t: "Estratégia de backlink sem spam",
    course_d5_s: "14 técnicas white-hat",
    course_d6_t: "Checklist de SEO técnico",
    course_d6_s: "Velocidade, schema, mobile",
    course_d7_t: "Seu plano de 90 dias",
    course_d7_s: "+ BÔNUS: código de desconto de 20%",
    course_err_invalid: "Por favor, insira um e-mail válido",
    strat_nav_title: "Gerador de Estratégia de IA",
    strat_badge: "PRO / Primeira estratégia gratuita",
    strat_title_a: "Como",
    strat_title_b: "ultrapassar seu concorrente",
    strat_title_c: "em 30 dias",
    strat_subtitle: "O PulseAI Engine™ gera um plano de ação concreto de 4 semanas adaptado ao seu domínio em comparação com um concorrente específico.",
    strat_label_my: "Seu domínio",
    strat_label_competitor: "Concorrente",
    strat_label_keywords: "Palavras-chave alvo (opcional)",
    strat_placeholder_my: "seudominio.com",
    strat_placeholder_competitor: "concorrente.com",
    strat_placeholder_keywords: "tênis de corrida, tênis nike, adidas...",
    strat_kw_hint: "Separadas por vírgula. Máx 6 palavras-chave.",
    strat_submit: "Gerar estratégia de 30 dias",
    strat_loading: "AI analisando... (~15–30s)",
    strat_err_both: "Digite ambos os domínios",
    strat_err_generic: "Geração falhou",
    strat_gap_title: "📊 Análise de Lacunas Atual",
    strat_share: "Compartilhar",
    strat_copied: "Copiado!",
    strat_gap_score: "Pontuação de SEO",
    strat_gap_keywords: "Palavras-chave no TOP 100",
    strat_gap_ai_vis: "Visibilidade em AI %",
    strat_you: "Você",
    strat_competitor: "Concorrente",
    strat_advantages_title: "🔥 Suas vantagens injustas",
    strat_week_label: "Semana",
    strat_forecast_title: "🎯 Resultado Previsto (30 dias)",
    strat_forecast_traffic: "Tráfego orgânico",
    strat_forecast_position: "Posição alvo",
    strat_forecast_ai_vis: "Visibilidade em AI",
    strat_upgrade: "Atualizar para PRO",
  },
  it: {
    laf_live: "DAL VIVO",
    laf_online: "online",
    laf_from: "da",
    laf_verified: "Verificato",
    laf_just_now: "appena adesso",
    laf_seconds_ago: "{n}s fa",
    laf_minutes_ago: "{n}m fa",
    laf_hours_ago: "{n}h fa",
    faqs_tag: "FAQ",
    faqs_title: "Domande frequenti",
    faqs_subtitle: "Tutto ciò che devi sapere prima della tua prima scansione",
    faqs_contact: "Hai bisogno di più informazioni? Scrivici a",
    faqs_q1: "Come ti distingui da SEMrush e Ahrefs?",
    faqs_a1: "SEMrush costa da €119/mese e traccia solo Google. Con €49/mese copriamo Google + ChatGPT + Perplexity + Claude + Gemini — dove le persone cercano davvero nel 2026. Inoltre, PulseAI Engine™ scrive raccomandazioni dettagliate passo dopo passo per te.",
    faqs_q2: "La prima scansione è davvero gratuita?",
    faqs_a2: "Sì, non è richiesta carta di credito. Ottieni un report completo SEO + GEO per 1 dominio + 3 raccomandazioni AI. Basta incollare il tuo URL e avviare una scansione.",
    faqs_q3: "Devo sapere SEO tecnicamente?",
    faqs_a3: "No. PulseAI Engine™ scrive un piano d'azione dettagliato ('cambia titolo in X', 'aggiungi parola chiave Y'). Basta copiare e incollare. Zero programmazione.",
    faqs_q4: "Quanto tempo ci vuole per vedere i risultati?",
    faqs_a4: "Miglioramenti nel ranking entro 7–14 giorni. Visibilità AI (menzioni ChatGPT / Perplexity) entro 3–5 giorni. La maggior parte dei clienti vede un aumento del +40% del traffico entro 30 giorni.",
    faqs_q5: "Funziona per i mercati locali / UE?",
    faqs_a5: "Sì, supporto completo per 26 lingue tra cui SK, CZ, PL, HU, DE. Il nostro LLM genera raccomandazioni direttamente nella tua lingua e tiene conto delle specifiche locali SEO.",
    faqs_q6: "Posso cancellare in qualsiasi momento?",
    faqs_a6: "Sì, con un clic nel tuo pannello di controllo. Nessuna penale di cancellazione. Rimborso di 30 giorni se non sei soddisfatto.",
    faqs_q7: "Hai integrazione con WordPress / Shopify?",
    faqs_a7: "Il plugin WordPress (download gratuito) applica automaticamente il markup schema e i meta tag. L'app Shopify arriverà nel Q2 2026.",
    faqs_q8: "Cosa succede se un concorrente scansiona il mio dominio?",
    faqs_a8: "La scansione è pubblica (chiunque può scansionare qualsiasi URL). I tuoi dati, parole chiave e strategie sono privati e crittografati — solo tu hai accesso tramite il tuo account.",
    faqs_q9: "Qual è la tua garanzia?",
    faqs_a9: "Garanzia di rimborso di 30 giorni, senza fare domande. Non sei soddisfatto — rimborso completo.",
    faqs_q10: "Hai un'API?",
    faqs_a10: "Sì, il piano Enterprise include REST API + webhook per integrazione con i tuoi strumenti interni, CRM o dashboard BI.",
    sleep_tag: "Automazione 24/7",
    sleep_title_a: "Mentre dormi,",
    sleep_title_b: "PulseAI lavora",
    sleep_subtitle: "Ogni notte alle 3:00 AM il tuo assistente AI esegue automaticamente 6 compiti critici. Apri la tua email al mattino — 17 nuovi miglioramenti in attesa di approvazione con un clic.",
    sleep_highlight: "17 nuovi miglioramenti in attesa di approvazione con un clic.",
    sleep_check_1: "Scansiona il 100% delle tue pagine",
    sleep_check_2: "Controlla 47 piattaforme AI (ChatGPT, Perplexity, Claude…)",
    sleep_check_3: "Genera 5 nuove raccomandazioni di ottimizzazione",
    sleep_check_4: "Invia un avviso se un concorrente supera la tua posizione",
    sleep_check_5: "Redige un articolo per il blog per domani",
    sleep_check_6: "Regola i meta tag dove il CTR è diminuito",
    sleep_cta: "Lascia che l'IA lavori per te →",
    sleep_overnight: "Miglioramenti notturni:",
    sleep_pending: "in attesa di approvazione",
    course_tag: "Gratuito · Nessuna carta di credito",
    course_title_a: "7 giorni per",
    course_title_b: "posizione #1",
    course_subtitle: "Corso email gratuito: 7 lezioni pratiche, 7 compiti concreti, 1 codice sconto BONUS alla fine.",
    course_feature_1: "7 email × 5 min di lettura",
    course_feature_2: "Compiti azionabili da copiare e incollare",
    course_feature_bonus: "BONUS:",
    course_feature_3: "Codice sconto del 20% al termine",
    course_email_placeholder: "tuo@email.com",
    course_submit: "Invia →",
    course_privacy: "🔒 No spam · Disiscriviti con 1 clic · GDPR-friendly",
    course_success: "✅ Fatto! Controlla la tua email.",
    course_code_label: "Il tuo codice BONUS:",
    course_program: "programma di 7 giorni",
    course_d1_t: "Audit in 5 minuti",
    course_d1_s: "Dove ti trovi davvero",
    course_d2_t: "Parole chiave che cambiano tutto",
    course_d2_s: "A lungo termine vs. a breve termine",
    course_d3_t: "SEO on-page senza sviluppatore",
    course_d3_s: "Titolo, meta, H1, schema",
    course_d4_t: "Come entrare nelle risposte di ChatGPT",
    course_d4_s: "Strategia GEO passo dopo passo",
    course_d5_t: "Strategia backlink senza spam",
    course_d5_s: "14 tecniche white-hat",
    course_d6_t: "Checklist SEO tecnica",
    course_d6_s: "Velocità, schema, mobile",
    course_d7_t: "Il tuo piano di 90 giorni",
    course_d7_s: "+ BONUS: codice sconto del 20%",
    course_err_invalid: "Si prega di inserire un'email valida",
    strat_nav_title: "Generatore di Strategia IA",
    strat_badge: "PRO / Prima strategia gratuita",
    strat_title_a: "Come",
    strat_title_b: "superare il tuo concorrente",
    strat_title_c: "in 30 giorni",
    strat_subtitle: "Il PulseAI Engine™ genera un piano d'azione concreto di 4 settimane personalizzato per il tuo dominio rispetto a un concorrente specifico.",
    strat_label_my: "Il tuo dominio",
    strat_label_competitor: "Concorrente",
    strat_label_keywords: "Parole chiave target (opzionale)",
    strat_placeholder_my: "iltuodominio.com",
    strat_placeholder_competitor: "concorrente.com",
    strat_placeholder_keywords: "scarpe da corsa, scarpe nike, adidas...",
    strat_kw_hint: "Separati da virgola. Max 6 parole chiave.",
    strat_submit: "Genera strategia di 30 giorni",
    strat_loading: "AI in analisi... (~15–30s)",
    strat_err_both: "Inserisci entrambi i domini",
    strat_err_generic: "Generazione fallita",
    strat_gap_title: "📊 Analisi del Gap Attuale",
    strat_share: "Condividi",
    strat_copied: "Copiato!",
    strat_gap_score: "Punteggio SEO",
    strat_gap_keywords: "Parole chiave nelle TOP 100",
    strat_gap_ai_vis: "Visibilità AI %",
    strat_you: "Tu",
    strat_competitor: "Concorrente",
    strat_advantages_title: "🔥 I tuoi vantaggi sleali",
    strat_week_label: "Settimana",
    strat_forecast_title: "🎯 Risultato previsto (30 giorni)",
    strat_forecast_traffic: "Traffico organico",
    strat_forecast_position: "Posizione target",
    strat_forecast_ai_vis: "Visibilità AI",
    strat_upgrade: "Aggiorna a PRO",
  },
  nl: {
    laf_live: "LIVE",
    laf_online: "online",
    laf_from: "van",
    laf_verified: "Geverifyerd",
    laf_just_now: "zojuist",
    laf_seconds_ago: "{n}s geleden",
    laf_minutes_ago: "{n}m geleden",
    laf_hours_ago: "{n}u geleden",
    faqs_tag: "FAQ",
    faqs_title: "Veelgestelde vragen",
    faqs_subtitle: "Alles wat je moet weten voor je eerste scan",
    faqs_contact: "Meer hulp nodig? Mail ons op",
    faqs_q1: "Hoe onderscheiden jullie je van SEMrush en Ahrefs?",
    faqs_a1: "SEMrush kost vanaf €119/maand en volgt alleen Google. Voor €49/maand dekken we Google + ChatGPT + Perplexity + Claude + Gemini — waar mensen daadwerkelijk zoeken in 2026. Bovendien schrijft de PulseAI Engine™ concrete stap-voor-stap aanbevelingen voor jou.",
    faqs_q2: "Is de eerste scan echt gratis?",
    faqs_a2: "Ja, geen creditcard vereist. Je krijgt een compleet SEO + GEO rapport voor 1 domein + 3 AI aanbevelingen. Plak gewoon je URL en voer een scan uit.",
    faqs_q3: "Moet ik technisch iets weten van SEO?",
    faqs_a3: "Nee. De PulseAI Engine™ schrijft een exacte stap-voor-stap actieplan ('verander titel naar X', 'voeg keyword Y toe'). Gewoon kopiëren en plakken. Geen programmeren.",
    faqs_q4: "Hoe lang duurt het voordat ik resultaten zie?",
    faqs_a4: "Eerste rangschikking verbeteringen binnen 7–14 dagen. AI zichtbaarheid (ChatGPT / Perplexity vermeldingen) binnen 3–5 dagen. De meeste klanten zien +40% verkeer binnen 30 dagen.",
    faqs_q5: "Werkt het voor lokale / EU-markten?",
    faqs_a5: "Ja, volledige ondersteuning voor 26 talen waaronder SK, CZ, PL, HU, DE. Onze LLM genereert aanbevelingen direct in jouw taal en houdt rekening met lokale SEO specificaties.",
    faqs_q6: "Kan ik op elk moment annuleren?",
    faqs_a6: "Ja, met één klik in je dashboard. Geen annuleringskosten. 30-dagen geld-terug-garantie als je niet tevreden bent.",
    faqs_q7: "Hebben jullie WordPress / Shopify integratie?",
    faqs_a7: "WordPress-plugin (gratis download) past automatisch schema markup en meta tags toe. Shopify-app komt in Q2 2026.",
    faqs_q8: "Wat als een concurrent mijn domein scant?",
    faqs_a8: "Scannen is openbaar (iedereen kan elke URL scannen). Jouw gegevens, keywords en strategieën zijn privé en versleuteld — alleen jij hebt toegang via jouw account.",
    faqs_q9: "Wat is jullie garantie?",
    faqs_a9: "30-dagen geld-terug-garantie, zonder gedoe. Niet blij — volledige terugbetaling.",
    faqs_q10: "Hebben jullie een API?",
    faqs_a10: "Ja, het Enterprise-plan bevat REST API + webhooks voor integratie met jouw interne tools, CRM, of BI dashboards.",
    sleep_tag: "Automatisering 24/7",
    sleep_title_a: "Terwijl je slaapt,",
    sleep_title_b: "werkt PulseAI",
    sleep_subtitle: "Elke nacht om 3:00 AM voert jouw AI-assistent automatisch 6 kritieke taken uit. Je opent je e-mail in de ochtend — 17 nieuwe verbeteringen wachten op goedkeuring met 1 klik.",
    sleep_highlight: "17 nieuwe verbeteringen wachten op goedkeuring met 1 klik.",
    sleep_check_1: "Scant 100% van je pagina's",
    sleep_check_2: "Controleert 47 AI-platforms (ChatGPT, Perplexity, Claude…)",
    sleep_check_3: "Genereert 5 nieuwe optimalisatie-aanbevelingen",
    sleep_check_4: "Stuur een waarschuwing als een concurrent je positie overneemt",
    sleep_check_5: "Stel een blogartikel op voor morgen",
    sleep_check_6: "Pas meta-tags aan waar CTR is gedaald",
    sleep_cta: "Laat AI voor je werken →",
    sleep_overnight: "Verbeteringen van de nacht:",
    sleep_pending: "wacht op goedkeuring",
    course_tag: "Gratis · Geen creditcard",
    course_title_a: "7 dagen naar",
    course_title_b: "#1 positie",
    course_subtitle: "Gratis e-mailcursus: 7 praktische lessen, 7 concrete taken, 1 BONUS kortingscode aan het einde.",
    course_feature_1: "7 e-mails × 5 min lezen",
    course_feature_2: "Copy-paste uitvoerbare taken",
    course_feature_bonus: "BONUS:",
    course_feature_3: "20% kortingscode bij voltooiing",
    course_email_placeholder: "jouw@email.com",
    course_submit: "Verzend →",
    course_privacy: "🔒 Geen spam · Uitschrijven met 1 klik · GDPR-vriendelijk",
    course_success: "✅ Klaar! Controleer je e-mail.",
    course_code_label: "Jouw BONUS code:",
    course_program: "7-daags programma",
    course_d1_t: "Audit in 5 minuten",
    course_d1_s: "Waar je echt staat",
    course_d2_t: "Trefwoorden die alles veranderen",
    course_d2_s: "Long-tail vs. short-tail",
    course_d3_t: "On-page SEO zonder ontwikkelaar",
    course_d3_s: "Titel, meta, H1, schema",
    course_d4_t: "Hoe in ChatGPT-antwoorden te komen",
    course_d4_s: "GEO-strategie stap-voor-stap",
    course_d5_t: "Linkbuilding strategie zonder spam",
    course_d5_s: "14 white-hat technieken",
    course_d6_t: "Technische SEO checklist",
    course_d6_s: "Snelheid, schema, mobiel",
    course_d7_t: "Jouw 90-dagen plan",
    course_d7_s: "+ BONUS: 20% kortingscode",
    course_err_invalid: "Voer een geldig e-mailadres in",
    strat_nav_title: "AI Strategie Generator",
    strat_badge: "PRO / Eerste strategie gratis",
    strat_title_a: "Hoe te",
    strat_title_b: "je concurrent te overtreffen",
    strat_title_c: "in 30 dagen",
    strat_subtitle: "PulseAI Engine™ genereert een concreet actieplan van 4 weken, afgestemd op jouw domein versus een specifieke concurrent.",
    strat_label_my: "Jouw domein",
    strat_label_competitor: "Concurrent",
    strat_label_keywords: "Doelzoekwoorden (optioneel)",
    strat_placeholder_my: "jouwdomein.com",
    strat_placeholder_competitor: "concurrent.com",
    strat_placeholder_keywords: "hardloopschoenen, nike schoenen, adidas...",
    strat_kw_hint: "Komma-gescheiden. Max 6 zoekwoorden.",
    strat_submit: "Genereer 30-dagen strategie",
    strat_loading: "AI aan het analyseren... (~15–30s)",
    strat_err_both: "Voer beide domeinen in",
    strat_err_generic: "Generatie mislukt",
    strat_gap_title: "📊 Huidige Gap Analyse",
    strat_share: "Deel",
    strat_copied: "Gekopieerd!",
    strat_gap_score: "SEO Score",
    strat_gap_keywords: "Zoekwoorden in TOP 100",
    strat_gap_ai_vis: "AI Zichtbaarheid %",
    strat_you: "Jij",
    strat_competitor: "Concurrent",
    strat_advantages_title: "🔥 Jouw oneerlijke voordelen",
    strat_week_label: "Week",
    strat_forecast_title: "🎯 Verwachte uitkomst (30 dagen)",
    strat_forecast_traffic: "Organisch verkeer",
    strat_forecast_position: "Doelpositie",
    strat_forecast_ai_vis: "AI Zichtbaarheid",
    strat_upgrade: "Upgrade naar PRO",
  },
  sv: {
    laf_live: "LIVE",
    laf_online: "online",
    laf_from: "från",
    laf_verified: "Verifierad",
    laf_just_now: "nyss",
    laf_seconds_ago: "för {n}s sedan",
    laf_minutes_ago: "för {n}m sedan",
    laf_hours_ago: "för {n}h sedan",
    faqs_tag: "FAQ",
    faqs_title: "Vanligt ställda frågor",
    faqs_subtitle: "Allt du behöver veta innan din första skanning",
    faqs_contact: "Behöver du mer? Mejla oss på",
    faqs_q1: "Hur skiljer ni er från SEMrush och Ahrefs?",
    faqs_a1: "SEMrush kostar från €119/månad och spårar endast Google. För €49/månad täcker vi Google + ChatGPT + Perplexity + Claude + Gemini — där människor faktiskt söker 2026. Dessutom skriver PulseAI Engine™ konkreta steg-för-steg-rekommendationer för dig.",
    faqs_q2: "Är den första skanningen verkligen gratis?",
    faqs_a2: "Ja, ingen kreditkort krävs. Du får en komplett SEO + GEO-rapport för 1 domän + 3 AI-rekommendationer. Klistra bara in din URL och kör en skanning.",
    faqs_q3: "Måste jag kunna SEO tekniskt?",
    faqs_a3: "Nej. PulseAI Engine™ skriver en exakt steg-för-steg handlingsplan ('ändra titel till X', 'lägg till nyckelord Y'). Klistra bara in. Ingen programmering.",
    faqs_q4: "Hur länge tar det innan jag ser resultat?",
    faqs_a4: "Första rankingförbättringarna inom 7–14 dagar. AI-synlighet (ChatGPT / Perplexity nämner) inom 3–5 dagar. De flesta kunder ser +40% trafik inom 30 dagar.",
    faqs_q5: "Fungerar det för lokala / EU-marknader?",
    faqs_a5: "Ja, fullt stöd för 26 språk inklusive SK, CZ, PL, HU, DE. Vår LLM genererar rekommendationer direkt på ditt språk och tar hänsyn till lokala SEO-specifika.",
    faqs_q6: "Kan jag avbryta när som helst?",
    faqs_a6: "Ja, ett klick i din instrumentpanel. Inga avbokningsavgifter. 30-dagars pengarna-tillbaka-garanti om du inte är nöjd.",
    faqs_q7: "Har ni WordPress / Shopify-integration?",
    faqs_a7: "WordPress-plugin (gratis nedladdning) tillämpar automatiskt schema markup och meta-taggar. Shopify-app kommer Q2 2026.",
    faqs_q8: "Vad händer om en konkurrent skannar min domän?",
    faqs_a8: "Skanning är offentlig (vem som helst kan skanna vilken URL som helst). Dina data, nyckelord och strategier är privata och krypterade — endast du har tillgång via ditt konto.",
    faqs_q9: "Vad är er garanti?",
    faqs_a9: "30-dagars pengarna-tillbaka-garanti, inga frågor ställda. Inte nöjd — full återbetalning.",
    faqs_q10: "Har ni en API?",
    faqs_a10: "Ja, Enterprise-planen inkluderar REST API + webhooks för integration med dina interna verktyg, CRM eller BI-dashboards.",
    sleep_tag: "Automatisering 24/7",
    sleep_title_a: "När du sover,",
    sleep_title_b: "arbetar PulseAI",
    sleep_subtitle: "Varje natt klockan 03:00 kör din AI-assistent automatiskt 6 kritiska uppgifter. Du öppnar din e-post på morgonen – 17 nya förbättringar väntar på att godkännas med ett klick.",
    sleep_highlight: "17 nya förbättringar väntande på godkännande med ett klick.",
    sleep_check_1: "Skannar 100% av dina sidor",
    sleep_check_2: "Kontrollerar 47 AI-plattformar (ChatGPT, Perplexity, Claude…)",
    sleep_check_3: "Genererar 5 nya optimeringsrekommendationer",
    sleep_check_4: "Skickar en varning om en konkurrent tar över din position",
    sleep_check_5: "Utformar en bloggartikel för imorgon",
    sleep_check_6: "Justerar meta-taggar där CTR har minskat",
    sleep_cta: "Låt AI jobba för dig →",
    sleep_overnight: "Förbättringar över natten:",
    sleep_pending: "väntar på godkännande",
    course_tag: "Gratis · Ingen kreditkort",
    course_title_a: "7 dagar till",
    course_title_b: "#1 position",
    course_subtitle: "Gratis e-postkurs: 7 praktiska lektioner, 7 konkreta uppgifter, 1 BONUS rabattkod i slutet.",
    course_feature_1: "7 mejl × 5 min läsning",
    course_feature_2: "Kopiera och klistra in handlingsbara uppgifter",
    course_feature_bonus: "BONUS:",
    course_feature_3: "20% rabattkod vid slutförande",
    course_email_placeholder: "din@email.com",
    course_submit: "Skicka →",
    course_privacy: "🔒 Ingen spam · Avsluta med 1 klick · GDPR-vänlig",
    course_success: "✅ Klart! Kolla din e-post.",
    course_code_label: "Din BONUS kod:",
    course_program: "7-dagarsprogram",
    course_d1_t: "Granskning på 5 minuter",
    course_d1_s: "Var du verkligen står",
    course_d2_t: "Nyckelord som förändrar allt",
    course_d2_s: "Long-tail vs. short-tail",
    course_d3_t: "On-page SEO utan en utvecklare",
    course_d3_s: "Titel, meta, H1, schema",
    course_d4_t: "Hur man kommer in i ChatGPT-svar",
    course_d4_s: "GEO-strategi steg för steg",
    course_d5_t: "Backlinkstrategi utan spam",
    course_d5_s: "14 white-hat tekniker",
    course_d6_t: "Teknisk SEO-checklista",
    course_d6_s: "Hastighet, schema, mobil",
    course_d7_t: "Din 90-dagarsplan",
    course_d7_s: "+ BONUS: 20% rabattkod",
    course_err_invalid: "Vänligen ange en giltig e-post",
    strat_nav_title: "AI Strategigenerator",
    strat_badge: "PRO / Gratis första strategi",
    strat_title_a: "Hur man",
    strat_title_b: "slår din konkurrent",
    strat_title_c: "på 30 dagar",
    strat_subtitle: "PulseAI Engine™ genererar en konkret 4-veckors handlingsplan anpassad till din domän kontra en specifik konkurrent.",
    strat_label_my: "Din domän",
    strat_label_competitor: "Konkurrent",
    strat_label_keywords: "Målnyckelord (valfritt)",
    strat_placeholder_my: "dindoman.com",
    strat_placeholder_competitor: "konkurrent.com",
    strat_placeholder_keywords: "löparskor, nike skor, adidas...",
    strat_kw_hint: "Komma-separerat. Max 6 nyckelord.",
    strat_submit: "Generera 30-dagars strategi",
    strat_loading: "AI analyserar... (~15–30s)",
    strat_err_both: "Ange båda domänerna",
    strat_err_generic: "Generering misslyckades",
    strat_gap_title: "📊 Aktuell Gap Analys",
    strat_share: "Dela",
    strat_copied: "Kopierad!",
    strat_gap_score: "SEO-poäng",
    strat_gap_keywords: "Nyckelord i TOP 100",
    strat_gap_ai_vis: "AI Synlighet %",
    strat_you: "Du",
    strat_competitor: "Konkurrent",
    strat_advantages_title: "🔥 Dina orättvisa fördelar",
    strat_week_label: "Vecka",
    strat_forecast_title: "🎯 Förväntat resultat (30 dagar)",
    strat_forecast_traffic: "Organisk trafik",
    strat_forecast_position: "Målt position",
    strat_forecast_ai_vis: "AI Synlighet",
    strat_upgrade: "Uppgradera till PRO",
  },
  no: {
    laf_live: "LIVE",
    laf_online: "online",
    laf_from: "fra",
    laf_verified: "Verifisert",
    laf_just_now: "nettopp nå",
    laf_seconds_ago: "for {n}s siden",
    laf_minutes_ago: "for {n}m siden",
    laf_hours_ago: "for {n}h siden",
    faqs_tag: "FAQ",
    faqs_title: "Vanlige spørsmål",
    faqs_subtitle: "Alt du trenger å vite før ditt første søk",
    faqs_contact: "Trenger du mer? Send oss en e-post på",
    faqs_q1: "Hvordan skiller dere dere fra SEMrush og Ahrefs?",
    faqs_a1: "SEMrush koster fra €119/måned og sporer kun Google. For €49/måned dekker vi Google + ChatGPT + Perplexity + Claude + Gemini — der folk faktisk søker i 2026. I tillegg skriver PulseAI Engine™ konkrete trinnvise anbefalinger for deg.",
    faqs_q2: "Er det første søket virkelig gratis?",
    faqs_a2: "Ja, ingen kredittkort er nødvendig. Du får en komplett SEO + GEO-rapport for 1 domene + 3 AI-anbefalinger. Bare lim inn nettadressen din og kjør et søk.",
    faqs_q3: "Må jeg vite noe om SEO teknisk?",
    faqs_a3: "Nei. PulseAI Engine™ skriver en nøyaktig trinn-for-trinn handlingsplan ('endre tittel til X', 'legg til nøkkelord Y'). Bare kopier og lim inn. Null programmering.",
    faqs_q4: "Hvor lenge til jeg ser resultater?",
    faqs_a4: "Første rangeringforbedringer innen 7–14 dager. AI-synlighet (ChatGPT / Perplexity omtaler) innen 3–5 dager. De fleste kunder ser +40% trafikk innen 30 dager.",
    faqs_q5: "Fungerer det for lokale / EU-markeder?",
    faqs_a5: "Ja, full støtte for 26 språk inkludert SK, CZ, PL, HU, DE. Vår LLM genererer anbefalinger direkte på ditt språk og tar hensyn til lokale SEO-spesifikasjoner.",
    faqs_q6: "Kan jeg kansellere når som helst?",
    faqs_a6: "Ja, ett klikk i dashbordet ditt. Ingen avbestillingsgebyrer. 30-dagers pengene-tilbake-garanti hvis du ikke er fornøyd.",
    faqs_q7: "Har dere WordPress / Shopify-integrasjon?",
    faqs_a7: "WordPress-plugin (gratis nedlasting) anvender automatisk schema markup og meta tags. Shopify-app kommer Q2 2026.",
    faqs_q8: "Hva om en konkurrent skanner domenet mitt?",
    faqs_a8: "Skanning er offentlig (alle kan skanne hvilken som helst URL). Dine data, nøkkelord og strategier er private og krypterte — bare du har tilgang via kontoen din.",
    faqs_q9: "Hva er deres garanti?",
    faqs_a9: "30-dagers pengene-tilbake-garanti, ingen spørsmål stilt. Ikke fornøyd — full refusjon.",
    faqs_q10: "Har dere en API?",
    faqs_a10: "Ja, Enterprise-planen inkluderer REST API + webhooks for integrasjon med dine interne verktøy, CRM eller BI-dashbord.",
    sleep_tag: "Automatisering 24/7",
    sleep_title_a: "Mens du sover,",
    sleep_title_b: "arbeider PulseAI",
    sleep_subtitle: "Hver natt kl. 03:00 kjører din AI-assistent automatisk 6 kritiske oppgaver. Du åpner e-posten din om morgenen — 17 nye forbedringer venter på 1-klikk godkjenning.",
    sleep_highlight: "17 nye forbedringer venter på 1-klikk godkjenning.",
    sleep_check_1: "Skanner 100% av sidene dine",
    sleep_check_2: "Sjekker 47 AI-plattformer (ChatGPT, Perplexity, Claude…)",
    sleep_check_3: "Genererer 5 nye optimaliseringsanbefalinger",
    sleep_check_4: "Sender varsling hvis en konkurrent overtar din posisjon",
    sleep_check_5: "Skisser et blogginnlegg for i morgen",
    sleep_check_6: "Justerer metatagger der CTR har falt",
    sleep_cta: "La AI jobbe for deg →",
    sleep_overnight: "Forbedringer over natten:",
    sleep_pending: "venter på godkjenning",
    course_tag: "Gratis · Ingen kredittkort",
    course_title_a: "7 dager til",
    course_title_b: "#1 posisjon",
    course_subtitle: "Gratis e-postkurs: 7 praktiske leksjoner, 7 konkrete oppgaver, 1 BONUS rabattkode på slutten.",
    course_feature_1: "7 e-poster × 5 min lesing",
    course_feature_2: "Kopier-og-lim handlingsbare oppgaver",
    course_feature_bonus: "BONUS:",
    course_feature_3: "20% rabattkode ved fullføring",
    course_email_placeholder: "din@email.com",
    course_submit: "Send →",
    course_privacy: "🔒 Ingen spam · Avmeld med 1 klikk · GDPR-vennlig",
    course_success: "✅ Ferdig! Sjekk e-posten din.",
    course_code_label: "Din BONUS kode:",
    course_program: "7-dagers program",
    course_d1_t: "Revisjon på 5 minutter",
    course_d1_s: "Hvor du egentlig står",
    course_d2_t: "Nøkkelord som endrer alt",
    course_d2_s: "Langhale vs. korthale",
    course_d3_t: "On-page SEO uten utvikler",
    course_d3_s: "Tittel, meta, H1, skjema",
    course_d4_t: "Hvordan komme inn i ChatGPT-svar",
    course_d4_s: "GEO-strategi steg-for-steg",
    course_d5_t: "Backlink-strategi uten spam",
    course_d5_s: "14 hvit-hatt teknikker",
    course_d6_t: "Teknisk SEO sjekkliste",
    course_d6_s: "Hastighet, skjema, mobil",
    course_d7_t: "Din 90-dagers plan",
    course_d7_s: "+ BONUS: 20% rabattkode",
    course_err_invalid: "Vennligst skriv inn en gyldig e-post",
    strat_nav_title: "AI Strategi Generator",
    strat_badge: "PRO / Gratis første strategi",
    strat_title_a: "Hvordan",
    strat_title_b: "overgå din konkurrent",
    strat_title_c: "på 30 dager",
    strat_subtitle: "PulseAI Engine™ genererer en konkret 4-ukers handlingsplan skreddersydd for ditt domene vs. en spesifikk konkurrent.",
    strat_label_my: "Ditt domene",
    strat_label_competitor: "Konkurrent",
    strat_label_keywords: "Målord (valgfritt)",
    strat_placeholder_my: "dittdomene.com",
    strat_placeholder_competitor: "konkurrent.com",
    strat_placeholder_keywords: "løpesko, nike sko, adidas...",
    strat_kw_hint: "Skilte med komma. Maks 6 søkeord.",
    strat_submit: "Generer 30-dagers strategi",
    strat_loading: "AI analyserer... (~15–30s)",
    strat_err_both: "Angi begge domener",
    strat_err_generic: "Generering mislyktes",
    strat_gap_title: "📊 Nåværende Gap Analyse",
    strat_share: "Del",
    strat_copied: "Kopiert!",
    strat_gap_score: "SEO Poeng",
    strat_gap_keywords: "Søkeord i TOPP 100",
    strat_gap_ai_vis: "AI Synlighet %",
    strat_you: "Du",
    strat_competitor: "Konkurrent",
    strat_advantages_title: "🔥 Dine urettferdige fordeler",
    strat_week_label: "Uke",
    strat_forecast_title: "🎯 Forutsagt resultat (30 dager)",
    strat_forecast_traffic: "Organisk trafikk",
    strat_forecast_position: "Målposisjon",
    strat_forecast_ai_vis: "AI Synlighet",
    strat_upgrade: "Oppgrader til PRO",
  },
  da: {
    laf_live: "LIVE",
    laf_online: "online",
    laf_from: "fra",
    laf_verified: "Verificeret",
    laf_just_now: "lige nu",
    laf_seconds_ago: "{n}s siden",
    laf_minutes_ago: "{n}m siden",
    laf_hours_ago: "{n}t siden",
    faqs_tag: "FAQ",
    faqs_title: "Ofte stillede spørgsmål",
    faqs_subtitle: "Alt hvad du behøver at vide før din første scanning",
    faqs_contact: "Har du brug for mere? Skriv til os på",
    faqs_q1: "Hvordan adskiller I jer fra SEMrush og Ahrefs?",
    faqs_a1: "SEMrush koster fra €119/md. og tracker kun Google. For €49/md. dækker vi Google + ChatGPT + Perplexity + Claude + Gemini — hvor folk faktisk søger i 2026. Derudover skriver PulseAI Engine™ konkrete trin-for-trin anbefalinger til dig.",
    faqs_q2: "Er den første scanning virkelig gratis?",
    faqs_a2: "Ja, ingen kreditkort kræves. Du får en komplet SEO + GEO rapport for 1 domæne + 3 AI anbefalinger. Bare indsæt din URL og kør en scanning.",
    faqs_q3: "Skal jeg have teknisk viden om SEO?",
    faqs_a3: "Nej. PulseAI Engine™ skriver en præcis trin-for-trin handlingsplan ('ændr titel til X', 'tilføj nøgleord Y'). Bare copy-paste. Ingen programmering.",
    faqs_q4: "Hvor lang tid tager det, før jeg ser resultater?",
    faqs_a4: "Første rangforbedringer inden for 7–14 dage. AI synlighed (ChatGPT / Perplexity nævnelser) inden for 3–5 dage. De fleste kunder ser +40% trafik inden for 30 dage.",
    faqs_q5: "Virker det for lokale / EU markeder?",
    faqs_a5: "Ja, fuld support for 26 sprog, herunder SK, CZ, PL, HU, DE. Vores LLM genererer anbefalinger direkte på dit sprog og tager højde for lokale SEO specifikationer.",
    faqs_q6: "Kan jeg annullere når som helst?",
    faqs_a6: "Ja, et klik i dit dashboard. Ingen annulleringsgebyrer. 30-dages pengene-tilbage garanti, hvis du ikke er tilfreds.",
    faqs_q7: "Har I WordPress / Shopify integration?",
    faqs_a7: "WordPress-plugin (gratis download) anvender automatisk schema markup og meta-tags. Shopify appen kommer i Q2 2026.",
    faqs_q8: "Hvad hvis en konkurrent scanner mit domæne?",
    faqs_a8: "Scanning er offentlig (alle kan scanne enhver URL). Dine data, nøgleord og strategier er private og krypterede — kun du har adgang via din konto.",
    faqs_q9: "Hvad er jeres garanti?",
    faqs_a9: "30-dages pengene-tilbage garanti, uden spørgsmål. Ikke tilfreds — fuld refundering.",
    faqs_q10: "Har I en API?",
    faqs_a10: "Ja, Enterprise planen inkluderer REST API + webhooks til integration med dine interne værktøjer, CRM, eller BI dashboards.",
    sleep_tag: "Automatisering 24/7",
    sleep_title_a: "Mens du sover,",
    sleep_title_b: "arbejder PulseAI",
    sleep_subtitle: "Hver nat kl. 3:00 AM udfører din AI-assistent automatisk 6 kritiske opgaver. Du åbner din e-mail om morgenen — 17 nye forbedringer venter på 1-klicke godkendelse.",
    sleep_highlight: "17 nye forbedringer venter på 1-klicke godkendelse.",
    sleep_check_1: "Scanner 100% af dine sider",
    sleep_check_2: "Tjekker 47 AI-platforme (ChatGPT, Perplexity, Claude…)",
    sleep_check_3: "Genererer 5 nye optimeringsanbefalinger",
    sleep_check_4: "Sender en advarsel, hvis en konkurrent overhaler din placering",
    sleep_check_5: "Udkast til et blogartikel til i morgen",
    sleep_check_6: "Justerer meta-tags, hvor CTR er faldet",
    sleep_cta: "Lad AI arbejde for dig →",
    sleep_overnight: "Forbedringer over natten:",
    sleep_pending: "venter på godkendelse",
    course_tag: "Gratis · Ingen kreditkort",
    course_title_a: "7 dage til",
    course_title_b: "1. plads",
    course_subtitle: "Gratis e-mailkursus: 7 praktiske lektioner, 7 konkrete opgaver, 1 BONUS rabatkode til slut.",
    course_feature_1: "7 e-mails × 5 min læsning",
    course_feature_2: "Kopier-og-indsæt handlingsorienterede opgaver",
    course_feature_bonus: "BONUS:",
    course_feature_3: "20% rabatkode ved gennemførelse",
    course_email_placeholder: "din@email.com",
    course_submit: "Send →",
    course_privacy: "🔒 Ingen spam · Afmeld med 1 klik · GDPR-venlig",
    course_success: "✅ Færdig! Tjek din e-mail.",
    course_code_label: "Din BONUSkode:",
    course_program: "7-dages program",
    course_d1_t: "Revision på 5 minutter",
    course_d1_s: "Hvor du virkelig står",
    course_d2_t: "Nøgleord der ændrer alt",
    course_d2_s: "Long-tail vs. short-tail",
    course_d3_t: "On-page SEO uden udvikler",
    course_d3_s: "Titel, meta, H1, schema",
    course_d4_t: "Hvordan man kommer ind i ChatGPT-svar",
    course_d4_s: "GEO-strategi trin-for-trin",
    course_d5_t: "Backlink-strategi uden spam",
    course_d5_s: "14 white-hat teknikker",
    course_d6_t: "Teknisk SEO tjekliste",
    course_d6_s: "Hastighed, schema, mobil",
    course_d7_t: "Din 90-dages plan",
    course_d7_s: "+ BONUS: 20% rabatkode",
    course_err_invalid: "Indtast venligst en gyldig e-mail",
    strat_nav_title: "AI Strategi Generator",
    strat_badge: "PRO / Gratis første strategi",
    strat_title_a: "Hvordan man",
    strat_title_b: "overhaler din konkurrent",
    strat_title_c: "på 30 dage",
    strat_subtitle: "PulseAI Engine™ genererer en konkret 4-ugers handlingsplan skræddersyet til dit domæne vs. en specifik konkurrent.",
    strat_label_my: "Dit domæne",
    strat_label_competitor: "Konkurrent",
    strat_label_keywords: "Målrettede søgeord (valgfrit)",
    strat_placeholder_my: "ditdomæne.com",
    strat_placeholder_competitor: "konkurrent.com",
    strat_placeholder_keywords: "løbesko, nike sko, adidas...",
    strat_kw_hint: "Kommaseparerede. Maks 6 søgeord.",
    strat_submit: "Generer 30-dages strategi",
    strat_loading: "AI analyserer... (~15–30s)",
    strat_err_both: "Indtast begge domæner",
    strat_err_generic: "Generering fejlede",
    strat_gap_title: "📊 Aktuel Gap Analyse",
    strat_share: "Del",
    strat_copied: "Kopieret!",
    strat_gap_score: "SEO Score",
    strat_gap_keywords: "Søgeord i TOP 100",
    strat_gap_ai_vis: "AI Synlighed %",
    strat_you: "Du",
    strat_competitor: "Konkurrent",
    strat_advantages_title: "🔥 Dine uretfærdige fordele",
    strat_week_label: "Uge",
    strat_forecast_title: "🎯 Forudsigte resultat (30 dage)",
    strat_forecast_traffic: "Organisk trafik",
    strat_forecast_position: "Målposition",
    strat_forecast_ai_vis: "AI Synlighed",
    strat_upgrade: "Opgradér til PRO",
  },
  fi: {
    laf_live: "REILLY",
    laf_online: "verkkossa",
    laf_from: "alkaen",
    laf_verified: "Vahvistettu",
    laf_just_now: "juuri nyt",
    laf_seconds_ago: "{n}s sitten",
    laf_minutes_ago: "{n}m sitten",
    laf_hours_ago: "{n}h sitten",
    faqs_tag: "UKK",
    faqs_title: "Usein kysytyt kysymykset",
    faqs_subtitle: "Kaikki mitä sinun tarvitsee tietää ennen ensimmäistä skannaustasi",
    faqs_contact: "Tarvitsetko lisää? Lähetä sähköpostia osoitteeseen",
    faqs_q1: "Miten erotutte SEMrushista ja Ahrefsista?",
    faqs_a1: "SEMrush maksaa alkaen €119/kuukausi ja seuraa vain Googlea. Meidän €49/kuukauden palvelumme kattaa Google + ChatGPT + Perplexity + Claude + Gemini — missä ihmiset oikeasti etsivät tietoa vuonna 2026. Lisäksi PulseAI Engine™ kirjoittaa konkreettisia vaiheittaisia suosituksia sinulle.",
    faqs_q2: "Onko ensimmäinen skannaus oikeasti ilmainen?",
    faqs_a2: "Kyllä, luottokorttia ei vaadita. Saat täydellisen SEO + GEO -raportin yhdelle verkkotunnukselle + 3 AI-suositusta. Liitä vain URL-osoitteesi ja suorita skannaus.",
    faqs_q3: "Tarvitseeko minun tuntea SEO teknisesti?",
    faqs_a3: "Ei tarvitse. PulseAI Engine™ kirjoittaa tarkan vaiheittaisen toimintasuunnitelman ('muuta otsikko X:ksi', 'lisää avainsana Y'). Kopioi ja liitä. Ei ohjelmointia.",
    faqs_q4: "Kuinka kauan ennen kuin näen tuloksia?",
    faqs_a4: "Ensimmäiset sijoitusparannukset 7–14 päivän sisällä. AI-näkyvyys (ChatGPT / Perplexity maininnat) 3–5 päivän sisällä. Useimmat asiakkaat näkevät +40 % liikennettä 30 päivän sisällä.",
    faqs_q5: "Toimiiko se paikallisilla / EU-markkinoilla?",
    faqs_a5: "Kyllä, täysi tuki 26 kielelle mukaan lukien SK, CZ, PL, HU, DE. LLM:ämme tuottaa suosituksia suoraan kielelläsi ottaen huomioon paikallisen SEO-specifikaation.",
    faqs_q6: "Voinko peruuttaa milloin tahansa?",
    faqs_a6: "Kyllä, yksi napsautus hallintapaneelissasi. Ei peruutusmaksuja. 30 päivän rahat takaisin -takuu, jos et ole tyytyväinen.",
    faqs_q7: "Onko teillä WordPress / Shopify -integraatio?",
    faqs_a7: "WordPress-laajennus (ilmainen lataus) soveltaa automaattisesti schema markupia ja meta-tageja. Shopify-sovellus tulee Q2 2026.",
    faqs_q8: "Entä jos kilpailija skannaa verkkotunnukseni?",
    faqs_a8: "Skannaus on julkista (kuka tahansa voi skannata minkä tahansa URL-osoitteen). Tiedot, avainsanat ja strategiat ovat yksityisiä ja salattuja — vain sinulla on pääsy tilisi kautta.",
    faqs_q9: "Mikä on takuunne?",
    faqs_a9: "30 päivän rahat takaisin -takuu, ilman kysymyksiä. Jos et ole tyytyväinen — täysi palautus.",
    faqs_q10: "Onko teillä API?",
    faqs_a10: "Kyllä, Enterprise-suunnitelma sisältää REST API:n + webhooksin integroimiseen sisäisiin työkaluihisi, CRM:ään tai BI-ohjauspaneeleihin.",
    sleep_tag: "Automaatiota 24/7",
    sleep_title_a: "Kun nukut,",
    sleep_title_b: "PulseAI työskentelee",
    sleep_subtitle: "Joka yö kello 3:00 AI-assistenttisi suorittaa automaattisesti 6 kriittistä tehtävää. Avasit sähköpostisi aamulla — 17 uutta parannusta odottaa yhden napsautuksen hyväksyntää.",
    sleep_highlight: "17 uutta parannusta odottaa yhden napsautuksen hyväksyntää.",
    sleep_check_1: "Skannaa 100 % sivuistasi",
    sleep_check_2: "Tarkistaa 47 AI-alustaa (ChatGPT, Perplexity, Claude…)",
    sleep_check_3: "Tuottaa 5 uutta optimointisuositusta",
    sleep_check_4: "Lähettää ilmoituksen, jos kilpailija ohittaa sijaintisi",
    sleep_check_5: "Laatii blogikirjoituksen huomiseksi",
    sleep_check_6: "Säättää meta-tunnisteita, joissa CTR on laskenut",
    sleep_cta: "Anna AI:n tehdä työt puolestasi →",
    sleep_overnight: "Yön aikana tapahtuvat parannukset:",
    sleep_pending: "odottaa hyväksyntää",
    course_tag: "Ilmainen · Ei luottokorttia",
    course_title_a: "7 päivää kohti",
    course_title_b: "#1 sijaa",
    course_subtitle: "Ilmainen sähköpostikurssi: 7 käytännön oppituntia, 7 konkreettista tehtävää, 1 BONUS alennuskoodi lopuksi.",
    course_feature_1: "7 sähköpostia × 5 min lukuaika",
    course_feature_2: "Kopioi-liitä käytännön tehtävät",
    course_feature_bonus: "BONUS:",
    course_feature_3: "20% alennuskoodi valmistumisen yhteydessä",
    course_email_placeholder: "sinun@email.com",
    course_submit: "Lähetä →",
    course_privacy: "🔒 Ei roskapostia · Peruutus yhdellä klikillä · GDPR-yhteensopiva",
    course_success: "✅ Valmis! Tarkista sähköpostisi.",
    course_code_label: "BONUS-koodisi:",
    course_program: "7 päivän ohjelma",
    course_d1_t: "Auditointi 5 minuutissa",
    course_d1_s: "Missä todella seisot",
    course_d2_t: "Avainsanat, jotka muuttavat kaiken",
    course_d2_s: "Pitkäkuonoiset vs. lyhyet",
    course_d3_t: "On-page SEO ilman kehittäjää",
    course_d3_s: "Otsikko, meta, H1, schema",
    course_d4_t: "Kuinka päästä mukaan ChatGPT:n vastauksiin",
    course_d4_s: "GEO-strategia vaihe vaiheelta",
    course_d5_t: "Taustalinkkistrategia ilman roskapostia",
    course_d5_s: "14 valkoisen hatun tekniikkaa",
    course_d6_t: "Tekninen SEO-tarkistuslista",
    course_d6_s: "Nopeus, schema, mobiili",
    course_d7_t: "90 päivän suunnitelmasi",
    course_d7_s: "+ BONUS: 20% alennuskoodi",
    course_err_invalid: "Ole hyvä ja syötä voimassa oleva sähköposti",
    strat_nav_title: "AI Strategiageneraattori",
    strat_badge: "PRO / Ilmainen ensimmäinen strategia",
    strat_title_a: "Kuinka",
    strat_title_b: "ohittaa kilpailijasi",
    strat_title_c: "30 päivässä",
    strat_subtitle: "PulseAI Engine™ luo konkreettisen 4 viikon toimintasuunnitelman, joka on mukautettu sinun verkkotunnuksellesi verrattuna tiettyyn kilpailijaan.",
    strat_label_my: "Sinun verkkotunnus",
    strat_label_competitor: "Kilpailija",
    strat_label_keywords: "Kohdesanat (valinnainen)",
    strat_placeholder_my: "yourdomain.com",
    strat_placeholder_competitor: "kilpailija.com",
    strat_placeholder_keywords: "juoksu kengät, nike kengät, adidas...",
    strat_kw_hint: "Erottele pilkuilla. Max 6 avainsanaa.",
    strat_submit: "Luo 30 päivän strategia",
    strat_loading: "AI analysoi... (~15–30s)",
    strat_err_both: "Syötä molemmat verkkotunnukset",
    strat_err_generic: "Generointi epäonnistui",
    strat_gap_title: "📊 Nykyinen aukkoanalyysi",
    strat_share: "Jaa",
    strat_copied: "Kopioitu!",
    strat_gap_score: "SEO-pisteet",
    strat_gap_keywords: "Avainsanat TOP 100:ssa",
    strat_gap_ai_vis: "AI-näkyvyys %",
    strat_you: "Sinä",
    strat_competitor: "Kilpailija",
    strat_advantages_title: "🔥 Omat epäreilut etusi",
    strat_week_label: "Viikko",
    strat_forecast_title: "🎯 Ennustettu tulos (30 päivää)",
    strat_forecast_traffic: "Orgaaninen liikenne",
    strat_forecast_position: "Kohdeasema",
    strat_forecast_ai_vis: "AI-näkyvyys",
    strat_upgrade: "Päivitä PRO:hon",
  },
  ro: {
    laf_live: "LIVE",
    laf_online: "online",
    laf_from: "de la",
    laf_verified: "Verificat",
    laf_just_now: "tocmai acum",
    laf_seconds_ago: "acum {n}s",
    laf_minutes_ago: "acum {n}m",
    laf_hours_ago: "acum {n}h",
    faqs_tag: "FAQ",
    faqs_title: "Întrebări frecvente",
    faqs_subtitle: "Tot ce trebuie să știi înainte de prima scanare",
    faqs_contact: "Ai nevoie de mai mult? Scrie-ne la",
    faqs_q1: "Cum te diferențezi de SEMrush și Ahrefs?",
    faqs_a1: "SEMrush costă de la €119/lună și urmărește doar Google. Pentru €49/lună acoperim Google + ChatGPT + Perplexity + Claude + Gemini — unde oamenii caută cu adevărat în 2026. În plus, PulseAI Engine™ scrie recomandări concrete pas cu pas pentru tine.",
    faqs_q2: "Este prima scanare chiar gratuită?",
    faqs_a2: "Da, nu este necesară o carte de credit. Obții un raport complet SEO + GEO pentru 1 domeniu + 3 recomandări AI. Pur și simplu copiază-ți URL-ul și efectuează o scanare.",
    faqs_q3: "Trebuie să știu SEO tehnic?",
    faqs_a3: "Nu. PulseAI Engine™ scrie un plan de acțiune exact pas cu pas ('schimbă titlul în X', 'adaugă cuvântul cheie Y'). Doar copiază și lipsește. Zero programare.",
    faqs_q4: "Cât durează până văd rezultate?",
    faqs_a4: "Îmbunătățiri ale clasamentului în 7–14 zile. Vizibilitate AI (mențiuni ChatGPT / Perplexity) în 3–5 zile. Cei mai mulți clienți văd +40% trafic în 30 de zile.",
    faqs_q5: "Funcționează pentru piețele locale / UE?",
    faqs_a5: "Da, suport complet pentru 26 de limbi, inclusiv SK, CZ, PL, HU, DE. LLM-ul nostru generează recomandări direct în limba ta și ține cont de specificitățile SEO locale.",
    faqs_q6: "Pot anula oricând?",
    faqs_a6: "Da, un singur clic în panoul tău de control. Nu sunt taxe de anulare. Garantiile de returnare a banilor în termen de 30 de zile dacă nu ești mulțumit.",
    faqs_q7: "Aveți integrare WordPress / Shopify?",
    faqs_a7: "Plugin-ul WordPress (descărcare gratuită) aplică automat schema markup și meta tags. Aplicația Shopify va fi disponibilă în T2 2026.",
    faqs_q8: "Ce se întâmplă dacă un competitor scanează domeniul meu?",
    faqs_a8: "Scanarea este publică (oricine poate scana orice URL). Datele, cuvintele tale cheie și strategiile sunt private și criptate — doar tu ai acces prin contul tău.",
    faqs_q9: "Care este garanția voastră?",
    faqs_a9: "Garanție de returnare a banilor în termen de 30 de zile, fără întrebări. Nu ești mulțumit — rambursare completă.",
    faqs_q10: "Aveți API?",
    faqs_a10: "Da, planul Enterprise include REST API + webhooks pentru integrarea cu uneltele tale interne, CRM sau panouri de BI.",
    sleep_tag: "Automatizare 24/7",
    sleep_title_a: "În timp ce dormi,",
    sleep_title_b: "PulseAI lucrează",
    sleep_subtitle: "În fiecare noapte la 3:00 AM, asistentul tău AI efectuează automat 6 sarcini critice. Deschizi emailul tău dimineața — 17 îmbunătățiri noi te așteaptă pentru aprobat cu un singur clic.",
    sleep_highlight: "17 îmbunătățiri noi te așteaptă pentru aprobat cu un singur clic.",
    sleep_check_1: "Scanează 100% din paginile tale",
    sleep_check_2: "Verifică 47 de platforme AI (ChatGPT, Perplexity, Claude…)",
    sleep_check_3: "Generează 5 noi recomandări de optimizare",
    sleep_check_4: "Trimite o alertă dacă un competitor îți depășește poziția",
    sleep_check_5: "Elaborează un articol de blog pentru mâine",
    sleep_check_6: "Ajustează meta tagurile unde CTR a scăzut",
    sleep_cta: "Lasă AI-ul să lucreze pentru tine →",
    sleep_overnight: "Îmbunătățiri peste noapte:",
    sleep_pending: "așteaptă aprobat",
    course_tag: "Gratuit · Fără card de credit",
    course_title_a: "7 zile pentru",
    course_title_b: "poziția #1",
    course_subtitle: "Curs gratuit pe email: 7 lecții practice, 7 sarcini concrete, 1 cod de reducere BONUS la final.",
    course_feature_1: "7 emailuri × 5 min lectură",
    course_feature_2: "Sarcini acționabile copy-paste",
    course_feature_bonus: "BONUS:",
    course_feature_3: "Cod de reducere de 20% la finalizare",
    course_email_placeholder: "your@email.com",
    course_submit: "Trimite →",
    course_privacy: "🔒 Fără spam · Dezabonare 1 click · Conforme GDPR",
    course_success: "✅ Gata! Verifică-ți emailul.",
    course_code_label: "Codul tău BONUS:",
    course_program: "Program de 7 zile",
    course_d1_t: "Audit în 5 minute",
    course_d1_s: "Unde te afli cu adevărat",
    course_d2_t: "Cuvinte cheie care schimbă totul",
    course_d2_s: "Long-tail vs. short-tail",
    course_d3_t: "SEO on-page fără dezvoltator",
    course_d3_s: "Titlu, meta, H1, schema",
    course_d4_t: "Cum să intri în răspunsurile ChatGPT",
    course_d4_s: "Strategie GEO pas cu pas",
    course_d5_t: "Strategie backlink fără spam",
    course_d5_s: "14 tehnici white-hat",
    course_d6_t: "Lista de verificare SEO tehnic",
    course_d6_s: "Viteză, schemă, mobil",
    course_d7_t: "Planul tău pe 90 de zile",
    course_d7_s: "+ BONUS: cod de reducere de 20%",
    course_err_invalid: "Te rugăm să introduci un email valid",
    strat_nav_title: "Generator de strategie AI",
    strat_badge: "PRO / Prima strategie gratuită",
    strat_title_a: "Cum să",
    strat_title_b: "depasesti competitorul",
    strat_title_c: "în 30 de zile",
    strat_subtitle: "PulseAI Engine™ generează un plan de acțiune concret pe 4 săptămâni personalizat pentru domeniul tău comparativ cu un competitor specific.",
    strat_label_my: "Domeniul tău",
    strat_label_competitor: "Competitor",
    strat_label_keywords: "Cuvinte cheie țintă (opțional)",
    strat_placeholder_my: "domeniultau.com",
    strat_placeholder_competitor: "competitor.com",
    strat_placeholder_keywords: "pantofi de alergare, pantofi nike, adidas...",
    strat_kw_hint: "Separat prin virgule. Max 6 cuvinte cheie.",
    strat_submit: "Generează strategia de 30 de zile",
    strat_loading: "AI analizează... (~15–30s)",
    strat_err_both: "Introdu ambele domenii",
    strat_err_generic: "Generarea a eșuat",
    strat_gap_title: "📊 Analiza Găpilor Actuale",
    strat_share: "Împărtășește",
    strat_copied: "Copiat!",
    strat_gap_score: "Scor SEO",
    strat_gap_keywords: "Cuvinte cheie în TOP 100",
    strat_gap_ai_vis: "Vizibilitate AI %",
    strat_you: "Tu",
    strat_competitor: "Competitor",
    strat_advantages_title: "🔥 Avantajele tale necorecte",
    strat_week_label: "Săptămână",
    strat_forecast_title: "🎯 Rezultatul preconizat (30 zile)",
    strat_forecast_traffic: "Trafic organic",
    strat_forecast_position: "Poziția țintă",
    strat_forecast_ai_vis: "Vizibilitate AI",
    strat_upgrade: "Upgrade la PRO",
  },
  bg: {
    laf_live: "НАЖИВО",
    laf_online: "онлайн",
    laf_from: "от",
    laf_verified: "Потвърден",
    laf_just_now: "току-що",
    laf_seconds_ago: "{n}с. назад",
    laf_minutes_ago: "{n}мин. назад",
    laf_hours_ago: "{n}ч. назад",
    faqs_tag: "ЧПВ",
    faqs_title: "Често задавани въпроси",
    faqs_subtitle: "Всичко, което трябва да знаете преди първото сканиране",
    faqs_contact: "Нуждаете се от повече? Пишете ни на",
    faqs_q1: "С какво се различавате от SEMrush и Ahrefs?",
    faqs_a1: "SEMrush струва от €119 на месец и проследява само Google. За €49 на месец покриваме Google + ChatGPT + Perplexity + Claude + Gemini — където хората всъщност търсят през 2026. Освен това PulseAI Engine™ пише конкретни стъпка по стъпка препоръки за вас.",
    faqs_q2: "Наистина ли първото сканиране е безплатно?",
    faqs_a2: "Да, не е необходима кредитна карта. Получавате пълен SEO + GEO доклад за 1 домейн + 3 AI препоръки. Просто поставете вашия URL и стартирайте сканиране.",
    faqs_q3: "Трябва ли да знам SEO технически?",
    faqs_a3: "Не. PulseAI Engine™ пише точен план за действие стъпка по стъпка ('смени заглавието на X', 'добави ключова дума Y'). Просто копирайте и поставете. Н Zero програмиране.",
    faqs_q4: "Колко време ще отнеме, за да видя резултати?",
    faqs_a4: "Първи подобрения в класирането в рамките на 7–14 дни. AI видимост (споменавания в ChatGPT / Perplexity) в рамките на 3–5 дни. Повечето клиенти виждат +40% трафик в рамките на 30 дни.",
    faqs_q5: "Работи ли за местни / ЕС пазари?",
    faqs_a5: "Да, пълна поддръжка за 26 езика, включително SK, CZ, PL, HU, DE. Нашият LLM генерира препоръки директно на вашия език и отчита специфики за местен SEO.",
    faqs_q6: "Мога ли да отменя по всяко време?",
    faqs_a6: "Да, един клик в таблото ви. Никаки такси за отказ. Гаранция за връщане на парите в рамките на 30 дни, ако не сте доволни.",
    faqs_q7: "Имате ли интеграция с WordPress / Shopify?",
    faqs_a7: "Плъгин за WordPress (безплатно изтегляне) автоматично прилага схема и мета тагове. Приложението за Shopify ще бъде готово през 2-то тримесечие на 2026.",
    faqs_q8: "Какво ако конкурент сканира моя домейн?",
    faqs_a8: "Сканирането е публично (всеки може да сканира всякакъв URL). Вашите данни, ключови думи и стратегии са частни и криптирани — само вие имате достъп чрез вашия акаунт.",
    faqs_q9: "Каква е вашата гаранция?",
    faqs_a9: "Гаранция за връщане на парите в рамките на 30 дни, без въпроси. Не сте доволни — пълно възстановяване.",
    faqs_q10: "Имате ли API?",
    faqs_a10: "Да, планът Enterprise включва REST API + уеб куки за интеграция с вашите вътрешни инструменти, CRM или BI табла.",
    sleep_tag: "Автоматизация 24/7",
    sleep_title_a: "Докато спите,",
    sleep_title_b: "PulseAI работи",
    sleep_subtitle: "Всяка нощ в 3:00 AM вашият AI асистент автоматично изпълнява 6 критични задачи. Отваряте имейла сутринта — 17 нови подобрения, чакащи вашето одобрение с един клик.",
    sleep_highlight: "17 нови подобрения, чакащи вашето одобрение с един клик.",
    sleep_check_1: "Сканира 100% от вашите страници",
    sleep_check_2: "Проверява 47 AI платформи (ChatGPT, Perplexity, Claude…)",
    sleep_check_3: "Генерира 5 нови препоръки за оптимизация",
    sleep_check_4: "Изпраща известие, ако конкурент ви изпревари",
    sleep_check_5: "Създава проект на блог статия за утре",
    sleep_check_6: "Коригира мета таговете, където CTR е намалял",
    sleep_cta: "Нека AI да работи за вас →",
    sleep_overnight: "Нощни подобрения:",
    sleep_pending: "очаква одобрение",
    course_tag: "Безплатно · Без кредитна карта",
    course_title_a: "7 дни до",
    course_title_b: "#1 позиция",
    course_subtitle: "Безплатен имейл курс: 7 практически урока, 7 конкретни задачи, 1 БОНУС код за отстъпка в края.",
    course_feature_1: "7 имейла × 5 мин четене",
    course_feature_2: "Копирай и поставяй приложими задачи",
    course_feature_bonus: "БОНУС:",
    course_feature_3: "20% код за отстъпка при завършване",
    course_email_placeholder: "вашият@email.com",
    course_submit: "Изпрати →",
    course_privacy: "🔒 Няма спам · Отписване с 1 клик · GDPR-съвместим",
    course_success: "✅ Готово! Проверете имейла си.",
    course_code_label: "Вашият БОНУС код:",
    course_program: "7-дневна програма",
    course_d1_t: "Аудит за 5 минути",
    course_d1_s: "Къде наистина стоите",
    course_d2_t: "Ключови думи, които променят всичко",
    course_d2_s: "Дълги и кратки ключови думи",
    course_d3_t: "On-page SEO без разработчик",
    course_d3_s: "Заглавие, мета, H1, схема",
    course_d4_t: "Как да влезете в отговорите на ChatGPT",
    course_d4_s: "GEO стратегия стъпка по стъпка",
    course_d5_t: "Стратегия за обратни връзки без спам",
    course_d5_s: "14 техники с бели шапки",
    course_d6_t: "Технически SEO списък за проверка",
    course_d6_s: "Скорост, схема, мобилно",
    course_d7_t: "Вашият 90-дневен план",
    course_d7_s: "+ БОНУС: 20% код за отстъпка",
    course_err_invalid: "Моля, въведете валиден имейл",
    strat_nav_title: "Генератор на AI стратегии",
    strat_badge: "PRO / Безплатна първа стратегия",
    strat_title_a: "Как да",
    strat_title_b: "изпреварите конкурента си",
    strat_title_c: "за 30 дни",
    strat_subtitle: "PulseAI Engine™ генерира конкретен план за действие за 4 седмици, адаптиран за вашия домейн спрямо конкретен конкурент.",
    strat_label_my: "Вашият домейн",
    strat_label_competitor: "Конкурент",
    strat_label_keywords: "Целеви ключови думи (по избор)",
    strat_placeholder_my: "вашиятдомейн.com",
    strat_placeholder_competitor: "конкурент.com",
    strat_placeholder_keywords: "бягащи обувки, nike обувки, adidas...",
    strat_kw_hint: "Разделени със запетая. Макс 6 ключови думи.",
    strat_submit: "Генерирай стратегия за 30 дни",
    strat_loading: "AI анализира... (~15–30с)",
    strat_err_both: "Въведете и двата домейна",
    strat_err_generic: "Генерацията не успя",
    strat_gap_title: "📊 Текуща анализ на пропуските",
    strat_share: "Сподели",
    strat_copied: "Копирано!",
    strat_gap_score: "SEO рейтинг",
    strat_gap_keywords: "Ключови думи в ТОП 100",
    strat_gap_ai_vis: "AI видимост %",
    strat_you: "Вие",
    strat_competitor: "Конкурент",
    strat_advantages_title: "🔥 Вашите несправедливи предимства",
    strat_week_label: "Седмица",
    strat_forecast_title: "🎯 Прогнозирани резултати (30 дни)",
    strat_forecast_traffic: "Органичен трафик",
    strat_forecast_position: "Целева позиция",
    strat_forecast_ai_vis: "AI видимост",
    strat_upgrade: "Актуализирайте до PRO",
  },
  hr: {
    laf_live: "UŽIVO",
    laf_online: "online",
    laf_from: "od",
    laf_verified: "Provjereno",
    laf_just_now: "prije trenutka",
    laf_seconds_ago: "prije {n}s",
    laf_minutes_ago: "prije {n}m",
    laf_hours_ago: "prije {n}h",
    faqs_tag: "ČPP",
    faqs_title: "Najčešća pitanja",
    faqs_subtitle: "Sve što trebate znati prije vašeg prvog skeniranja",
    faqs_contact: "Trebate više? Pošaljite nam email na",
    faqs_q1: "Kako se razlikujete od SEMrush-a i Ahrefs-a?",
    faqs_a1: "SEMrush košta od €119/mjesec i prati samo Google. Za €49/mjesec pratimo Google + ChatGPT + Perplexity + Claude + Gemini — gdje ljudi zapravo pretražuju 2026. godine. Osim toga, PulseAI Engine™ piše konkretne korak-po-korak preporuke za vas.",
    faqs_q2: "Je li prvo skeniranje stvarno besplatno?",
    faqs_a2: "Da, bez potrebe za kreditnom karticom. Dobivate potpuni SEO + GEO izvještaj za 1 domenu + 3 AI preporuke. Samo zalijepite svoj URL i pokrenite skeniranje.",
    faqs_q3: "Trebam li tehnički znati SEO?",
    faqs_a3: "Ne. PulseAI Engine™ piše točan akcijski plan korak-po-korak ('promijenite naslov u X', 'dodajte ključnu riječ Y'). Samo kopirajte i zalijepite. Nema programiranja.",
    faqs_q4: "Koliko dugo treba da vidim rezultate?",
    faqs_a4: "Prva poboljšanja rangiranja unutar 7–14 dana. AI vidljivost (spominjanje ChatGPT / Perplexity) unutar 3–5 dana. Većina korisnika vidi +40% prometa unutar 30 dana.",
    faqs_q5: "Da li to radi za lokalna / EU tržišta?",
    faqs_a5: "Da, puna podrška za 26 jezika uključujući SK, CZ, PL, HU, DE. Naš LLM generira preporuke izravno na vašem jeziku i uzima u obzir lokalne SEO specifičnosti.",
    faqs_q6: "Mogu li otkazati u bilo kojem trenutku?",
    faqs_a6: "Da, jednim klikom u vašem nadzornom panelu. Nema naknada za otkazivanje. Jamstvo povrata novca u trajanju od 30 dana ako niste zadovoljni.",
    faqs_q7: "Imate li WordPress / Shopify integraciju?",
    faqs_a7: "WordPress dodatak (besplatno preuzimanje) automatski primjenjuje shemu označavanja i meta oznake. Shopify aplikacija dolazi u Q2 2026.",
    faqs_q8: "Što ako konkurent skenira moju domenu?",
    faqs_a8: "Skeniranje je javno (svatko može skenirati bilo koji URL). Vaši podaci, ključne riječi i strategije su privatni i enkriptirani — samo vi imate pristup putem vašeg računa.",
    faqs_q9: "Koje je vaše jamstvo?",
    faqs_a9: "Jamstvo povrata novca u trajanju od 30 dana, bez postavljanja pitanja. Niste zadovoljni — puni povrat.",
    faqs_q10: "Imate li API?",
    faqs_a10: "Da, Enterprise plan uključuje REST API + webhooks za integraciju s vašim internim alatima, CRM-om ili BI nadzornim pločama.",
    sleep_tag: "Automatizacija 24/7",
    sleep_title_a: "Dok spavate,",
    sleep_title_b: "PulseAI radi",
    sleep_subtitle: "Svake noći u 3:00 AM vaš AI asistent automatski pokreće 6 kritičnih zadataka. Ujutro otvorite email — 17 novih poboljšanja čeka na odobrenje jednim klikom.",
    sleep_highlight: "17 novih poboljšanja čeka na odobrenje jednim klikom.",
    sleep_check_1: "Skenira 100% vaših stranica",
    sleep_check_2: "Provjerava 47 AI platformi (ChatGPT, Perplexity, Claude…)",
    sleep_check_3: "Generira 5 novih preporuka za optimizaciju",
    sleep_check_4: "Šalje obavijest ako konkurent preuzme vašu poziciju",
    sleep_check_5: "Priprema blog članak za sutra",
    sleep_check_6: "Podešava meta oznake gdje je CTR pao",
    sleep_cta: "Neka AI radi za vas →",
    sleep_overnight: "Poboljšanja tokom noći:",
    sleep_pending: "čeka na odobrenje",
    course_tag: "Besplatno · Nema kreditne kartice",
    course_title_a: "7 dana do",
    course_title_b: "#1 pozicije",
    course_subtitle: "Besplatni email tečaj: 7 praktičnih lekcija, 7 konkretnih zadataka, 1 BONUS kod za popust na kraju.",
    course_feature_1: "7 emailova × 5 min čitanja",
    course_feature_2: "Zadaci za kopiranje i lijepljenje",
    course_feature_bonus: "BONUS:",
    course_feature_3: "20% kod za popust na završetku",
    course_email_placeholder: "vaša@email.com",
    course_submit: "Pošalji →",
    course_privacy: "🔒 Nema spama · Odjava jednim klikom · GDPR-prijateljski",
    course_success: "✅ Gotovo! Provjerite svoj email.",
    course_code_label: "Vaš BONUS kod:",
    course_program: "7-dnevni program",
    course_d1_t: "Auditi za 5 minuta",
    course_d1_s: "Gdje se stvarno nalazite",
    course_d2_t: "Ključne riječi koje mijenjaju sve",
    course_d2_s: "Dugački vs. kratki rep",
    course_d3_t: "On-page SEO bez programera",
    course_d3_s: "Naslov, meta, H1, shema",
    course_d4_t: "Kako ući u odgovore ChatGPT-a",
    course_d4_s: "GEO strategija korak po korak",
    course_d5_t: "Backlink strategija bez spama",
    course_d5_s: "14 tehnika bijelog šešira",
    course_d6_t: "Tehnička SEO kontrolna lista",
    course_d6_s: "Brzina, shema, mobilni",
    course_d7_t: "Vaš plan za 90 dana",
    course_d7_s: "+ BONUS: 20% kod za popust",
    course_err_invalid: "Molimo unesite valjanu email adresu",
    strat_nav_title: "AI Generator strategije",
    strat_badge: "PRO / Besplatna prva strategija",
    strat_title_a: "Kako",
    strat_title_b: "prestići svog konkurenta",
    strat_title_c: "u 30 dana",
    strat_subtitle: "PulseAI Engine™ generira konkretan akcijski plan za 4 tjedna prilagođen vašoj domeni naspram specifičnog konkurenta.",
    strat_label_my: "Vaša domena",
    strat_label_competitor: "Konkurent",
    strat_label_keywords: "Ciljane ključne riječi (opcionalno)",
    strat_placeholder_my: "vasaadomena.com",
    strat_placeholder_competitor: "konkurent.com",
    strat_placeholder_keywords: "trkaće cipele, nike cipele, adidas...",
    strat_kw_hint: "Odvojene zarezom. Maksimalno 6 ključnih riječi.",
    strat_submit: "Generiraj strategiju za 30 dana",
    strat_loading: "AI analizira... (~15–30s)",
    strat_err_both: "Unesite obje domene",
    strat_err_generic: "Generiranje nije uspjelo",
    strat_gap_title: "📊 Trenutna analiza razlike",
    strat_share: "Dijeli",
    strat_copied: "Kopirano!",
    strat_gap_score: "SEO rezultat",
    strat_gap_keywords: "Ključne riječi u TOP 100",
    strat_gap_ai_vis: "AI Vidljivost %",
    strat_you: "Vi",
    strat_competitor: "Konkurent",
    strat_advantages_title: "🔥 Vaše nepravedne prednosti",
    strat_week_label: "Tjedan",
    strat_forecast_title: "🎯 Predviđeni rezultat (30 dana)",
    strat_forecast_traffic: "Organski promet",
    strat_forecast_position: "Ciljana pozicija",
    strat_forecast_ai_vis: "AI Vidljivost",
    strat_upgrade: "Nadogradi na PRO",
  },
  uk: {
    laf_live: "ОНЛАЙН",
    laf_online: "онлайн",
    laf_from: "з",
    laf_verified: "Перевірено",
    laf_just_now: "тільки що",
    laf_seconds_ago: "{n}с тому",
    laf_minutes_ago: "{n}хв тому",
    laf_hours_ago: "{n}г тому",
    faqs_tag: "Питання та відповіді",
    faqs_title: "Питання, що часто задаються",
    faqs_subtitle: "Все, що потрібно знати перед вашим першим скануванням",
    faqs_contact: "Потрібна допомога? Напишіть нам на",
    faqs_q1: "Чим ви відрізняєтеся від SEMrush і Ahrefs?",
    faqs_a1: "SEMrush коштує від €119/місяць і відстежує тільки Google. За €49/місяць ми покриваємо Google + ChatGPT + Perplexity + Claude + Gemini — де насправді шукають у 2026 році. Плюс PulseAI Engine™ пише конкретні покрокові рекомендації для вас.",
    faqs_q2: "Перше сканування дійсно безкоштовне?",
    faqs_a2: "Так, без банківської карти. Ви отримуєте повний SEO + GEO звіт для 1 домену + 3 рекомендації AI. Просто вставте свою URL-адресу і запустіть сканування.",
    faqs_q3: "Чи потрібно мені технічно знати SEO?",
    faqs_a3: "Ні. PulseAI Engine™ пише точний покроковий план дій ('змінити заголовок на X', 'додати ключове слово Y'). Просто копіюйте та вставляйте. Ніякого програмування.",
    faqs_q4: "Як довго чекати на результати?",
    faqs_a4: "Перші покращення в рейтингу протягом 7–14 днів. Видимість AI (згадки ChatGPT / Perplexity) протягом 3–5 днів. Більшість клієнтів бачать +40% трафіку протягом 30 днів.",
    faqs_q5: "Це працює для місцевих / ЄС ринків?",
    faqs_a5: "Так, повна підтримка 26 мов, включаючи SK, CZ, PL, HU, DE. Наш LLM генерує рекомендації безпосередньо вашою мовою та враховує місцеві специфіки SEO.",
    faqs_q6: "Чи можу я скасувати в будь-який час?",
    faqs_a6: "Так, одним кліком у вашій панелі управління. Немає штрафів за скасування. 30-денна гарантія повернення коштів, якщо ви не задоволені.",
    faqs_q7: "У вас є інтеграція з WordPress / Shopify?",
    faqs_a7: "Плагін WordPress (безкоштовне завантаження) автоматично застосовує schema markup і meta теги. Додаток для Shopify з’явиться у 2 кварталі 2026 року.",
    faqs_q8: "Що, якщо конкурент просканує мій домен?",
    faqs_a8: "Сканування є публічним (будь-хто може сканувати будь-яку URL-адресу). Ваші дані, ключові слова та стратегії є приватними та зашифрованими — тільки ви маєте доступ через свій обліковий запис.",
    faqs_q9: "Яка ваша гарантія?",
    faqs_a9: "30-денна гарантія повернення коштів, жодних запитань. Не задоволені — повний виплат.",
    faqs_q10: "У вас є API?",
    faqs_a10: "Так, корпоративний план включає REST API + вебхуки для інтеграції з вашими внутрішніми інструментами, CRM або BI панелями.",
    sleep_tag: "Автоматизація 24/7",
    sleep_title_a: "Поки ви спите,",
    sleep_title_b: "PulseAI працює",
    sleep_subtitle: "Щоночі о 3:00 ваш AI асистент автоматично виконує 6 критичних завдань. Ви відкриваєте свою електронну пошту вранці — 17 нових покращень чекають на одне клікове затвердження.",
    sleep_highlight: "17 нових покращень чекають на одне клікове затвердження.",
    sleep_check_1: "Сканує 100% ваших сторінок",
    sleep_check_2: "Перевіряє 47 AI платформ (ChatGPT, Perplexity, Claude…)",
    sleep_check_3: "Генерує 5 нових рекомендацій з оптимізації",
    sleep_check_4: "Надсилає сповіщення, якщо конкурент випереджає вашу позицію",
    sleep_check_5: "Готує статтю для блогу на завтра",
    sleep_check_6: "Коригує мета-теги, де впав CTR",
    sleep_cta: "Нехай AI працює на вас →",
    sleep_overnight: "Покращення за ніч:",
    sleep_pending: "очікує на затвердження",
    course_tag: "Безкоштовно · Не потрібна кредитна картка",
    course_title_a: "7 днів до",
    course_title_b: "#1 позиції",
    course_subtitle: "Безкоштовний email-курс: 7 практичних уроків, 7 конкретних завдань, 1 БОНУС код знижки в кінці.",
    course_feature_1: "7 листів × 5 хвилин читання",
    course_feature_2: "Копіюй і вставляй дієві завдання",
    course_feature_bonus: "БОНУС:",
    course_feature_3: "Код знижки 20% за завершення",
    course_email_placeholder: "your@email.com",
    course_submit: "Надіслати →",
    course_privacy: "🔒 Жодного спаму · Відписатися за 1 клік · Сумісний з GDPR",
    course_success: "✅ Готово! Перевірте вашу електронну пошту.",
    course_code_label: "Ваш БОНУС код:",
    course_program: "7-денна програма",
    course_d1_t: "Аудит за 5 хвилин",
    course_d1_s: "Де ви справді стоїте",
    course_d2_t: "Ключові слова, які змінюють усе",
    course_d2_s: "Довгі проти коротких",
    course_d3_t: "On-page SEO без розробника",
    course_d3_s: "Заголовок, мета, H1, схема",
    course_d4_t: "Як потрапити в відповіді ChatGPT",
    course_d4_s: "Стратегія GEO покроково",
    course_d5_t: "Стратегія зворотних посилань без спаму",
    course_d5_s: "14 білих технік",
    course_d6_t: "Технічний чек-лист SEO",
    course_d6_s: "Швидкість, схема, мобільний",
    course_d7_t: "Ваш 90-дневний план",
    course_d7_s: "+ БОНУС: код знижки 20%",
    course_err_invalid: "Будь ласка, введіть дійсну електронну пошту",
    strat_nav_title: "Генератор стратегій AI",
    strat_badge: "PRO / Безкоштовна перша стратегія",
    strat_title_a: "Як",
    strat_title_b: "випередити вашого конкурента",
    strat_title_c: "за 30 днів",
    strat_subtitle: "PulseAI Engine™ генерує конкретний план дій на 4 тижні, адаптований до вашого домену та конкретного конкурента.",
    strat_label_my: "Ваш домен",
    strat_label_competitor: "Конкурент",
    strat_label_keywords: "Цільові ключові слова (необов'язково)",
    strat_placeholder_my: "вашдомен.com",
    strat_placeholder_competitor: "конкурент.com",
    strat_placeholder_keywords: "кросівки, nike, adidas...",
    strat_kw_hint: "Розділяйте комами. Макс. 6 ключових слів.",
    strat_submit: "Згенерувати стратегію на 30 днів",
    strat_loading: "AI аналізує... (~15–30с)",
    strat_err_both: "Введіть обидва домени",
    strat_err_generic: "Не вдалося згенерувати",
    strat_gap_title: "📊 Аналіз поточної прогалини",
    strat_share: "Поділитися",
    strat_copied: "Скопійовано!",
    strat_gap_score: "SEO бал",
    strat_gap_keywords: "Ключові слова в TOP 100",
    strat_gap_ai_vis: "AI Видимість %",
    strat_you: "Ви",
    strat_competitor: "Конкурент",
    strat_advantages_title: "🔥 Ваші несправедливі переваги",
    strat_week_label: "Тиждень",
    strat_forecast_title: "🎯 Прогнозований результат (30 днів)",
    strat_forecast_traffic: "Органічний трафік",
    strat_forecast_position: "Цільова позиція",
    strat_forecast_ai_vis: "AI Видимість",
    strat_upgrade: "Оновити до PRO",
  },
  tr: {
    laf_live: "CANLI",
    laf_online: "çevrimiçi",
    laf_from: "den",
    laf_verified: "Doğrulandı",
    laf_just_now: "şimdi",
    laf_seconds_ago: "{n}s önce",
    laf_minutes_ago: "{n}d önce",
    laf_hours_ago: "{n}s önce",
    faqs_tag: "SSS",
    faqs_title: "Sıkça Sorulan Sorular",
    faqs_subtitle: "İlk taramanızdan önce bilmeniz gereken her şey",
    faqs_contact: "Daha fazla mı ihtiyacınız var? Bize e-posta gönderin",
    faqs_q1: "SEMrush ve Ahrefs'den nasıl farklısınız?",
    faqs_a1: "SEMrush, aylık €119'dan başlar ve yalnızca Google'ı takip eder. Aylık €49'a Google + ChatGPT + Perplexity + Claude + Gemini'i kapsıyoruz - insanların 2026'da gerçekten arama yaptığı yerler. Ayrıca PulseAI Engine™ sizin için somut adım adım öneriler yazıyor.",
    faqs_q2: "İlk tarama gerçekten ücretsiz mi?",
    faqs_a2: "Evet, kredi kartı gerekmiyor. 1 alan adı için tamamlayıcı SEO + GEO raporu + 3 AI önerisi alıyorsunuz. URL'nizi yapıştırın ve bir tarama başlatın.",
    faqs_q3: "Teknik olarak SEO'yu bilmem gerekli mi?",
    faqs_a3: "Hayır. PulseAI Engine™ tam olarak adım adım bir eylem planı yazar ('başlığı X yap', 'anahtar kelime Y ekle'). Sadece kopyala-yapıştır. Sıfır programlama.",
    faqs_q4: "Sonuçları görmem ne kadar sürer?",
    faqs_a4: "İlk sıralama iyileştirmeleri 7–14 gün içinde. AI görünürlüğü (ChatGPT / Perplexity bahsedilmesi) 3–5 gün içinde. Çoğu müşteri 30 gün içinde %40'ın üzerinde trafik görür.",
    faqs_q5: "Yerel / AB pazarları için çalışıyor mu?",
    faqs_a5: "Evet, SK, CZ, PL, HU, DE dahil 26 dili tam destekliyoruz. LLM'imiz önerileri doğrudan dilinizde üretir ve yerel SEO spesifiklerini dikkate alır.",
    faqs_q6: "Herhangi bir zamanda iptal edebilir miyim?",
    faqs_a6: "Evet, kontrol panelinizde bir tıklama ile. İptal ücreti yok. Memnun kalmazsanız 30 günlük para iade garantisi var.",
    faqs_q7: "WordPress / Shopify entegrasyonunuz var mı?",
    faqs_a7: "WordPress eklentisi (ücretsiz indirme) otomatik olarak şema işaretlemesi ve meta etiketleri uygular. Shopify uygulaması 2026'nın 2. çeyreğinde gelecek.",
    faqs_q8: "Bir rakip alan adımı tararsa ne olur?",
    faqs_a8: "Tarama kamuya açıktır (herkes herhangi bir URL'yi tarayabilir). Verileriniz, anahtar kelimeleriniz ve stratejileriniz özel ve şifrelenmiştir - sadece hesabınız üzerinden erişim sağlayabilirsiniz.",
    faqs_q9: "Garanti nedir?",
    faqs_a9: "30 günlük para iade garantisi, soru sormadan. Memnun değil misiniz - tam geri ödeme.",
    faqs_q10: "API'niz var mı?",
    faqs_a10: "Evet, Enterprise planı REST API + iç araçlarınız, CRM veya BI panelleri ile entegrasyon için webhook'lar içerir.",
    sleep_tag: "24/7 Otomasyon",
    sleep_title_a: "Uyurken,",
    sleep_title_b: "PulseAI çalışıyor",
    sleep_subtitle: "Her gece sabah 3:00'te AI asistanınız otomatik olarak 6 kritik görevi yerine getirir. Sabah e-postanızı açtığınızda - 1 tıklama ile onay bekleyen 17 yeni iyileştirme.",
    sleep_highlight: "1 tıklama ile onay bekleyen 17 yeni iyileştirme.",
    sleep_check_1: "Sayfalarınızın %100'ünü tarar",
    sleep_check_2: "47 AI platformunu kontrol eder (ChatGPT, Perplexity, Claude…)",
    sleep_check_3: "5 yeni optimizasyon önerisi üretir",
    sleep_check_4: "Rakip pozisyonunuzu geçtiğinde bildirim gönderir",
    sleep_check_5: "Yarın için bir blog makalesi taslağı hazırlar",
    sleep_check_6: "CTR'nin düştüğü meta etiketlerini ayarlar",
    sleep_cta: "AI'nin senin için çalışmasına izin ver →",
    sleep_overnight: "Gece boyunca iyileştirmeler:",
    sleep_pending: "onay bekliyor",
    course_tag: "Ücretsiz · Kredi kartı gerektirmez",
    course_title_a: "7 günde",
    course_title_b: "#1 pozisyon",
    course_subtitle: "Ücretsiz email kursu: 7 pratik ders, 7 somut görev, sonunda 1 BONUS indirim kodu.",
    course_feature_1: "7 email × 5 dk okumayla",
    course_feature_2: "Kopyala-yapıştır yapılabilir görevler",
    course_feature_bonus: "BONUS:",
    course_feature_3: "Tamamlandığında %20 indirim kodu",
    course_email_placeholder: "senin@email.com",
    course_submit: "Gönder →",
    course_privacy: "🔒 Spam yok · 1 tıkla aboneliği iptal et · GDPR uyumlu",
    course_success: "✅ Tamamlandı! E-postanı kontrol et.",
    course_code_label: "BONUS kodun:",
    course_program: "7 günlük program",
    course_d1_t: "5 dakikada denetim",
    course_d1_s: "Gerçek durumun",
    course_d2_t: "Her şeyi değiştiren anahtar kelimeler",
    course_d2_s: "Uzun kuyruk vs. kısa kuyruk",
    course_d3_t: "Geliştirici olmadan sayfa içi SEO",
    course_d3_s: "Başlık, meta, H1, şema",
    course_d4_t: "ChatGPT cevaplarına nasıl girilir",
    course_d4_s: "GEO stratejisi adım adım",
    course_d5_t: "Spam olmadan backlink stratejisi",
    course_d5_s: "14 beyaz şapka tekniği",
    course_d6_t: "Teknik SEO kontrol listesi",
    course_d6_s: "Hız, şema, mobil",
    course_d7_t: "90 günlük planın",
    course_d7_s: "+ BONUS: %20 indirim kodu",
    course_err_invalid: "Lütfen geçerli bir e-posta girin",
    strat_nav_title: "AI Strateji Üreticisi",
    strat_badge: "PRO / İlk ücretsiz strateji",
    strat_title_a: "Nasıl",
    strat_title_b: "rakibinizi geride bırakırsınız",
    strat_title_c: "30 günde",
    strat_subtitle: "PulseAI Engine™ belirli bir rakibe göre alanınıza uygun somut bir 4 haftalık eylem planı oluşturur.",
    strat_label_my: "Alanınız",
    strat_label_competitor: "Rakip",
    strat_label_keywords: "Hedef anahtar kelimeler (isteğe bağlı)",
    strat_placeholder_my: "alanınız.com",
    strat_placeholder_competitor: "rakip.com",
    strat_placeholder_keywords: "koşu ayakkabıları, nike ayakkabıları, adidas...",
    strat_kw_hint: "Virgülle ayrılmış. Max 6 anahtar kelime.",
    strat_submit: "30 günlük strateji oluştur",
    strat_loading: "AI analiz ediliyor... (~15–30sn)",
    strat_err_both: "Her iki alanı da girin",
    strat_err_generic: "Oluşturma başarısız",
    strat_gap_title: "📊 Mevcut Boşluk Analizi",
    strat_share: "Paylaş",
    strat_copied: "Kopyalandı!",
    strat_gap_score: "SEO Skoru",
    strat_gap_keywords: "TOP 100'deki Anahtar Kelimeler",
    strat_gap_ai_vis: "AI Görünürlük %",
    strat_you: "Siz",
    strat_competitor: "Rakip",
    strat_advantages_title: "🔥 Haksız Avantajlarınız",
    strat_week_label: "Hafta",
    strat_forecast_title: "🎯 Tahmin Edilen Sonuç (30 gün)",
    strat_forecast_traffic: "Organik trafik",
    strat_forecast_position: "Hedef konum",
    strat_forecast_ai_vis: "AI Görünürlük",
    strat_upgrade: "PRO'ya Geç",
  },
  ja: {
    laf_live: "ライブ",
    laf_online: "オンライン",
    laf_from: "から",
    laf_verified: "確認済み",
    laf_just_now: "たった今",
    laf_seconds_ago: "{n}秒前",
    laf_minutes_ago: "{n}分前",
    laf_hours_ago: "{n}時間前",
    faqs_tag: "FAQ",
    faqs_title: "よくある質問",
    faqs_subtitle: "初めてのスキャン前に知っておくべきこと",
    faqs_contact: "もっと必要ですか？メールはこちら",
    faqs_q1: "SEMrushやAhrefsとはどう違いますか？",
    faqs_a1: "SEMrushは€119/月からで、Googleのみを追跡します。€49/月でGoogle + ChatGPT + Perplexity + Claude + Geminiをカバーします — 2026年に実際に人々が検索する場所です。さらに、PulseAI Engine™が具体的なステップバイステップの推奨を作成します。",
    faqs_q2: "初回スキャンは本当に無料ですか？",
    faqs_a2: "はい、クレジットカードは不要です。1つのドメインに対して完全なSEO + GEOレポートと3つのAI推奨を得られます。URLを貼り付けてスキャンを実行します。",
    faqs_q3: "SEOの技術的な知識は必要ですか？",
    faqs_a3: "いいえ。PulseAI Engine™が正確なステップバイステップのアクションプランを書きます（「タイトルをXに変更」、「キーワードYを追加」）。ただコピー&ペーストするだけで、プログラミングはゼロです。",
    faqs_q4: "結果はどれくらいで見られますか？",
    faqs_a4: "最初のランキング改善は7〜14日以内に。AIの可視性（ChatGPT / Perplexityの言及）は3〜5日以内に。ほとんどの顧客が30日以内に+40%のトラフィックを見ています。",
    faqs_q5: "ローカル/EU市場でも機能しますか？",
    faqs_a5: "はい、SK、CZ、PL、HU、DEを含む26言語の完全サポートがあります。私たちのLLMはあなたの言語で直接推奨を生成し、ローカルSEOの特性を考慮します。",
    faqs_q6: "いつでもキャンセルできますか？",
    faqs_a6: "はい、ダッシュボードでワンクリックで。キャンセル料は不要です。満足できない場合は30日間の返金保証があります。",
    faqs_q7: "WordPressやShopifyの統合はありますか？",
    faqs_a7: "WordPressプラグイン（無料ダウンロード）が自動的にスキーママークアップとメタタグを適用します。Shopifyアプリは2026年第2四半期に登場予定です。",
    faqs_q8: "競合が私のドメインをスキャンしたらどうなりますか？",
    faqs_a8: "スキャンは公開されています（誰でも任意のURLをスキャンできます）。あなたのデータ、キーワード、戦略はプライベートで暗号化されています — あなたのアカウントからのみアクセス可能です。",
    faqs_q9: "保証は何ですか？",
    faqs_a9: "30日間の返金保証があります。満足できなければ全額返金します。",
    faqs_q10: "APIはありますか？",
    faqs_a10: "はい、エンタープライズプランには内部ツール、CRM、またはBIダッシュボードとの統合のためのREST API + Webhooksが含まれています。",
    sleep_tag: "自動化24/7",
    sleep_title_a: "眠っている間に、",
    sleep_title_b: "PulseAIが動いています",
    sleep_subtitle: "毎晩3:00 AMにAIアシスタントが自動的に6つの重要なタスクを実行します。朝メールを開くと — 1クリックの承認を待つ17の新しい改善が待っています。",
    sleep_highlight: "1クリックの承認を待つ17の新しい改善。",
    sleep_check_1: "あなたのページの100%をスキャン",
    sleep_check_2: "47のAIプラットフォームをチェック（ChatGPT、Perplexity、Claude…）",
    sleep_check_3: "5つの新しい最適化推奨を生成",
    sleep_check_4: "競合があなたの順位を超えた場合にアラートを送信します",
    sleep_check_5: "明日のブログ記事をドラフトします",
    sleep_check_6: "CTRが低下したメタタグを調整します",
    sleep_cta: "AIに働いてもらいましょう →",
    sleep_overnight: "一晩の改善:",
    sleep_pending: "承認待ち",
    course_tag: "無料 · クレジットカード不要",
    course_title_a: "7日で",
    course_title_b: "1位獲得",
    course_subtitle: "無料メールコース：7つの実践的なレッスン、7つの具体的なタスク、最後にボーナス割引コードを1つ。",
    course_feature_1: "7通のメール × 5分の読書",
    course_feature_2: "コピー＆ペースト可能なタスク",
    course_feature_bonus: "ボーナス:",
    course_feature_3: "完了時の20%割引コード",
    course_email_placeholder: "your@email.com",
    course_submit: "送信 →",
    course_privacy: "🔒 スパムなし · 1クリックで解除 · GDPR準拠",
    course_success: "✅ 完了！メールを確認してください。",
    course_code_label: "あなたのボーナスコード:",
    course_program: "7日間プログラム",
    course_d1_t: "5分で監査",
    course_d1_s: "あなたの真の立ち位置",
    course_d2_t: "すべてを変えるキーワード",
    course_d2_s: "ロングテール対ショートテール",
    course_d3_t: "開発者なしのオンページSEO",
    course_d3_s: "タイトル、メタ、H1、スキーマ",
    course_d4_t: "ChatGPTの回答にどう入るか",
    course_d4_s: "GEO戦略ステップバイステップ",
    course_d5_t: "スパムなしのバックリンク戦略",
    course_d5_s: "14のホワイトハット手法",
    course_d6_t: "技術的SEOチェックリスト",
    course_d6_s: "速度、スキーマ、モバイル",
    course_d7_t: "あなたの90日プラン",
    course_d7_s: "+ ボーナス: 20%割引コード",
    course_err_invalid: "有効なメールアドレスを入力してください",
    strat_nav_title: "AI戦略ジェネレーター",
    strat_badge: "PRO / 最初の戦略は無料",
    strat_title_a: "競合を",
    strat_title_b: "上回る方法",
    strat_title_c: "30日以内に",
    strat_subtitle: "PulseAIエンジン™は、特定の競合に対してあなたのドメインに合わせた具体的な4週間のアクションプランを生成します。",
    strat_label_my: "あなたのドメイン",
    strat_label_competitor: "競合",
    strat_label_keywords: "ターゲットキーワード（オプション）",
    strat_placeholder_my: "yourdomain.com",
    strat_placeholder_competitor: "competitor.com",
    strat_placeholder_keywords: "ランニングシューズ、ナイキシューズ、アディダス…",
    strat_kw_hint: "カンマ区切り。最大6つのキーワード。",
    strat_submit: "30日間の戦略を生成",
    strat_loading: "AI分析中...（約15〜30秒）",
    strat_err_both: "両方のドメインを入力してください",
    strat_err_generic: "生成に失敗しました",
    strat_gap_title: "📊 現在のギャップ分析",
    strat_share: "共有",
    strat_copied: "コピーしました！",
    strat_gap_score: "SEOスコア",
    strat_gap_keywords: "TOP 100内のキーワード",
    strat_gap_ai_vis: "AIの可視性 %",
    strat_you: "あなた",
    strat_competitor: "競合",
    strat_advantages_title: "🔥 あなたの不公平なアドバンテージ",
    strat_week_label: "週",
    strat_forecast_title: "🎯 予測結果（30日間）",
    strat_forecast_traffic: "オーガニックトラフィック",
    strat_forecast_position: "ターゲットポジション",
    strat_forecast_ai_vis: "AIの可視性",
    strat_upgrade: "PROにアップグレード",
  },
  ko: {
    laf_live: "실시간",
    laf_online: "온라인",
    laf_from: "부터",
    laf_verified: "검증됨",
    laf_just_now: "방금",
    laf_seconds_ago: "{n}초 전",
    laf_minutes_ago: "{n}분 전",
    laf_hours_ago: "{n}시간 전",
    faqs_tag: "자주 묻는 질문",
    faqs_title: "자주 묻는 질문",
    faqs_subtitle: "첫 스캔 전에 알아야 할 모든 것",
    faqs_contact: "더 필요하신가요? 이메일 보내기:",
    faqs_q1: "SEMrush와 Ahrefs와 어떻게 다른가요?",
    faqs_a1: "SEMrush는 €119/월부터 시작하며 구글만 추적합니다. €49/월로 Google + ChatGPT + Perplexity + Claude + Gemini를 커버합니다 — 사람들이 2026년에 실제로 검색하는 곳입니다. Plus PulseAI Engine™은 단계별 구체적인 권장 사항을 작성해 드립니다.",
    faqs_q2: "첫 스캔이 정말 무료인가요?",
    faqs_a2: "네, 신용카드 필요 없습니다. 1개의 도메인에 대한 완전한 SEO + GEO 보고서와 3개의 AI 권장 사항을 받습니다. URL을 붙여넣고 스캔을 실행하세요.",
    faqs_q3: "SEO를 기술적으로 알아야 하나요?",
    faqs_a3: "아니요. PulseAI Engine™이 정확한 단계별 행동 계획을 작성합니다 ('제목을 X로 변경', 'Y 키워드 추가'). 복사해서 붙여넣기만 하면 됩니다. 프로그래밍 필요 없음.",
    faqs_q4: "결과를 언제 볼 수 있나요?",
    faqs_a4: "첫 번째 순위 개선은 7–14일 이내에 이루어집니다. AI 가시성 (ChatGPT / Perplexity 언급)은 3–5일 이내에 이루어집니다. 대부분의 고객은 30일 이내에 +40%의 트래픽을 경험합니다.",
    faqs_q5: "지역 / EU 시장에서도 작동하나요?",
    faqs_a5: "네, SK, CZ, PL, HU, DE를 포함한 26개 언어에 대한 전체 지원을 제공합니다. 우리의 LLM은 귀하의 언어로 직접 권장 사항을 생성하며 지역 SEO 특성을 고려합니다.",
    faqs_q6: "언제든지 취소할 수 있나요?",
    faqs_a6: "네, 대시보드에서 한 번의 클릭으로 가능합니다. 취소 수수료 없음. 만족하지 않으면 30일 환불 보장입니다.",
    faqs_q7: "WordPress / Shopify 통합이 있나요?",
    faqs_a7: "WordPress 플러그인 (무료 다운로드)은 스키마 마크업과 메타 태그를 자동으로 적용합니다. Shopify 앱은 2026년 2분기에 출시될 예정입니다.",
    faqs_q8: "경쟁자가 내 도메인을 스캔하면 어떻게 되나요?",
    faqs_a8: "스캔은 공개적입니다 (누구나 어떤 URL이든 스캔할 수 있습니다). 귀하의 데이터, 키워드 및 전략은 개인적이고 암호화되어 있으며 오직 귀하만 계정을 통해 접근할 수 있습니다.",
    faqs_q9: "귀하의 보장은 무엇인가요?",
    faqs_a9: "30일 환불 보장, 질문 없음. 불만족 시 전액 환불.",
    faqs_q10: "API가 있나요?",
    faqs_a10: "네, 엔터프라이즈 플랜에는 내부 도구, CRM 또는 BI 대시보드와의 통합을 위한 REST API + 웹후크가 포함되어 있습니다.",
    sleep_tag: "자동화 24/7",
    sleep_title_a: "당신이 자는 동안,",
    sleep_title_b: "PulseAI가 작동합니다",
    sleep_subtitle: "매일 밤 3:00 AM에 귀하의 AI 어시스턴트가 자동으로 6가지 중요한 작업을 실행합니다. 아침에 이메일을 열면 — 1-클릭 승인을 기다리는 17개의 새로운 개선 사항이 있습니다.",
    sleep_highlight: "1-클릭 승인을 기다리는 17개의 새로운 개선 사항.",
    sleep_check_1: "귀하의 페이지 100% 스캔",
    sleep_check_2: "47개의 AI 플랫폼 체크 (ChatGPT, Perplexity, Claude…)",
    sleep_check_3: "5개의 새로운 최적화 권장 사항 생성",
    sleep_check_4: "경쟁자가 귀하의 순위를 초과할 경우 알림을 보냅니다",
    sleep_check_5: "내일 블로그 기사를 초안 작성합니다",
    sleep_check_6: "CTR이 감소한 메타 태그를 조정합니다",
    sleep_cta: "AI에게 일을 맡기세요 →",
    sleep_overnight: "하룻밤 사이 개선 사항:",
    sleep_pending: "승인을 기다리는 중",
    course_tag: "무료 · 신용카드 필요 없음",
    course_title_a: "7일 만에",
    course_title_b: "#1 위치",
    course_subtitle: "무료 이메일 코스: 7개의 실용적인 교훈, 7개의 구체적인 작업, 마지막에 1개의 보너스 할인 코드.",
    course_feature_1: "7개의 이메일 × 5분 읽기",
    course_feature_2: "복사-붙여넣기 가능한 작업",
    course_feature_bonus: "보너스:",
    course_feature_3: "수료 시 20% 할인 코드",
    course_email_placeholder: "your@email.com",
    course_submit: "전송 →",
    course_privacy: "🔒 스팸 없음 · 1클릭 구독 취소 · GDPR 준수",
    course_success: "✅ 완료! 이메일을 확인하세요.",
    course_code_label: "귀하의 보너스 코드:",
    course_program: "7일 프로그램",
    course_d1_t: "5분 안에 감사",
    course_d1_s: "현재 위치 확인",
    course_d2_t: "모든 것을 바꾸는 키워드",
    course_d2_s: "롱테일 대 숏테일",
    course_d3_t: "개발자 없이 온페이지 SEO",
    course_d3_s: "제목, 메타, H1, 스키마",
    course_d4_t: "ChatGPT 답변에 들어가는 방법",
    course_d4_s: "GEO 전략 단계별",
    course_d5_t: "스팸 없는 백링크 전략",
    course_d5_s: "14가지 화이트햇 기법",
    course_d6_t: "기술 SEO 체크리스트",
    course_d6_s: "속도, 스키마, 모바일",
    course_d7_t: "귀하의 90일 계획",
    course_d7_s: "+ 보너스: 20% 할인 코드",
    course_err_invalid: "유효한 이메일을 입력해 주세요",
    strat_nav_title: "AI 전략 생성기",
    strat_badge: "프로 / 무료 첫 전략",
    strat_title_a: "경쟁자를",
    strat_title_b: "초과하는 방법",
    strat_title_c: "30일 안에",
    strat_subtitle: "PulseAI Engine™은 특정 경쟁자와 비교하여 귀하의 도메인에 맞춤화된 구체적인 4주 행동 계획을 생성합니다.",
    strat_label_my: "귀하의 도메인",
    strat_label_competitor: "경쟁자",
    strat_label_keywords: "목표 키워드 (선택 사항)",
    strat_placeholder_my: "yourdomain.com",
    strat_placeholder_competitor: "competitor.com",
    strat_placeholder_keywords: "러닝화, 나이키 신발, 아디다스...",
    strat_kw_hint: "쉼표로 구분. 최대 6개 키워드.",
    strat_submit: "30일 전략 생성",
    strat_loading: "AI 분석 중... (~15–30초)",
    strat_err_both: "두 도메인을 입력하세요",
    strat_err_generic: "생성 실패",
    strat_gap_title: "📊 현재 격차 분석",
    strat_share: "공유",
    strat_copied: "복사됨!",
    strat_gap_score: "SEO 점수",
    strat_gap_keywords: "TOP 100의 키워드",
    strat_gap_ai_vis: "AI 가시성 %",
    strat_you: "당신",
    strat_competitor: "경쟁자",
    strat_advantages_title: "🔥 귀하의 특별한 장점",
    strat_week_label: "주",
    strat_forecast_title: "🎯 예측 결과 (30일)",
    strat_forecast_traffic: "유기적 트래픽",
    strat_forecast_position: "목표 위치",
    strat_forecast_ai_vis: "AI 가시성",
    strat_upgrade: "PRO로 업그레이드",
  },
  zh: {
    laf_live: "实时",
    laf_online: "在线",
    laf_from: "来自",
    laf_verified: "已验证",
    laf_just_now: "刚刚",
    laf_seconds_ago: "{n}秒前",
    laf_minutes_ago: "{n}分钟前",
    laf_hours_ago: "{n}小时前",
    faqs_tag: "常见问题",
    faqs_title: "常见问题解答",
    faqs_subtitle: "首次扫描前您需要了解的一切",
    faqs_contact: "需要更多帮助？请发送电子邮件至",
    faqs_q1: "您与SEMrush和Ahrefs有什么不同？",
    faqs_a1: "SEMrush每月费用为€119，仅跟踪Google。每月€49，我们覆盖Google + ChatGPT + Perplexity + Claude + Gemini——这是人们在2026年实际搜索的地方。此外，PulseAI Engine™为您撰写具体的逐步建议。",
    faqs_q2: "第一次扫描真的免费的吗？",
    faqs_a2: "是的，无需信用卡。您将获得1个域名的完整SEO + GEO报告 + 3条AI建议。只需粘贴您的URL并运行扫描。",
    faqs_q3: "我需要了解技术SEO吗？",
    faqs_a3: "不需要。PulseAI Engine™会为您写出准确的逐步行动计划（‘将标题改为X’，‘添加关键词Y’）。只需复制粘贴。无需编程。",
    faqs_q4: "多久能看到结果？",
    faqs_a4: "7到14天内初步排名提升。AI可见性（ChatGPT / Perplexity提及）在3到5天内。大多数客户在30天内看到流量增加40%。",
    faqs_q5: "它适用于本地/欧盟市场吗？",
    faqs_a5: "是的，全面支持26种语言，包括SK、CZ、PL、HU、DE。我们的LLM直接用您的语言生成建议，并考虑本地SEO的特性。",
    faqs_q6: "我可以随时取消吗？",
    faqs_a6: "可以，在您的仪表板上点击一下即可。无取消费用。如果不满意，提供30天退款保证。",
    faqs_q7: "您有WordPress / Shopify集成吗？",
    faqs_a7: "WordPress插件（免费下载）自动应用架构标记和元标签。Shopify应用将于2026年第二季度推出。",
    faqs_q8: "如果竞争对手扫描我的域名怎么办？",
    faqs_a8: "扫描是公开的（任何人都可以扫描任何URL）。您的数据、关键词和策略是私密和加密的——只有您可以通过您的帐户访问。",
    faqs_q9: "你的保证是什么？",
    faqs_a9: "30天退款保证，无条件。如果不满意——全额退款。",
    faqs_q10: "您有API吗？",
    faqs_a10: "是的，企业计划包括REST API + webhooks，以便与您的内部工具、CRM或BI仪表板集成。",
    sleep_tag: "全天候自动化",
    sleep_title_a: "在您睡觉时，",
    sleep_title_b: "PulseAI在工作",
    sleep_subtitle: "每晚3:00 AM，您的AI助手会自动执行6个关键任务。早上查看电子邮件——17项新改进等待您一键批准。",
    sleep_highlight: "17项新改进等待您一键批准。",
    sleep_check_1: "扫描您所有页面的100%",
    sleep_check_2: "检查47个AI平台（ChatGPT，Perplexity，Claude等…）",
    sleep_check_3: "生成5条新的优化建议",
    sleep_check_4: "如果竞争对手超过您的位置，将发送警报",
    sleep_check_5: "为明天撰写博客文章",
    sleep_check_6: "调整点击率下降的元标签",
    sleep_cta: "让AI为您工作 →",
    sleep_overnight: "过夜改善：",
    sleep_pending: "等待批准",
    course_tag: "免费 · 无需信用卡",
    course_title_a: "7天内",
    course_title_b: "第一位置",
    course_subtitle: "免费邮件课程：7个实用课程、7个具体任务、1个奖励折扣码。",
    course_feature_1: "7封邮件 × 5分钟阅读",
    course_feature_2: "复制粘贴可执行任务",
    course_feature_bonus: "奖励：",
    course_feature_3: "完成后获得20%折扣码",
    course_email_placeholder: "your@email.com",
    course_submit: "发送 →",
    course_privacy: "🔒 无垃圾邮件 · 一键退订 · 符合GDPR",
    course_success: "✅ 完成！检查您的电子邮件。",
    course_code_label: "您的奖励代码：",
    course_program: "7天课程",
    course_d1_t: "5分钟内进行审计",
    course_d1_s: "您真正的状况",
    course_d2_t: "改变一切的关键词",
    course_d2_s: "长尾与短尾",
    course_d3_t: "无需开发者的页面SEO",
    course_d3_s: "标题、元、H1、架构",
    course_d4_t: "如何获取ChatGPT的回答",
    course_d4_s: "逐步GEO策略",
    course_d5_t: "无垃圾邮件的反向链接策略",
    course_d5_s: "14种白帽技术",
    course_d6_t: "技术SEO检查清单",
    course_d6_s: "速度、架构、移动",
    course_d7_t: "您的90天计划",
    course_d7_s: "+ 奖励：20%折扣码",
    course_err_invalid: "请输入有效的电子邮件",
    strat_nav_title: "AI战略生成器",
    strat_badge: "专业版 / 免费首个战略",
    strat_title_a: "如何",
    strat_title_b: "超越您的竞争对手",
    strat_title_c: "在30天内",
    strat_subtitle: "PulseAI Engine™ 生成针对您的领域与特定竞争对手的具体四周行动计划。",
    strat_label_my: "您的域名",
    strat_label_competitor: "竞争对手",
    strat_label_keywords: "目标关键词（可选）",
    strat_placeholder_my: "yourdomain.com",
    strat_placeholder_competitor: "competitor.com",
    strat_placeholder_keywords: "运动鞋，耐克鞋，阿迪达斯...",
    strat_kw_hint: "以逗号分隔。最多 6 个关键词。",
    strat_submit: "生成 30 天策略",
    strat_loading: "AI 正在分析...（约 15–30 秒）",
    strat_err_both: "请输入两个域名",
    strat_err_generic: "生成失败",
    strat_gap_title: "📊 当前差距分析",
    strat_share: "分享",
    strat_copied: "已复制！",
    strat_gap_score: "SEO 评分",
    strat_gap_keywords: "TOP 100 中的关键词",
    strat_gap_ai_vis: "AI 可见性 %",
    strat_you: "您",
    strat_competitor: "竞争对手",
    strat_advantages_title: "🔥 您的不公平优势",
    strat_week_label: "周",
    strat_forecast_title: "🎯 预测结果（30 天）",
    strat_forecast_traffic: "自然流量",
    strat_forecast_position: "目标位置",
    strat_forecast_ai_vis: "AI 可见性",
    strat_upgrade: "升级到 PRO",
  },
  hi: {
    laf_live: "जीवित",
    laf_online: "ऑनलाइन",
    laf_from: "से",
    laf_verified: "सत्यापित",
    laf_just_now: "अभी अभी",
    laf_seconds_ago: "{n}सेकंड पहले",
    laf_minutes_ago: "{n}मिनट पहले",
    laf_hours_ago: "{n}घंटे पहले",
    faqs_tag: "सामान्य प्रश्न",
    faqs_title: "बार-बार पूछे जाने वाले प्रश्न",
    faqs_subtitle: "आपके पहले स्कैन से पहले जानने के लिए सब कुछ",
    faqs_contact: "और जानकारी चाहिए? हमें ईमेल करें",
    faqs_q1: "आप SEMrush और Ahrefs से कैसे अलग हैं?",
    faqs_a1: "SEMrush की लागत €119/महीना है और केवल Google को ट्रैक करता है। €49/महीने में हम Google + ChatGPT + Perplexity + Claude + Gemini कवर करते हैं — जहाँ लोग वास्तव में 2026 में खोजते हैं। साथ ही, PulseAI Engine™ आपके लिए ठोस कदम-दर-कदम सिफारिशें लिखता है।",
    faqs_q2: "क्या पहला स्कैन वास्तव में मुफ्त है?",
    faqs_a2: "हाँ, कोई क्रेडिट कार्ड की आवश्यकता नहीं है। आपको 1 डोमेन + 3 AI सिफारिशों के लिए एक पूर्ण SEO + GEO रिपोर्ट मिलती है। बस अपना URL चिपकाएँ और एक स्कैन चलाएँ।",
    faqs_q3: "क्या मुझे तकनीकी रूप से SEO जानने की आवश्यकता है?",
    faqs_a3: "नहीं। PulseAI Engine™ एक सटीक कदम-दर-कदम कार्य योजना लिखता है ('शीर्षक को X में बदलें', 'कीवर्ड Y जोड़ें')। बस कॉपी-पेस्ट करें। शून्य प्रोग्रामिंग।",
    faqs_q4: "मैं परिणाम देखने में कितना समय लगेगा?",
    faqs_a4: "पहले रैंकिंग सुधार 7–14 दिनों के भीतर। AI दृश्यता (ChatGPT / Perplexity उल्लेख) 3–5 दिनों के भीतर। अधिकांश ग्राहक 30 दिनों के भीतर +40% ट्रैफ़िक देखते हैं।",
    faqs_q5: "क्या यह स्थानीय / यूरोपीय बाजारों के लिए काम करता है?",
    faqs_a5: "हाँ, SK, CZ, PL, HU, DE सहित 26 भाषाओं के लिए पूर्ण समर्थन। हमारा LLM सीधे आपकी भाषा में सिफारिशें उत्पन्न करता है और स्थानीय SEO विशिष्टताओं का ध्यान रखता है।",
    faqs_q6: "क्या मैं कभी भी रद्द कर सकता हूँ?",
    faqs_a6: "हाँ, आपके डैशबोर्ड में एक क्लिक। कोई रद्द करने की फीस नहीं। यदि आप संतुष्ट नहीं हैं तो 30 दिनों की मनी-बैक गारंटी।",
    faqs_q7: "क्या आपके पास WordPress / Shopify इंटीग्रेशन है?",
    faqs_a7: "WordPress प्लगइन (मुफ्त डाउनलोड) स्वचालित रूप से स्कीमा मार्कअप और मेटा टैग लागू करता है। Shopify ऐप Q2 2026 में आ रहा है।",
    faqs_q8: "अगर कोई प्रतियोगी मेरे डोमेन का स्कैन करता है तो क्या होगा?",
    faqs_a8: "स्कैनिंग सार्वजनिक है (कोई भी किसी भी URL को स्कैन कर सकता है)। आपके डेटा, कीवर्ड और रणनीतियाँ निजी और एन्क्रिप्टेड हैं - केवल आपके खाते के माध्यम से आपको पहुंच है।",
    faqs_q9: "आपकी गारंटी क्या है?",
    faqs_a9: "30 दिनों की मनी-बैक गारंटी, बिना सवाल पूछे। खुश नहीं हैं - पूर्ण धनवापसी।",
    faqs_q10: "क्या आपके पास एक API है?",
    faqs_a10: "हाँ, एंटरप्राइज प्लान में REST API + वेबहुक शामिल हैं, जो आपके आंतरिक उपकरणों, CRM, या BI डैशबोर्ड के लिए इंटीग्रेशन की सुविधा देते हैं।",
    sleep_tag: "स्वचालन 24/7",
    sleep_title_a: "जब आप सोते हैं,",
    sleep_title_b: "PulseAI काम करता है",
    sleep_subtitle: "हर रात 3:00 AM पर आपका AI सहायक स्वचालित रूप से 6 महत्वपूर्ण कार्य करता है। आप सुबह अपने ईमेल खोलते हैं - 1-क्लिक स्वीकृति के लिए 17 नई सुधारों की प्रतीक्षा।",
    sleep_highlight: "1-क्लिक स्वीकृति के लिए 17 नई सुधारों की प्रतीक्षा।",
    sleep_check_1: "आपके 100% पृष्ठों का स्कैन करता है",
    sleep_check_2: "47 AI प्लेटफार्मों (ChatGPT, Perplexity, Claude…) की जांच करता है",
    sleep_check_3: "5 नई अनुकूलन सिफारिशें उत्पन्न करता है",
    sleep_check_4: "यदि एक प्रतियोगी आपकी स्थिति को पार कर लेता है तो एक अलर्ट भेजता है",
    sleep_check_5: "कल के लिए एक ब्लॉग लेख का मसौदा तैयार करता है",
    sleep_check_6: "जहां CTR गिरा है वहां मेटा टैग समायोजित करता है",
    sleep_cta: "AI को आपके लिए काम करने दें →",
    sleep_overnight: "रातों-रात सुधार:",
    sleep_pending: "मंजूरी का इंतजार कर रहा है",
    course_tag: "मुक्त · कोई क्रेडिट कार्ड नहीं",
    course_title_a: "7 दिन में",
    course_title_b: "#1 स्थिति",
    course_subtitle: "मुक्त ईमेल कोर्स: 7 व्यावहारिक पाठ, 7 ठोस कार्य, अंत में 1 बोनस डिस्काउंट कोड।",
    course_feature_1: "7 ईमेल × 5 मिनट पढ़ने का समय",
    course_feature_2: "कॉपी-पेस्ट करने योग्य कार्य",
    course_feature_bonus: "बोनस:",
    course_feature_3: "पूर्णता पर 20% डिस्काउंट कोड",
    course_email_placeholder: "your@email.com",
    course_submit: "भेजें →",
    course_privacy: "🔒 कोई स्पैम नहीं · 1 क्लिक में अनससब्सक्राइब · GDPR-अनुकूल",
    course_success: "✅ हो गया! अपना ईमेल चेक करें।",
    course_code_label: "आपका बोनस कोड:",
    course_program: "7-दिवसीय कार्यक्रम",
    course_d1_t: "5 मिनट में ऑडिट",
    course_d1_s: "आप वास्तव में कहां खड़े हैं",
    course_d2_t: "वे कीवर्ड जो सब कुछ बदलते हैं",
    course_d2_s: "लॉन्ग-टेल बनाम शॉर्ट-टेल",
    course_d3_t: "डेवलपर के बिना ऑन-पेज SEO",
    course_d3_s: "शीर्षक, मेटा, H1, स्कीमा",
    course_d4_t: "ChatGPT उत्तरों में कैसे शामिल हों",
    course_d4_s: "GEO रणनीति चरण-दर-चरण",
    course_d5_t: "स्पैम के बिना बैकलिंक रणनीति",
    course_d5_s: "14 सफेद-हैट तकनीकें",
    course_d6_t: "तकनीकी SEO चेकलिस्ट",
    course_d6_s: "गति, स्कीमा, मोबाइल",
    course_d7_t: "आपकी 90-दिवसीय योजना",
    course_d7_s: "+ बोनस: 20% डिस्काउंट कोड",
    course_err_invalid: "कृपया एक मान्य ईमेल दर्ज करें",
    strat_nav_title: "AI रणनीति जनरेटर",
    strat_badge: "PRO / पहली रणनीति मुफ्त",
    strat_title_a: "कैसे",
    strat_title_b: "अपने प्रतियोगी को पछाड़ें",
    strat_title_c: "30 दिनों में",
    strat_subtitle: "PulseAI Engine™ आपके डोमेन और एक विशेष प्रतियोगी के खिलाफ एक ठोस 4-सप्ताह की क्रिया योजना उत्पन्न करता है।",
    strat_label_my: "आपका डोमेन",
    strat_label_competitor: "प्रतियोगी",
    strat_label_keywords: "लक्ष्य कीवर्ड (वैकल्पिक)",
    strat_placeholder_my: "yourdomain.com",
    strat_placeholder_competitor: "competitor.com",
    strat_placeholder_keywords: "रनिंग शूज़, नाइके शूज़, एडिडास...",
    strat_kw_hint: "कामा से अलग करें। अधिकतम 6 कीवर्ड।",
    strat_submit: "30-दिन की रणनीति बनाएं",
    strat_loading: "AI विश्लेषण कर रहा है... (~15–30s)",
    strat_err_both: "दोनों डोमेन दर्ज करें",
    strat_err_generic: "जनरेशन विफल",
    strat_gap_title: "📊 वर्तमान गैप विश्लेषण",
    strat_share: "भेजें",
    strat_copied: "कॉपी किया गया!",
    strat_gap_score: "SEO स्कोर",
    strat_gap_keywords: "TOP 100 में कीवर्ड",
    strat_gap_ai_vis: "AI दृश्यता %",
    strat_you: "आप",
    strat_competitor: "प्रतियोगी",
    strat_advantages_title: "🔥 आपके अनुचित लाभ",
    strat_week_label: "सप्ताह",
    strat_forecast_title: "🎯 पूर्वानुमानित परिणाम (30 दिन)",
    strat_forecast_traffic: "ऑर्गेनिक ट्रैफिक",
    strat_forecast_position: "लक्ष्य स्थिति",
    strat_forecast_ai_vis: "AI दृश्यता",
    strat_upgrade: "PRO में अपग्रेड करें",
  },
  ar: {
    laf_live: "مباشر",
    laf_online: "عبر الإنترنت",
    laf_from: "من",
    laf_verified: "تم التحقق",
    laf_just_now: "الآن",
    laf_seconds_ago: "منذ {n} ثانية",
    laf_minutes_ago: "منذ {n} دقيقة",
    laf_hours_ago: "منذ {n} ساعة",
    faqs_tag: "الأسئلة الشائعة",
    faqs_title: "الأسئلة المتكررة",
    faqs_subtitle: "كل ما تحتاج لمعرفته قبل الفحص الأول",
    faqs_contact: "تحتاج إلى المزيد؟ راسلنا عبر البريد الإلكتروني على",
    faqs_q1: "كيف تختلف عن SEMrush و Ahrefs؟",
    faqs_a1: "تكلفة SEMrush تبدأ من 119 يورو/شهر وتتبع فقط جوجل. مقابل 49 يورو/شهر، نقدم تغطية لجوجل + ChatGPT + Perplexity + Claude + Gemini — حيث يبحث الناس فعلاً في عام 2026. بالإضافة إلى ذلك، يقوم PulseAI Engine™ بكتابة توصيات خطوة بخطوة لك.",
    faqs_q2: "هل الفحص الأول مجاني حقًا؟",
    faqs_a2: "نعم، لا حاجة لبطاقة ائتمان. ستحصل على تقرير كامل عن SEO + GEO لاسم نطاق واحد + 3 توصيات من AI. فقط ألصق عنوان URL الخاص بك وابدأ الفحص.",
    faqs_q3: "هل أحتاج إلى معرفة SEO من الناحية التقنية؟",
    faqs_a3: "لا. يقوم PulseAI Engine™ بكتابة خطة عمل دقيقة خطوة بخطوة ('تغيير العنوان إلى X'، 'إضافة الكلمة الرئيسية Y'). فقط انسخ والصق. لا يتطلب برمجة.",
    faqs_q4: "كم من الوقت حتى أرى النتائج؟",
    faqs_a4: "تحسينات في الترتيب الأولى خلال 7–14 يومًا. الرؤية في الذكاء الاصطناعي (إشارات ChatGPT / Perplexity) خلال 3–5 أيام. معظم العملاء يشهدون نموًا في الحركة بنسبة +40% خلال 30 يومًا.",
    faqs_q5: "هل يعمل للأسواق المحلية / الأوروبية؟",
    faqs_a5: "نعم، دعم كامل لـ 26 لغة بما في ذلك SK و CZ و PL و HU و DE. يقوم نموذجنا الكبير بتوليد توصيات مباشرة بلغتك ويأخذ بعين الاعتبار خصوصيات SEO المحلية.",
    faqs_q6: "هل يمكنني الإلغاء في أي وقت؟",
    faqs_a6: "نعم، بنقرة واحدة في لوحتك. لا رسوم إلغاء. ضمان استرداد الأموال لمدة 30 يومًا إذا لم تكن راضيًا.",
    faqs_q7: "هل لديكم تكامل مع WordPress / Shopify؟",
    faqs_a7: "تطبيق WordPress (تنزيل مجاني) يقوم تلقائيًا بتطبيق ترميز المخطط وعلامات التعريف. تطبيق Shopify قيد الإعداد في الربع الثاني من عام 2026.",
    faqs_q8: "ماذا لو قام أحد المنافسين بفحص نطاقي؟",
    faqs_a8: "الفحص متاح للجميع (يمكن لأي شخص فحص أي عنوان URL). بياناتك وكلماتك الرئيسية واستراتيجياتك خاصة ومشفرة — فقط لديك حق الوصول عبر حسابك.",
    faqs_q9: "ما هو ضمانكم؟",
    faqs_a9: "ضمان استرداد الأموال لمدة 30 يومًا، بدون أسئلة مطروحة. إذا لم تكن راضيًا — استرداد كامل.",
    faqs_q10: "هل لديكم واجهة برمجة التطبيقات (API)؟",
    faqs_a10: "نعم، يتضمن خطة المؤسسة واجهة برمجة التطبيقات REST + webhooks للتكامل مع أدواتك الداخلية و CRM أو لوحات BI.",
    sleep_tag: "الأتمتة على مدار الساعة",
    sleep_title_a: "بينما تنام،",
    sleep_title_b: "PulseAI يعمل",
    sleep_subtitle: "كل ليلة في الساعة 3:00 صباحًا، يقوم مساعد AI الخاص بك تلقائيًا بتشغيل 6 مهام حيوية. تفتح بريدك الإلكتروني في الصباح — 17 تحسينًا جديدًا في انتظار الموافقة بنقرة واحدة.",
    sleep_highlight: "17 تحسينًا جديدًا في انتظار الموافقة بنقرة واحدة.",
    sleep_check_1: "يفحص 100% من صفحاتك",
    sleep_check_2: "يتحقق من 47 منصة ذكاء اصطناعي (ChatGPT، Perplexity، Claude…)",
    sleep_check_3: "ينتج 5 توصيات تحسين جديدة",
    sleep_check_4: "يرسل تنبيهًا إذا تجاوزك المنافس",
    sleep_check_5: "يعد مسودة مقال مدونة ليوم غدٍ",
    sleep_check_6: "يعدل علامات الميتا حيث انخفض معدل النقر",
    sleep_cta: "دع الذكاء الاصطناعي يعمل من أجلك →",
    sleep_overnight: "تحسينات خلال الليل:",
    sleep_pending: "بانتظار الموافقة",
    course_tag: "مجاني · بدون بطاقة ائتمان",
    course_title_a: "7 أيام إلى",
    course_title_b: "المركز #1",
    course_subtitle: "دورة بريد إلكتروني مجانية: 7 دروس عملية، 7 مهام ملموسة، 1 كود خصم BONUS في النهاية.",
    course_feature_1: "7 رسائل × 5 دقائق قراءة",
    course_feature_2: "مهام قابلة للتنفيذ بنسخ ولصق",
    course_feature_bonus: "BONUS:",
    course_feature_3: "كود خصم 20% عند الانتهاء",
    course_email_placeholder: "your@email.com",
    course_submit: "إرسال →",
    course_privacy: "🔒 لا spam · إلغاء الاشتراك بنقرة واحدة · متوافق مع GDPR",
    course_success: "✅ تم! تحقق من بريدك الإلكتروني.",
    course_code_label: "كود BONUS الخاص بك:",
    course_program: "برنامج مدته 7 أيام",
    course_d1_t: "تدقيق في 5 دقائق",
    course_d1_s: "أين تقف حقًا",
    course_d2_t: "الكلمات الرئيسية التي تغير كل شيء",
    course_d2_s: "طويلة الذيل مقابل قصيرة الذيل",
    course_d3_t: "تحسين محركات البحث على الصفحة بدون مطور",
    course_d3_s: "العنوان، الميتا، H1، المخطط",
    course_d4_t: "كيف تدخل في إجابات ChatGPT",
    course_d4_s: "استراتيجية GEO خطوة بخطوة",
    course_d5_t: "استراتيجية الروابط الخلفية بدون spam",
    course_d5_s: "14 تقنية مضمونة",
    course_d6_t: "قائمة مراجعة تحسين محركات البحث التقنية",
    course_d6_s: "السرعة، المخطط، المحمول",
    course_d7_t: "خطتك لمدة 90 يومًا",
    course_d7_s: "+ BONUS: كود خصم 20%",
    course_err_invalid: "يرجى إدخال بريد إلكتروني صالح",
    strat_nav_title: "مولد استراتيجيات الذكاء الاصطناعي",
    strat_badge: "PRO / الاستراتيجية الأولى مجانية",
    strat_title_a: "كيف",
    strat_title_b: "تتجاوز منافسك",
    strat_title_c: "في 30 يومًا",
    strat_subtitle: "تولّد PulseAI Engine™ خطة عمل ملموسة لمدة 4 أسابيع مصممة خصيصًا لمجالك مقابل منافس معين.",
    strat_label_my: "مجالك",
    strat_label_competitor: "المنافس",
    strat_label_keywords: "الكلمات الرئيسية المستهدفة (اختياري)",
    strat_placeholder_my: "yourdomain.com",
    strat_placeholder_competitor: "competitor.com",
    strat_placeholder_keywords: "أحذية الجري، أحذية نايك، أديداس...",
    strat_kw_hint: "تفصل بين الكلمات بفواصل. بحد أقصى 6 كلمات.",
    strat_submit: "إنشاء استراتيجية لمدة 30 يومًا",
    strat_loading: "AI يحلل... (~15–30s)",
    strat_err_both: "أدخل كلاً من المجالين",
    strat_err_generic: "فشل التوليد",
    strat_gap_title: "📊 تحليل الفجوة الحالية",
    strat_share: "مشاركة",
    strat_copied: "تم النسخ!",
    strat_gap_score: "درجة SEO",
    strat_gap_keywords: "الكلمات الرئيسية في TOP 100",
    strat_gap_ai_vis: "نسبة الظهور في الذكاء الاصطناعي %",
    strat_you: "أنت",
    strat_competitor: "المنافس",
    strat_advantages_title: "🔥 مزايائك غير العادلة",
    strat_week_label: "أسبوع",
    strat_forecast_title: "🎯 النتائج المتوقعة (30 يومًا)",
    strat_forecast_traffic: "حركة المرور العضوية",
    strat_forecast_position: "الموقع المستهدف",
    strat_forecast_ai_vis: "الظهور في الذكاء الاصطناعي",
    strat_upgrade: "ترقية إلى PRO",
  },
  id: {
    laf_live: "MENDAPAT",
    laf_online: "daring",
    laf_from: "dari",
    laf_verified: "Terverifikasi",
    laf_just_now: "baru saja",
    laf_seconds_ago: "{n} detik yang lalu",
    laf_minutes_ago: "{n} menit yang lalu",
    laf_hours_ago: "{n} jam yang lalu",
    faqs_tag: "FAQ",
    faqs_title: "Pertanyaan yang sering diajukan",
    faqs_subtitle: "Segala yang perlu Anda ketahui sebelum pemindaian pertama Anda",
    faqs_contact: "Perlu lebih banyak? Kirim email kepada kami di",
    faqs_q1: "Apa yang membedakan Anda dari SEMrush dan Ahrefs?",
    faqs_a1: "SEMrush biaya mulai dari €119/bulan dan hanya melacak Google. Dengan €49/bulan, kami mencakup Google + ChatGPT + Perplexity + Claude + Gemini — tempat orang benar-benar mencari di tahun 2026. Plus, PulseAI Engine™ menyusun rekomendasi langkah-demi-langkah yang konkret untuk Anda.",
    faqs_q2: "Apakah pemindaian pertama benar-benar gratis?",
    faqs_a2: "Ya, tidak perlu kartu kredit. Anda mendapatkan laporan SEO + GEO lengkap untuk 1 domain + 3 rekomendasi AI. Cukup tempel URL Anda dan jalankan pemindaian.",
    faqs_q3: "Apakah saya perlu tahu SEO secara teknis?",
    faqs_a3: "Tidak. PulseAI Engine™ menulis rencana aksi langkah-demi-langkah yang tepat ('ubah judul menjadi X', 'tambahkan kata kunci Y'). Cukup salin-tempel. Tanpa pemrograman.",
    faqs_q4: "Berapa lama sampai saya melihat hasil?",
    faqs_a4: "Peningkatan peringkat pertama dalam 7–14 hari. Visibilitas AI (sebutan ChatGPT / Perplexity) dalam 3–5 hari. Sebagian besar pelanggan melihat peningkatan lalu lintas +40% dalam 30 hari.",
    faqs_q5: "Apakah ini bekerja untuk pasar lokal / UE?",
    faqs_a5: "Ya, dukungan penuh untuk 26 bahasa termasuk SK, CZ, PL, HU, DE. LLM kami menghasilkan rekomendasi langsung dalam bahasa Anda dan memperhitungkan spesifik SEO lokal.",
    faqs_q6: "Bisakah saya membatalkannya kapan saja?",
    faqs_a6: "Ya, satu klik di dasbor Anda. Tidak ada biaya pembatalan. Jaminan uang kembali 30 hari jika Anda tidak puas.",
    faqs_q7: "Apakah Anda memiliki integrasi WordPress / Shopify?",
    faqs_a7: "Plugin WordPress (unduhan gratis) secara otomatis menerapkan skema markup dan meta tag. Aplikasi Shopify akan datang Q2 2026.",
    faqs_q8: "Apa yang terjadi jika pesaing memindai domain saya?",
    faqs_a8: "Pemindaian bersifat publik (siapa pun dapat memindai URL mana pun). Data, kata kunci, dan strategi Anda bersifat pribadi dan dienkripsi — hanya Anda yang memiliki akses melalui akun Anda.",
    faqs_q9: "Apa jaminan Anda?",
    faqs_a9: "Jaminan uang kembali 30 hari, tanpa ditanya. Tidak puas — pengembalian penuh.",
    faqs_q10: "Apakah Anda memiliki API?",
    faqs_a10: "Ya, paket Enterprise mencakup REST API + webhook untuk integrasi dengan alat internal Anda, CRM, atau dasbor BI.",
    sleep_tag: "Automatisasi 24/7",
    sleep_title_a: "Sementara Anda tidur,",
    sleep_title_b: "PulseAI bekerja",
    sleep_subtitle: "Setiap malam pukul 3:00 AM, asisten AI Anda secara otomatis menjalankan 6 tugas kritis. Anda membuka email Anda di pagi hari — 17 perbaikan baru menunggu persetujuan 1-klik.",
    sleep_highlight: "17 perbaikan baru menunggu persetujuan 1-klik.",
    sleep_check_1: "Memindai 100% halaman Anda",
    sleep_check_2: "Memeriksa 47 platform AI (ChatGPT, Perplexity, Claude…)",
    sleep_check_3: "Menghasilkan 5 rekomendasi optimasi baru",
    sleep_check_4: "Mengirimkan pemberitahuan jika pesaing mengalahkan posisi Anda",
    sleep_check_5: "Menyiapkan artikel blog untuk besok",
    sleep_check_6: "Mengubah meta tag di mana CTR menurun",
    sleep_cta: "Biarkan AI bekerja untuk Anda →",
    sleep_overnight: "Perbaikan semalaman:",
    sleep_pending: "menunggu persetujuan",
    course_tag: "Gratis · Tanpa kartu kredit",
    course_title_a: "7 hari untuk",
    course_title_b: "posisi #1",
    course_subtitle: "Kursus email gratis: 7 pelajaran praktis, 7 tugas konkrit, 1 kode diskon BONUS di akhir.",
    course_feature_1: "7 email × 5 menit membaca",
    course_feature_2: "Tugas yang dapat disalin-tempel",
    course_feature_bonus: "BONUS:",
    course_feature_3: "Kode diskon 20% setelah menyelesaikan",
    course_email_placeholder: "emailanda@email.com",
    course_submit: "Kirim →",
    course_privacy: "🔒 Tidak ada spam · Berhenti berlangganan 1 klik · Ramah GDPR",
    course_success: "✅ Selesai! Periksa email Anda.",
    course_code_label: "Kode BONUS Anda:",
    course_program: "Program 7 hari",
    course_d1_t: "Audit dalam 5 menit",
    course_d1_s: "Di mana posisi Anda sebenarnya",
    course_d2_t: "Kata kunci yang mengubah segalanya",
    course_d2_s: "Long-tail vs. short-tail",
    course_d3_t: "SEO on-page tanpa pengembang",
    course_d3_s: "Judul, meta, H1, skema",
    course_d4_t: "Cara masuk ke jawaban ChatGPT",
    course_d4_s: "Strategi GEO langkah demi langkah",
    course_d5_t: "Strategi backlink tanpa spam",
    course_d5_s: "14 teknik white-hat",
    course_d6_t: "Daftar periksa SEO teknis",
    course_d6_s: "Kecepatan, skema, mobile",
    course_d7_t: "Rencana 90-hari Anda",
    course_d7_s: "+ BONUS: kode diskon 20%",
    course_err_invalid: "Silakan masukkan email yang valid",
    strat_nav_title: "Generator Strategi AI",
    strat_badge: "PRO / Strategi pertama gratis",
    strat_title_a: "Cara",
    strat_title_b: "mengalahkan pesaing Anda",
    strat_title_c: "dalam 30 hari",
    strat_subtitle: "PulseAI Engine™ menghasilkan rencana tindakan konkret 4 minggu yang disesuaikan untuk domain Anda vs. pesaing tertentu.",
    strat_label_my: "Domain Anda",
    strat_label_competitor: "Pesaing",
    strat_label_keywords: "Kata kunci target (opsional)",
    strat_placeholder_my: "yourdomain.com",
    strat_placeholder_competitor: "competitor.com",
    strat_placeholder_keywords: "sepatu lari, sepatu nike, sepatu adidas...",
    strat_kw_hint: "Dipisahkan dengan koma. Maks 6 kata kunci.",
    strat_submit: "Buat strategi 30-hari",
    strat_loading: "AI menganalisis... (~15–30s)",
    strat_err_both: "Masukkan kedua domain",
    strat_err_generic: "Pembuatan gagal",
    strat_gap_title: "📊 Analisis Gap Saat Ini",
    strat_share: "Bagikan",
    strat_copied: "Disalin!",
    strat_gap_score: "Skor SEO",
    strat_gap_keywords: "Kata kunci di TOP 100",
    strat_gap_ai_vis: "Visibilitas AI %",
    strat_you: "Anda",
    strat_competitor: "Pesaing",
    strat_advantages_title: "🔥 Keuntungan tidak adil Anda",
    strat_week_label: "Minggu",
    strat_forecast_title: "🎯 Hasil yang Diperkirakan (30 hari)",
    strat_forecast_traffic: "Lalu lintas organik",
    strat_forecast_position: "Posisi target",
    strat_forecast_ai_vis: "Visibilitas AI",
    strat_upgrade: "Tingkatkan ke PRO",
  },
};
